(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var assign        = require('es5-ext/object/assign')
  , normalizeOpts = require('es5-ext/object/normalize-options')
  , isCallable    = require('es5-ext/object/is-callable')
  , contains      = require('es5-ext/string/#/contains')

  , d;

d = module.exports = function (dscr, value/*, options*/) {
	var c, e, w, options, desc;
	if ((arguments.length < 2) || (typeof dscr !== 'string')) {
		options = value;
		value = dscr;
		dscr = null;
	} else {
		options = arguments[2];
	}
	if (dscr == null) {
		c = w = true;
		e = false;
	} else {
		c = contains.call(dscr, 'c');
		e = contains.call(dscr, 'e');
		w = contains.call(dscr, 'w');
	}

	desc = { value: value, configurable: c, enumerable: e, writable: w };
	return !options ? desc : assign(normalizeOpts(options), desc);
};

d.gs = function (dscr, get, set/*, options*/) {
	var c, e, options, desc;
	if (typeof dscr !== 'string') {
		options = set;
		set = get;
		get = dscr;
		dscr = null;
	} else {
		options = arguments[3];
	}
	if (get == null) {
		get = undefined;
	} else if (!isCallable(get)) {
		options = get;
		get = set = undefined;
	} else if (set == null) {
		set = undefined;
	} else if (!isCallable(set)) {
		options = set;
		set = undefined;
	}
	if (dscr == null) {
		c = true;
		e = false;
	} else {
		c = contains.call(dscr, 'c');
		e = contains.call(dscr, 'e');
	}

	desc = { get: get, set: set, configurable: c, enumerable: e };
	return !options ? desc : assign(normalizeOpts(options), desc);
};

},{"es5-ext/object/assign":2,"es5-ext/object/is-callable":5,"es5-ext/object/normalize-options":9,"es5-ext/string/#/contains":11}],2:[function(require,module,exports){
'use strict';

module.exports = require('./is-implemented')()
	? Object.assign
	: require('./shim');

},{"./is-implemented":3,"./shim":4}],3:[function(require,module,exports){
'use strict';

module.exports = function () {
	var assign = Object.assign, obj;
	if (typeof assign !== 'function') return false;
	obj = { foo: 'raz' };
	assign(obj, { bar: 'dwa' }, { trzy: 'trzy' });
	return (obj.foo + obj.bar + obj.trzy) === 'razdwatrzy';
};

},{}],4:[function(require,module,exports){
'use strict';

var keys  = require('../keys')
  , value = require('../valid-value')

  , max = Math.max;

module.exports = function (dest, src/*, …srcn*/) {
	var error, i, l = max(arguments.length, 2), assign;
	dest = Object(value(dest));
	assign = function (key) {
		try { dest[key] = src[key]; } catch (e) {
			if (!error) error = e;
		}
	};
	for (i = 1; i < l; ++i) {
		src = arguments[i];
		keys(src).forEach(assign);
	}
	if (error !== undefined) throw error;
	return dest;
};

},{"../keys":6,"../valid-value":10}],5:[function(require,module,exports){
// Deprecated

'use strict';

module.exports = function (obj) { return typeof obj === 'function'; };

},{}],6:[function(require,module,exports){
'use strict';

module.exports = require('./is-implemented')()
	? Object.keys
	: require('./shim');

},{"./is-implemented":7,"./shim":8}],7:[function(require,module,exports){
'use strict';

module.exports = function () {
	try {
		Object.keys('primitive');
		return true;
	} catch (e) { return false; }
};

},{}],8:[function(require,module,exports){
'use strict';

var keys = Object.keys;

module.exports = function (object) {
	return keys(object == null ? object : Object(object));
};

},{}],9:[function(require,module,exports){
'use strict';

var forEach = Array.prototype.forEach, create = Object.create;

var process = function (src, obj) {
	var key;
	for (key in src) obj[key] = src[key];
};

module.exports = function (options/*, …options*/) {
	var result = create(null);
	forEach.call(arguments, function (options) {
		if (options == null) return;
		process(Object(options), result);
	});
	return result;
};

},{}],10:[function(require,module,exports){
'use strict';

module.exports = function (value) {
	if (value == null) throw new TypeError("Cannot use null or undefined");
	return value;
};

},{}],11:[function(require,module,exports){
'use strict';

module.exports = require('./is-implemented')()
	? String.prototype.contains
	: require('./shim');

},{"./is-implemented":12,"./shim":13}],12:[function(require,module,exports){
'use strict';

var str = 'razdwatrzy';

module.exports = function () {
	if (typeof str.contains !== 'function') return false;
	return ((str.contains('dwa') === true) && (str.contains('foo') === false));
};

},{}],13:[function(require,module,exports){
'use strict';

var indexOf = String.prototype.indexOf;

module.exports = function (searchString/*, position*/) {
	return indexOf.call(this, searchString, arguments[1]) > -1;
};

},{}],14:[function(require,module,exports){
'use strict';

module.exports = function (x) {
	if (!x) return false;
	if (typeof x === 'symbol') return true;
	if (!x.constructor) return false;
	if (x.constructor.name !== 'Symbol') return false;
	return (x[x.constructor.toStringTag] === 'Symbol');
};

},{}],15:[function(require,module,exports){
// ES2015 Symbol polyfill for environments that do not support it (or partially support it)

'use strict';

var d              = require('d')
  , validateSymbol = require('./validate-symbol')

  , create = Object.create, defineProperties = Object.defineProperties
  , defineProperty = Object.defineProperty, objPrototype = Object.prototype
  , NativeSymbol, SymbolPolyfill, HiddenSymbol, globalSymbols = create(null)
  , isNativeSafe;

if (typeof Symbol === 'function') {
	NativeSymbol = Symbol;
	try {
		String(NativeSymbol());
		isNativeSafe = true;
	} catch (ignore) {}
}

var generateName = (function () {
	var created = create(null);
	return function (desc) {
		var postfix = 0, name, ie11BugWorkaround;
		while (created[desc + (postfix || '')]) ++postfix;
		desc += (postfix || '');
		created[desc] = true;
		name = '@@' + desc;
		defineProperty(objPrototype, name, d.gs(null, function (value) {
			// For IE11 issue see:
			// https://connect.microsoft.com/IE/feedbackdetail/view/1928508/
			//    ie11-broken-getters-on-dom-objects
			// https://github.com/medikoo/es6-symbol/issues/12
			if (ie11BugWorkaround) return;
			ie11BugWorkaround = true;
			defineProperty(this, name, d(value));
			ie11BugWorkaround = false;
		}));
		return name;
	};
}());

// Internal constructor (not one exposed) for creating Symbol instances.
// This one is used to ensure that `someSymbol instanceof Symbol` always return false
HiddenSymbol = function Symbol(description) {
	if (this instanceof HiddenSymbol) throw new TypeError('TypeError: Symbol is not a constructor');
	return SymbolPolyfill(description);
};

// Exposed `Symbol` constructor
// (returns instances of HiddenSymbol)
module.exports = SymbolPolyfill = function Symbol(description) {
	var symbol;
	if (this instanceof Symbol) throw new TypeError('TypeError: Symbol is not a constructor');
	if (isNativeSafe) return NativeSymbol(description);
	symbol = create(HiddenSymbol.prototype);
	description = (description === undefined ? '' : String(description));
	return defineProperties(symbol, {
		__description__: d('', description),
		__name__: d('', generateName(description))
	});
};
defineProperties(SymbolPolyfill, {
	for: d(function (key) {
		if (globalSymbols[key]) return globalSymbols[key];
		return (globalSymbols[key] = SymbolPolyfill(String(key)));
	}),
	keyFor: d(function (s) {
		var key;
		validateSymbol(s);
		for (key in globalSymbols) if (globalSymbols[key] === s) return key;
	}),

	// If there's native implementation of given symbol, let's fallback to it
	// to ensure proper interoperability with other native functions e.g. Array.from
	hasInstance: d('', (NativeSymbol && NativeSymbol.hasInstance) || SymbolPolyfill('hasInstance')),
	isConcatSpreadable: d('', (NativeSymbol && NativeSymbol.isConcatSpreadable) ||
		SymbolPolyfill('isConcatSpreadable')),
	iterator: d('', (NativeSymbol && NativeSymbol.iterator) || SymbolPolyfill('iterator')),
	match: d('', (NativeSymbol && NativeSymbol.match) || SymbolPolyfill('match')),
	replace: d('', (NativeSymbol && NativeSymbol.replace) || SymbolPolyfill('replace')),
	search: d('', (NativeSymbol && NativeSymbol.search) || SymbolPolyfill('search')),
	species: d('', (NativeSymbol && NativeSymbol.species) || SymbolPolyfill('species')),
	split: d('', (NativeSymbol && NativeSymbol.split) || SymbolPolyfill('split')),
	toPrimitive: d('', (NativeSymbol && NativeSymbol.toPrimitive) || SymbolPolyfill('toPrimitive')),
	toStringTag: d('', (NativeSymbol && NativeSymbol.toStringTag) || SymbolPolyfill('toStringTag')),
	unscopables: d('', (NativeSymbol && NativeSymbol.unscopables) || SymbolPolyfill('unscopables'))
});

// Internal tweaks for real symbol producer
defineProperties(HiddenSymbol.prototype, {
	constructor: d(SymbolPolyfill),
	toString: d('', function () { return this.__name__; })
});

// Proper implementation of methods exposed on Symbol.prototype
// They won't be accessible on produced symbol instances as they derive from HiddenSymbol.prototype
defineProperties(SymbolPolyfill.prototype, {
	toString: d(function () { return 'Symbol (' + validateSymbol(this).__description__ + ')'; }),
	valueOf: d(function () { return validateSymbol(this); })
});
defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toPrimitive, d('', function () {
	var symbol = validateSymbol(this);
	if (typeof symbol === 'symbol') return symbol;
	return symbol.toString();
}));
defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toStringTag, d('c', 'Symbol'));

// Proper implementaton of toPrimitive and toStringTag for returned symbol instances
defineProperty(HiddenSymbol.prototype, SymbolPolyfill.toStringTag,
	d('c', SymbolPolyfill.prototype[SymbolPolyfill.toStringTag]));

// Note: It's important to define `toPrimitive` as last one, as some implementations
// implement `toPrimitive` natively without implementing `toStringTag` (or other specified symbols)
// And that may invoke error in definition flow:
// See: https://github.com/medikoo/es6-symbol/issues/13#issuecomment-164146149
defineProperty(HiddenSymbol.prototype, SymbolPolyfill.toPrimitive,
	d('c', SymbolPolyfill.prototype[SymbolPolyfill.toPrimitive]));

},{"./validate-symbol":16,"d":1}],16:[function(require,module,exports){
'use strict';

var isSymbol = require('./is-symbol');

module.exports = function (value) {
	if (!isSymbol(value)) throw new TypeError(value + " is not a symbol");
	return value;
};

},{"./is-symbol":14}],17:[function(require,module,exports){
'use strict';

var _WebViewer = require('./coi/WebViewer');

var _WebViewer2 = _interopRequireDefault(_WebViewer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.Symbol = require('es6-symbol/polyfill.js');

// Main
$(function () {

	var args = window["startupArgs"];
	if (args == null) {
		args = [];

		var startIndex = window.location.href.indexOf('?') + 1;
		var stopIndex = window.location.href.indexOf('#');

		if (stopIndex == -1) stopIndex = window.location.href.length;

		var queryString = window.location.href.slice(startIndex, stopIndex);
		var pairs = queryString.split('&');
		for (var i = 0; i < pairs.length; i++) {
			var res = pairs[i].split('=');
			var key = res[0];
			var value = res[1];

			args[key] = value;
		}
	}

	// ==========

	var viewer = new _WebViewer2.default(args);
	viewer.run();
});

},{"./coi/WebViewer":18,"es6-symbol/polyfill.js":15}],18:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _App2 = require('./core/App');

var _App3 = _interopRequireDefault(_App2);

var _CDSLoader = require('./loader/CDSLoader');

var _CDSLoader2 = _interopRequireDefault(_CDSLoader);

var _LibraryLoader = require('./loader/LibraryLoader');

var _LibraryLoader2 = _interopRequireDefault(_LibraryLoader);

var _LibraryController = require('./controllers/LibraryController');

var _LibraryController2 = _interopRequireDefault(_LibraryController);

var _InteractiveCatalogController = require('./controllers/InteractiveCatalogController');

var _InteractiveCatalogController2 = _interopRequireDefault(_InteractiveCatalogController);

var _BrowserUtils = require('./util/BrowserUtils');

var _BrowserUtils2 = _interopRequireDefault(_BrowserUtils);

var _URLUtils = require('./util/URLUtils');

var _URLUtils2 = _interopRequireDefault(_URLUtils);

var _CDSFilter = require('./util/CDSFilter');

var _CDSFilter2 = _interopRequireDefault(_CDSFilter);

var _LibraryCatalogFilter = require('./util/LibraryCatalogFilter');

var _LibraryCatalogFilter2 = _interopRequireDefault(_LibraryCatalogFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WebViewer = function (_App) {
    _inherits(WebViewer, _App);

    function WebViewer(args) {
        _classCallCheck(this, WebViewer);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(WebViewer).call(this));

        _this.currentViewerVersion = '0.7.9';
        _this.currentDeviceType = 'WEB';
        _this.currentOrientation = 'HORIZONTAL';

        _this.userLanguageList = _BrowserUtils2.default.getUserLanguages();
        _this.viewerLanguageList = ['en', 'es', 'zh'];
        _this.deviceLanguageList = undefined;
        _this.defaultLanguage = 'en';
        _this.currentDeviceLanguage = undefined;

        _this.baseUrl = args['baseUrl'] ? args['baseUrl'] : '/export/';
        if (_this.baseUrl.charAt(_this.baseUrl.length - 1) != '/') _this.baseUrl += '/';

        _this.libraryId = args['libraryId'] ? args['libraryId'] : 'testintelligentfolders';
        _this.cds = args['cds'] ? args['cds'] == "true" || args['cds'] == true : false;
        _this.catalogId = args['catalogId'] ? args['catalogId'] : args['catalog'] ? args['catalog'] : undefined;

        _this.library = null;
        _this.visualTemplate = null;
        _this.cdsConfig = null;

        _this.viewStack = [];

        _this.bannerSliderOptions = {};

        _this.polyglot = new Polyglot();

        // Register controllers
        _this.registerController('LibraryController', new _LibraryController2.default());
        _this.registerController('InteractiveCatalogController', new _InteractiveCatalogController2.default());

        _this.initializePolyfills();

        // Events
        $(window).resize(_this.onResize.bind(_this));
        return _this;
    }

    _createClass(WebViewer, [{
        key: 'run',
        value: function run() {
            var _this2 = this;

            this.printHeader();

            // Favicon
            $("link[rel*='icon']").attr("href", _URLUtils2.default.getURL(this.baseUrl + "img/favicon.png"));

            // Comprobar si el navegador está soportado
            if (!this.isSupportedBrowser()) {
                $('#COIWebViewer').empty();

                var d = $('<div>', {
                    title: 'Error',
                    html: '<p><span class="ui-icon ui-icon-alert" style="float:left; margin:0 7px 50px 0;"></span> El navegador no está soportado.</p>'
                }).dialog({
                    modal: true,
                    closeOnEscape: false,
                    open: function open(event, ui) {
                        $(".ui-dialog-titlebar-close", ui.dialog | ui).hide();
                    }
                });
            }

            this.currentDeviceLanguage = this.chooseLanguage(this.userLanguageList, this.viewerLanguageList, this.defaultLanguage);
            this.loadMessages().done(function () {
                // Comprobar si la aplicación está ejecutandose como fichero local
                if (!window.location.protocol.includes('http')) {
                    $('#COIWebViewer').empty();

                    var d = $('<div>', {
                        title: 'Error',
                        html: '<p><span class="ui-icon ui-icon-alert" style="float:left; margin:0 7px 50px 0;"></span> La aplicación no está ejecutandose desde un servidor.</p>'
                    }).dialog({
                        modal: true,
                        closeOnEscape: false,
                        open: function open(event, ui) {
                            $(".ui-dialog-titlebar-close", ui.dialog | ui).hide();
                        }
                    });
                } else if (_this2.cds) {
                    _this2.loadCDSConfig().done(function () {

                        var cdsUsername = localStorage[_this2.libraryId + '.cdsUsername'];
                        var cdsPassword = localStorage[_this2.libraryId + '.cdsPassword'];
                        if (cdsUsername && cdsUsername.length > 0) {
                            _this2.login(cdsUsername, cdsPassword, true, false).done(function () {
                                _this2.tryToLoadCatalogOfArgs();
                            });
                        } else {
                            _this2.login().done(function () {
                                _this2.tryToLoadCatalogOfArgs();
                            });
                        }
                    });
                } else {
                    _this2.loadLibrary().done(function () {
                        _this2.getController('LibraryController').loadLibrary({
                            'library': _this2.library
                        });
                        _this2.tryToLoadCatalogOfArgs();
                    });
                }
            });
        }
    }, {
        key: 'loadLibrary',
        value: function loadLibrary() {
            var _this3 = this;

            var libraryPath = this.baseUrl + this.libraryId + "-library.xml";
            var libraryURL = _URLUtils2.default.getURL(libraryPath);
            var libraryLoader = new _LibraryLoader2.default();

            var deferred = new $.Deferred();

            libraryLoader.load(libraryURL).done(function (library) {
                _this3.library = library;
                _this3.visualTemplate = library.visualTemplate;
                _this3.deviceLanguageList = library.deviceLanguageList.length > 0 ? library.deviceLanguageList : _this3.viewerLanguageList;
                _this3.defaultLanguage = library.defaultLanguage ? library.defaultLanguage : _this3.defaultLanguage;
                _this3.currentDeviceLanguage = _this3.chooseLanguage(_this3.userLanguageList, _this3.deviceLanguageList, _this3.defaultLanguage);
                _this3.loadMessages().done(function () {
                    deferred.resolve();
                });
            }).fail(deferred.reject);

            return deferred;
        }
    }, {
        key: 'loadCDSConfig',
        value: function loadCDSConfig() {
            var _this4 = this;

            var cdsConfigPath = this.baseUrl + this.libraryId + "-cds-config.xml";
            var cdsConfigURL = _URLUtils2.default.getURL(cdsConfigPath);
            var cdsLoader = new _CDSLoader2.default();

            var deferred = new $.Deferred();

            cdsLoader.loadCDSConfig(cdsConfigURL).done(function (cdsConfig) {
                _this4.cdsConfig = cdsConfig;
                deferred.resolve();
            }).fail(deferred.resolve);

            return deferred;
        }
    }, {
        key: 'login',
        value: function login(username, password) {
            var _this5 = this;

            var remember = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
            var encryptPassword = arguments.length <= 3 || arguments[3] === undefined ? true : arguments[3];

            var cdsLoader = new _CDSLoader2.default();

            var deferred = new $.Deferred();

            this.cdsConfig.cdsUsername = username ? username : '';
            this.cdsConfig.cdsPassword = password ? encryptPassword ? CryptoJS.MD5(password) : password : '';

            if (this.cdsConfig.cdsUsername.length == 0 && this.cdsConfig.cdsPassword.length == 0 && !this.cdsConfig.cdsUseDefaultUsername) {
                (function () {

                    $('#COIWebViewer').empty();

                    var textUsername = _this5.polyglot.t("Username");
                    var textPassword = _this5.polyglot.t("Password");
                    var textRemember = _this5.polyglot.t("Remember");
                    var textLogin = _this5.polyglot.t("Login");

                    $('#loginDialog').remove();

                    var loginClicked = false;
                    var d = $('<div>', {
                        id: 'loginDialog',
                        title: textLogin,
                        html: '<label for="login_username">' + textUsername + ':</label><br/><input type="text" id="login_username"/><br/>' + '<label for="login_password">' + textPassword + ':</label><br/><input type="password" id="login_password"/><br/>' + '<input type="checkbox" id="login_remember"><label for="login_remember" style="margin-left:5px;">' + textRemember + '</label>',
                        keypress: function keypress(e) {
                            if (e.keyCode == $.ui.keyCode.ENTER) {
                                $('#loginButton').trigger("click");
                            }
                        }
                    }).dialog({
                        modal: true,
                        close: function close() {
                            if (!loginClicked) _this5.run();
                        },
                        buttons: [{
                            id: 'loginButton',
                            text: textLogin,
                            click: function click() {
                                loginClicked = true;
                                var username = d.children('#login_username').val();
                                var password = d.children('#login_password').val();
                                var remember = d.children('#login_remember').is(':checked');
                                $('#loginDialog').dialog("close");
                                _this5.login(username, password, remember);
                            }
                        }]
                    });
                })();
            } else {

                cdsLoader.loadCDSResponse(this.cdsConfig).done(function (cdsResponse) {
                    if (cdsResponse.code == "OK") {

                        if (remember) {
                            localStorage[_this5.libraryId + '.cdsUsername'] = _this5.cdsConfig.cdsUsername;
                            localStorage[_this5.libraryId + '.cdsPassword'] = _this5.cdsConfig.cdsPassword;
                        }

                        _this5.loadLibrary().done(function () {
                            _CDSFilter2.default.filterLibrary(_this5.library, cdsResponse.publications);

                            _this5.getController('LibraryController').loadLibrary({
                                'library': _this5.library
                            });

                            deferred.resolve();
                        });
                    } else {
                        (function () {
                            var textError = _this5.polyglot.t("Error");
                            var textOK = _this5.polyglot.t("OK");

                            var d = $('<div>', {
                                title: textError,
                                html: '<p><span class="ui-icon ui-icon-alert" style="float:left; margin:0 7px 50px 0;"></span>' + cdsResponse.message + '</p>'
                            }).dialog({
                                modal: true,
                                close: _this5.run.bind(_this5),
                                buttons: [{
                                    text: textOK,
                                    click: function click() {
                                        d.dialog("close");
                                    }
                                }]
                            });
                            deferred.resolve();
                        })();
                    }
                }).fail(function () {
                    var textError = _this5.polyglot.t("Error");
                    var textOK = _this5.polyglot.t("OK");

                    var d = $('<div>', {
                        title: textError,
                        html: '<p><span class="ui-icon ui-icon-alert" style="float:left; margin:0 7px 50px 0;"></span>No se ha podido conectar con el servidor.</p>'
                    }).dialog({
                        modal: true,
                        close: _this5.run.bind(_this5),
                        buttons: [{
                            text: textOK,
                            click: function click() {
                                d.dialog("close");
                            }
                        }]
                    });
                    deferred.reject();
                });
            }

            return deferred;
        }
    }, {
        key: 'logout',
        value: function logout() {
            localStorage[this.libraryId + '.cdsUsername'] = '';
            localStorage[this.libraryId + '.cdsPassword'] = '';
            this.login();
        }
    }, {
        key: 'renderView',
        value: function renderView(view, model) {
            _get(Object.getPrototypeOf(WebViewer.prototype), 'renderView', this).call(this, view, model);
            this.viewStack.push([view, model]);
            this.render();
        }
    }, {
        key: 'goBack',
        value: function goBack() {
            var numViews = this.viewStack.length;
            if (numViews > 1) {
                this.viewStack.pop();
                this.render();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            $('#COIWebViewer').empty();
            var numViews = this.viewStack.length;
            if (numViews > 0) {
                var currentView = this.viewStack[numViews - 1][0];
                var currentModel = this.viewStack[numViews - 1][1];
                currentView.createView(currentModel, $('#COIWebViewer')).appendTo('#COIWebViewer');
                currentView.onRendered();
            }
            // Slider
            $('#slides').slidesjs(this.bannerSliderOptions);
        }
    }, {
        key: 'chooseLanguage',
        value: function chooseLanguage(preferredLanguages, availableLanguages, fallbackLanguage) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = preferredLanguages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var lang = _step.value;

                    if ($.inArray(lang, availableLanguages) >= 0) {
                        return lang;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return fallbackLanguage;
        }
    }, {
        key: 'changeCurrentLanguage',
        value: function changeCurrentLanguage(lang) {
            var _this6 = this;

            this.currentDeviceLanguage = lang;
            this.loadMessages().done(function () {
                _this6.getController('LibraryController').loadLibrary({ 'library': _this6.library });
            });
        }
    }, {
        key: 'loadMessages',
        value: function loadMessages() {
            var _this7 = this;

            var deferred = new $.Deferred();

            var messagesJsonPath = 'resources/messages.' + this.currentDeviceLanguage + '.json';
            var messagesJsonURL = _URLUtils2.default.getURL(messagesJsonPath);
            $.getJSON(messagesJsonURL).done(function (json) {
                _this7.polyglot = new Polyglot();
                _this7.polyglot.locale(_this7.currentDeviceLanguage);
                _this7.polyglot.extend(json);
                deferred.resolve();
            }).fail(deferred.reject);

            return deferred;
        }
    }, {
        key: 'loadCatalogById',
        value: function loadCatalogById(catalogId) {
            var fromRoot = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

            var catalogList = this.library.getRecursiveCatalogList();
            catalogList = _LibraryCatalogFilter2.default.filter(catalogList, {
                'deviceType': this.currentDeviceType,
                'deviceLanguage': this.currentDeviceLanguage,
                'catalogId': catalogId
            });

            if (catalogList.length > 0) {

                if (fromRoot) {
                    var catalogsToLoad = [];
                    var currentCatalog = catalogList[0];

                    while (currentCatalog != undefined) {
                        catalogsToLoad.push(currentCatalog);
                        currentCatalog = currentCatalog._parent;
                    }

                    this.viewStack = this.viewStack.slice(0, 1);

                    while (catalogsToLoad.length > 0) {
                        currentCatalog = catalogsToLoad.pop();
                        this.getController('LibraryController').loadLibraryCatalog({
                            'libraryCatalog': currentCatalog
                        });
                    }
                } else {
                    this.getController('LibraryController').loadLibraryCatalog({
                        'libraryCatalog': catalogList[0]
                    });
                }
            } else {
                $('<div>', {
                    title: 'Error',
                    html: '<p><span class="ui-icon ui-icon-alert" style="float:left; margin:0 7px 50px 0;"></span> Publicación no disponible.</p>'
                }).dialog({
                    modal: true,
                    closeOnEscape: true
                });
            }
        }
    }, {
        key: 'tryToLoadCatalogOfArgs',
        value: function tryToLoadCatalogOfArgs() {
            if (this.catalogId) {
                this.loadCatalogById(this.catalogId, true);
            }
        }
    }, {
        key: 'initializePolyfills',
        value: function initializePolyfills() {
            PointerEventsPolyfill.initialize({});
        }
    }, {
        key: 'isSupportedBrowser',
        value: function isSupportedBrowser() {
            if (bowser.msie && bowser.version <= 11) {
                return false;
            }
            return true;
        }
    }, {
        key: 'printHeader',
        value: function printHeader() {
            console.log("480i Visor Web - version: " + this.currentViewerVersion);
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            //console.log("WebViewer onResize");

        }
    }]);

    return WebViewer;
}(_App3.default);

exports.default = WebViewer;

},{"./controllers/InteractiveCatalogController":19,"./controllers/LibraryController":20,"./core/App":21,"./loader/CDSLoader":24,"./loader/LibraryLoader":25,"./util/BrowserUtils":81,"./util/CDSFilter":82,"./util/LibraryCatalogFilter":84,"./util/URLUtils":86}],19:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Controller2 = require('../core/Controller');

var _Controller3 = _interopRequireDefault(_Controller2);

var _URLUtils = require('../util/URLUtils');

var _URLUtils2 = _interopRequireDefault(_URLUtils);

var _InteractiveCatalogParser = require('../parser/interactive/InteractiveCatalogParser');

var _InteractiveCatalogParser2 = _interopRequireDefault(_InteractiveCatalogParser);

var _InteractiveCatalogPageParser = require('../parser/interactive/InteractiveCatalogPageParser');

var _InteractiveCatalogPageParser2 = _interopRequireDefault(_InteractiveCatalogPageParser);

var _InteractiveCatalogView = require('../view/interactive/InteractiveCatalogView');

var _InteractiveCatalogView2 = _interopRequireDefault(_InteractiveCatalogView);

var _GoToPageAction = require('../model/interactive/actions/GoToPageAction');

var _GoToPageAction2 = _interopRequireDefault(_GoToPageAction);

var _HideItemAction = require('../model/interactive/actions/HideItemAction');

var _HideItemAction2 = _interopRequireDefault(_HideItemAction);

var _ShowItemAction = require('../model/interactive/actions/ShowItemAction');

var _ShowItemAction2 = _interopRequireDefault(_ShowItemAction);

var _OpenWebAction = require('../model/interactive/actions/OpenWebAction');

var _OpenWebAction2 = _interopRequireDefault(_OpenWebAction);

var _PlayAudioAction = require('../model/interactive/actions/PlayAudioAction');

var _PlayAudioAction2 = _interopRequireDefault(_PlayAudioAction);

var _PauseAudioAction = require('../model/interactive/actions/PauseAudioAction');

var _PauseAudioAction2 = _interopRequireDefault(_PauseAudioAction);

var _ResumeAudioAction = require('../model/interactive/actions/ResumeAudioAction');

var _ResumeAudioAction2 = _interopRequireDefault(_ResumeAudioAction);

var _StopAudioAction = require('../model/interactive/actions/StopAudioAction');

var _StopAudioAction2 = _interopRequireDefault(_StopAudioAction);

var _PlayMovieAction = require('../model/interactive/actions/PlayMovieAction');

var _PlayMovieAction2 = _interopRequireDefault(_PlayMovieAction);

var _PauseMovieAction = require('../model/interactive/actions/PauseMovieAction');

var _PauseMovieAction2 = _interopRequireDefault(_PauseMovieAction);

var _ResumeMovieAction = require('../model/interactive/actions/ResumeMovieAction');

var _ResumeMovieAction2 = _interopRequireDefault(_ResumeMovieAction);

var _StopMovieAction = require('../model/interactive/actions/StopMovieAction');

var _StopMovieAction2 = _interopRequireDefault(_StopMovieAction);

var _ToggleMenuAction = require('../model/interactive/actions/ToggleMenuAction');

var _ToggleMenuAction2 = _interopRequireDefault(_ToggleMenuAction);

var _ExitCatalogAction = require('../model/interactive/actions/ExitCatalogAction');

var _ExitCatalogAction2 = _interopRequireDefault(_ExitCatalogAction);

var _GoToStateAction = require('../model/interactive/actions/GoToStateAction');

var _GoToStateAction2 = _interopRequireDefault(_GoToStateAction);

var _GoToNextStateAction = require('../model/interactive/actions/GoToNextStateAction');

var _GoToNextStateAction2 = _interopRequireDefault(_GoToNextStateAction);

var _GoToPreviousStateAction = require('../model/interactive/actions/GoToPreviousStateAction');

var _GoToPreviousStateAction2 = _interopRequireDefault(_GoToPreviousStateAction);

var _OpenCatalogAction = require('../model/interactive/actions/OpenCatalogAction');

var _OpenCatalogAction2 = _interopRequireDefault(_OpenCatalogAction);

var _CSSEffects = require('../util/CSSEffects');

var _CSSEffects2 = _interopRequireDefault(_CSSEffects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InteractiveCatalogController = function (_Controller) {
    _inherits(InteractiveCatalogController, _Controller);

    function InteractiveCatalogController() {
        _classCallCheck(this, InteractiveCatalogController);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(InteractiveCatalogController).call(this));
    }

    _createClass(InteractiveCatalogController, [{
        key: 'load',
        value: function load(libraryCatalog) {
            var _this2 = this;

            var url = libraryCatalog.path;
            if (url.search('http') < 0) {
                var path = this.app.baseUrl + libraryCatalog.path;
                url = _URLUtils2.default.getURL(path);
            }

            $.get(url, function (data) {

                var parser = new _InteractiveCatalogParser2.default();

                _this2.interactiveCatalog = parser.parse(data);

                var deferred = new $.Deferred();
                var promise = deferred;

                if (_this2.app.library.expandPagesXml) {
                    var _loop = function _loop(i) {
                        promise = promise.then(function () {
                            var pageUrl = url.replace(".xml", "-page-" + i + ".xml");
                            return $.get(pageUrl, function (data) {
                                var xml = $(data);
                                var elem = xml.children().first();
                                _this2.interactiveCatalog.pages.push(_InteractiveCatalogPageParser2.default.parse(elem));
                            });
                        });
                    };

                    for (var i = 0; i < _this2.interactiveCatalog.numPages; i++) {
                        _loop(i);
                    }
                }

                promise.then(function () {
                    console.log(_this2.interactiveCatalog);
                    _this2.view = new _InteractiveCatalogView2.default();
                    _this2.getApp().renderView(_this2.view, {
                        'library': _this2.app.library,
                        'baseUrl': _this2.app.baseUrl,
                        'visualTemplate': _this2.app.visualTemplate,
                        'libraryCatalog': libraryCatalog,
                        'interactiveCatalog': _this2.interactiveCatalog
                    });
                });

                deferred.resolve();
            });
        }
    }, {
        key: 'doAction',
        value: function doAction(itemAction) {
            console.log(itemAction);

            if (itemAction instanceof _GoToPageAction2.default) {
                this.interactiveCatalog.goToPage(itemAction.page);
                this.view.render();
            }

            if (itemAction instanceof _HideItemAction2.default) {

                var targetItem = this.interactiveCatalog._items[itemAction.itemId];

                if (itemAction.animationType == 'EASE_OUT') targetItem.fadeOut(1000);else if (itemAction.animationType == 'FLIP_LEFT') _CSSEffects2.default.hideFlipLeft(targetItem);else if (itemAction.animationType == 'FLIP_RIGHT') _CSSEffects2.default.hideFlipRight(targetItem);else targetItem.hide();
            }

            if (itemAction instanceof _ShowItemAction2.default) {

                var targetItem = this.interactiveCatalog._items[itemAction.itemId];

                if (itemAction.animationType == 'EASE_OUT') targetItem.fadeIn(1000);else if (itemAction.animationType == 'FLIP_LEFT') _CSSEffects2.default.showFlipLeft(targetItem);else if (itemAction.animationType == 'FLIP_RIGHT') _CSSEffects2.default.showFlipRight(targetItem);else targetItem.show();
            }

            if (itemAction instanceof _OpenWebAction2.default) {
                window.open(itemAction.url, '_blank');
            }

            if (itemAction instanceof _PlayAudioAction2.default) {
                var audio = this.interactiveCatalog._items[itemAction.itemId].find('audio')[0];
                if (audio.paused) audio.currentTime = 0;
                audio.play();
            }

            if (itemAction instanceof _PauseAudioAction2.default) {
                var audio = this.interactiveCatalog._items[itemAction.itemId].find('audio')[0];
                audio.pause();
            }

            if (itemAction instanceof _ResumeAudioAction2.default) {
                var audio = this.interactiveCatalog._items[itemAction.itemId].find('audio')[0];
                audio.play();
            }

            if (itemAction instanceof _StopAudioAction2.default) {
                var audio = this.interactiveCatalog._items[itemAction.itemId].find('audio')[0];
                audio.pause();
                audio.currentTime = 0;
            }

            if (itemAction instanceof _PlayMovieAction2.default) {
                var itemDiv = this.interactiveCatalog._items[itemAction.itemId];
                if (!itemDiv.is(":visible")) itemDiv.show();

                var video = itemDiv.find('video')[0];
                if (video.paused) video.currentTime = 0;
                video.play();
            }

            if (itemAction instanceof _PauseMovieAction2.default) {
                var itemDiv = this.interactiveCatalog._items[itemAction.itemId];
                var video = itemDiv.find('video')[0];
                video.pause();
            }

            if (itemAction instanceof _ResumeMovieAction2.default) {
                var itemDiv = this.interactiveCatalog._items[itemAction.itemId];
                if (!itemDiv.is(":visible")) itemDiv.show();

                var video = itemDiv.find('video')[0];
                video.play();
            }

            if (itemAction instanceof _StopMovieAction2.default) {
                var itemDiv = this.interactiveCatalog._items[itemAction.itemId];
                var video = itemDiv.find('video')[0];
                video.pause();
                video.currentTime = 0;
            }

            if (itemAction instanceof _ToggleMenuAction2.default) {
                $('#toolbar').fadeToggle();
            }

            if (itemAction instanceof _ExitCatalogAction2.default) {
                this.app.goBack();
            }

            if (itemAction instanceof _GoToStateAction2.default) {
                var itemDiv = this.interactiveCatalog._items[itemAction.itemId];
                var item = itemDiv._item;
                item.goToState(itemAction.stateName);
                item.refresh(itemDiv);
            }

            if (itemAction instanceof _GoToNextStateAction2.default) {
                var itemDiv = this.interactiveCatalog._items[itemAction.itemId];
                var item = itemDiv._item;
                item.goToNextState(itemAction.stopInLast);
                item.refresh(itemDiv);
            }

            if (itemAction instanceof _GoToPreviousStateAction2.default) {
                var itemDiv = this.interactiveCatalog._items[itemAction.itemId];
                var item = itemDiv._item;
                item.goToPreviousState(itemAction.stopInFirst);
                item.refresh(itemDiv);
            }

            if (itemAction instanceof _OpenCatalogAction2.default) {
                this.app.loadCatalogById(itemAction.catalogId, true);
            }
        }
    }]);

    return InteractiveCatalogController;
}(_Controller3.default);

exports.default = InteractiveCatalogController;

},{"../core/Controller":22,"../model/interactive/actions/ExitCatalogAction":39,"../model/interactive/actions/GoToNextStateAction":40,"../model/interactive/actions/GoToPageAction":41,"../model/interactive/actions/GoToPreviousStateAction":42,"../model/interactive/actions/GoToStateAction":43,"../model/interactive/actions/HideItemAction":44,"../model/interactive/actions/OpenCatalogAction":46,"../model/interactive/actions/OpenWebAction":47,"../model/interactive/actions/PauseAudioAction":48,"../model/interactive/actions/PauseMovieAction":49,"../model/interactive/actions/PlayAudioAction":50,"../model/interactive/actions/PlayMovieAction":51,"../model/interactive/actions/ResumeAudioAction":52,"../model/interactive/actions/ResumeMovieAction":53,"../model/interactive/actions/ShowItemAction":54,"../model/interactive/actions/StopAudioAction":55,"../model/interactive/actions/StopMovieAction":56,"../model/interactive/actions/ToggleMenuAction":57,"../parser/interactive/InteractiveCatalogPageParser":78,"../parser/interactive/InteractiveCatalogParser":79,"../util/CSSEffects":83,"../util/URLUtils":86,"../view/interactive/InteractiveCatalogView":97}],20:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Controller2 = require('../core/Controller');

var _Controller3 = _interopRequireDefault(_Controller2);

var _LibraryView = require('../view/LibraryView');

var _LibraryView2 = _interopRequireDefault(_LibraryView);

var _FolderView = require('../view/FolderView');

var _FolderView2 = _interopRequireDefault(_FolderView);

var _PDFView = require('../view/PDFView');

var _PDFView2 = _interopRequireDefault(_PDFView);

var _YoutubeView = require('../view/video/YoutubeView');

var _YoutubeView2 = _interopRequireDefault(_YoutubeView);

var _YoutubeListView = require('../view/video/YoutubeListView');

var _YoutubeListView2 = _interopRequireDefault(_YoutubeListView);

var _VimeoView = require('../view/video/VimeoView');

var _VimeoView2 = _interopRequireDefault(_VimeoView);

var _LocalVideoView = require('../view/video/LocalVideoView');

var _LocalVideoView2 = _interopRequireDefault(_LocalVideoView);

var _WebView = require('../view/web/WebView');

var _WebView2 = _interopRequireDefault(_WebView);

var _TypeformView = require('../view/web/TypeformView');

var _TypeformView2 = _interopRequireDefault(_TypeformView);

var _GoogleMapsView = require('../view/web/GoogleMapsView');

var _GoogleMapsView2 = _interopRequireDefault(_GoogleMapsView);

var _HTMLView = require('../view/web/HTMLView');

var _HTMLView2 = _interopRequireDefault(_HTMLView);

var _URLUtils = require('../util/URLUtils');

var _URLUtils2 = _interopRequireDefault(_URLUtils);

var _LibraryCatalogFilter = require('../util/LibraryCatalogFilter');

var _LibraryCatalogFilter2 = _interopRequireDefault(_LibraryCatalogFilter);

var _LibraryCatalogSorter = require('../util/LibraryCatalogSorter');

var _LibraryCatalogSorter2 = _interopRequireDefault(_LibraryCatalogSorter);

var _LibraryXMLParser = require('../parser/LibraryXMLParser');

var _LibraryXMLParser2 = _interopRequireDefault(_LibraryXMLParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LibraryController = function (_Controller) {
    _inherits(LibraryController, _Controller);

    function LibraryController() {
        _classCallCheck(this, LibraryController);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(LibraryController).call(this));
    }

    _createClass(LibraryController, [{
        key: 'onRegistered',
        value: function onRegistered() {
            this.registerAction('loadLibrary', this.loadLibrary.bind(this));
            this.registerAction('loadLibraryCatalog', this.loadLibraryCatalog.bind(this));
            this.registerAction('searchLibraryCatalogs', this.searchLibraryCatalogs.bind(this));
        }
    }, {
        key: 'loadLibrary',
        value: function loadLibrary(args) {
            var library = args['library'];

            // Check useAsRoot
            var useAsRootCatalogs = this.getUseAsRootCatalogs(library.catalogList);
            useAsRootCatalogs = _LibraryCatalogFilter2.default.filter(useAsRootCatalogs, {
                'deviceType': this.app.currentDeviceType,
                'deviceLanguage': this.app.currentDeviceLanguage
            });

            if (useAsRootCatalogs.length > 0) {
                this.loadLibraryCatalog({
                    'libraryCatalog': useAsRootCatalogs[0]
                });
            } else {
                var catalogList = library.catalogList;
                catalogList = _LibraryCatalogFilter2.default.filter(catalogList, {
                    'deviceType': this.app.currentDeviceType,
                    'deviceLanguage': this.app.currentDeviceLanguage
                });
                catalogList = _LibraryCatalogSorter2.default.sort(catalogList, this.app.library.indexSortType);

                if (library.singleIssueApp) {
                    catalogList[0].useAsRoot = true;
                    this.loadLibraryCatalog({
                        'libraryCatalog': catalogList[0]
                    });
                } else {
                    this.getApp().renderView(new _LibraryView2.default(), {
                        'library': library,
                        'catalogList': catalogList
                    });
                }
            }
        }
    }, {
        key: 'loadLibraryCatalog',
        value: function loadLibraryCatalog(args) {
            var _this2 = this;

            var libraryCatalog = args['libraryCatalog'];
            console.log(libraryCatalog);

            if (libraryCatalog.catalogType == 'FOLDER') {
                var catalogList = libraryCatalog.childList;
                catalogList = _LibraryCatalogFilter2.default.filter(catalogList, {
                    'deviceType': this.app.currentDeviceType,
                    'deviceLanguage': this.app.currentDeviceLanguage
                });
                catalogList = _LibraryCatalogSorter2.default.sort(catalogList, this.app.library.indexSortType);

                this.getApp().renderView(new _FolderView2.default(), {
                    'library': this.app.library,
                    'baseUrl': this.app.baseUrl,
                    'visualTemplate': this.app.visualTemplate,
                    'libraryCatalog': libraryCatalog,
                    'catalogList': catalogList
                });
            } else if (libraryCatalog.catalogType == 'INTELLIGENT_FOLDER') {

                $.get(libraryCatalog.intelligentFolderUrl, function (data) {

                    var parser = new _LibraryXMLParser2.default();
                    var intelligentFolder = parser.parseIntelligentFolder(data, _this2.app.visualTemplate);
                    var catalogList = intelligentFolder.childList;
                    catalogList = _LibraryCatalogFilter2.default.filter(catalogList, {
                        'deviceType': _this2.app.currentDeviceType,
                        'deviceLanguage': _this2.app.currentDeviceLanguage
                    });
                    catalogList = _LibraryCatalogSorter2.default.sort(catalogList, _this2.app.library.indexSortType);

                    _this2.getApp().renderView(new _FolderView2.default(), {
                        'library': _this2.app.library,
                        'baseUrl': _this2.app.baseUrl,
                        'visualTemplate': _this2.app.visualTemplate,
                        'libraryCatalog': libraryCatalog,
                        'catalogList': catalogList
                    });
                });
            } else if (libraryCatalog.catalogType == 'PDF') {

                var url = libraryCatalog.path;
                if (url.search('http') < 0) {
                    var path = this.app.baseUrl + libraryCatalog.path;
                    url = _URLUtils2.default.getURL(path);
                }

                this.getApp().renderView(new _PDFView2.default(), {
                    'libraryCatalog': libraryCatalog,
                    'url': url,
                    'visualTemplate': this.app.visualTemplate
                });
            } else if (libraryCatalog.catalogType == 'INTERACTIVE') {
                var interactiveCatalogController = this.app.getController("InteractiveCatalogController");
                interactiveCatalogController.load(libraryCatalog);
            } else if (libraryCatalog.catalogType == 'VIDEO') {

                var _args = {
                    'library': this.app.library,
                    'baseUrl': this.app.baseUrl,
                    'visualTemplate': this.app.visualTemplate,
                    'libraryCatalog': libraryCatalog
                };

                switch (libraryCatalog.catalogVideoType) {
                    case 'YOUTUBE':
                        this.getApp().renderView(new _YoutubeView2.default(), _args);
                        break;
                    case 'YOUTUBE_LIST':
                        this.getApp().renderView(new _YoutubeListView2.default(), _args);
                        break;
                    case 'VIMEO':
                        this.getApp().renderView(new _VimeoView2.default(), _args);
                        break;
                    case 'LOCAL_VIDEO':
                        this.getApp().renderView(new _LocalVideoView2.default(), _args);
                        break;
                }
            } else if (libraryCatalog.catalogType == 'WEB') {

                var _args2 = {
                    'library': this.app.library,
                    'baseUrl': this.app.baseUrl,
                    'visualTemplate': this.app.visualTemplate,
                    'libraryCatalog': libraryCatalog
                };

                switch (libraryCatalog.catalogWebType) {
                    case 'WEB':
                        this.getApp().renderView(new _WebView2.default(), _args2);
                        break;
                    case 'TYPEFORM':
                        this.getApp().renderView(new _TypeformView2.default(), _args2);
                        break;
                    case 'GOOGLE_MAPS':
                        this.getApp().renderView(new _GoogleMapsView2.default(), _args2);
                        break;
                    case 'HTML':
                        this.getApp().renderView(new _HTMLView2.default(), _args2);
                        break;
                    case 'FACEBOOK':
                        this.getApp().renderView(new _HTMLView2.default(), _args2);
                        break;
                    case 'TWITTER':
                        this.getApp().renderView(new _HTMLView2.default(), _args2);
                        break;
                    case 'RSS':
                        this.getApp().renderView(new _WebView2.default(), _args2);
                        break;
                }
            }
        }
    }, {
        key: 'searchLibraryCatalogs',
        value: function searchLibraryCatalogs(args) {
            var searchString = args['searchString'];

            var catalogList = this.app.library.getRecursiveCatalogList();
            catalogList = _LibraryCatalogFilter2.default.filter(catalogList, {
                'deviceType': this.app.currentDeviceType,
                'deviceLanguage': this.app.currentDeviceLanguage,
                'title': searchString
            });
            catalogList = _LibraryCatalogSorter2.default.sort(catalogList, this.app.library.indexSortType);

            this.getApp().renderView(new _FolderView2.default(), {
                'library': this.app.library,
                'baseUrl': this.app.baseUrl,
                'visualTemplate': this.app.visualTemplate,
                'libraryCatalog': {
                    'title': searchString,
                    'useAsRoot': false,
                    'showCatalogMenu': true,
                    'showExitButton': true
                },
                'catalogList': catalogList
            });
        }
    }, {
        key: 'getUseAsRootCatalogs',
        value: function getUseAsRootCatalogs(catalogList) {

            var res = catalogList.filter(function (elem) {
                return elem.useAsRoot;
            });

            catalogList.forEach(function (elem) {
                res.concat(elem.childList);
            });

            return res;
        }
    }]);

    return LibraryController;
}(_Controller3.default);

exports.default = LibraryController;

},{"../core/Controller":22,"../parser/LibraryXMLParser":74,"../util/LibraryCatalogFilter":84,"../util/LibraryCatalogSorter":85,"../util/URLUtils":86,"../view/FolderView":89,"../view/LibraryView":94,"../view/PDFView":95,"../view/video/LocalVideoView":98,"../view/video/VimeoView":100,"../view/video/YoutubeListView":101,"../view/video/YoutubeView":102,"../view/web/GoogleMapsView":103,"../view/web/HTMLView":104,"../view/web/TypeformView":105,"../view/web/WebView":106}],21:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var App = function () {
    function App() {
        _classCallCheck(this, App);

        this.controllers = {};
        this.actions = {};
    }

    _createClass(App, [{
        key: "registerController",
        value: function registerController(name, controller) {
            this.controllers[name] = controller;
            controller.setApp(this);
            controller.onRegistered();
        }
    }, {
        key: "getController",
        value: function getController(name) {
            return this.controllers[name];
        }
    }, {
        key: "registerAction",
        value: function registerAction(name, handler) {
            this.actions[name] = handler;
        }
    }, {
        key: "callAction",
        value: function callAction(actionName, args) {
            this.actions[actionName](args);
        }
    }, {
        key: "createView",
        value: function createView(view, model) {
            view.setApp(this);
            return view.createView(model);
        }
    }, {
        key: "renderView",
        value: function renderView(view, model) {
            view.setApp(this);
        }
    }]);

    return App;
}();

exports.default = App;

},{}],22:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = function () {
    function Controller() {
        _classCallCheck(this, Controller);

        this.app = null;
    }

    _createClass(Controller, [{
        key: "setApp",
        value: function setApp(app) {
            this.app = app;
        }
    }, {
        key: "getApp",
        value: function getApp() {
            return this.app;
        }
    }, {
        key: "onRegistered",
        value: function onRegistered() {}
    }, {
        key: "registerAction",
        value: function registerAction(name, handler) {
            this.app.registerAction(name, handler);
        }
    }, {
        key: "renderView",
        value: function renderView(view, model) {
            this.app.renderView(view, model);
        }
    }]);

    return Controller;
}();

exports.default = Controller;

},{}],23:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _WebViewer = require('../WebViewer');

var _WebViewer2 = _interopRequireDefault(_WebViewer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var View = function () {
    function View() {
        _classCallCheck(this, View);

        this.app = null;
    }

    _createClass(View, [{
        key: 'setApp',
        value: function setApp(app) {
            this.app = app;
        }
    }, {
        key: 'getApp',
        value: function getApp() {
            return this.app;
        }
    }, {
        key: 'createView',
        value: function createView(model) {}
    }, {
        key: 'onRendered',
        value: function onRendered() {}
    }]);

    return View;
}();

exports.default = View;

},{"../WebViewer":18}],24:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CDSConfig = require('../model/CDSConfig');

var _CDSConfig2 = _interopRequireDefault(_CDSConfig);

var _CDSParser = require('../parser/CDSParser');

var _CDSParser2 = _interopRequireDefault(_CDSParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CDSLoader = function () {
    function CDSLoader() {
        _classCallCheck(this, CDSLoader);
    }

    _createClass(CDSLoader, [{
        key: 'loadCDSConfig',
        value: function loadCDSConfig(url) {

            var deferred = new $.Deferred();

            $.get(url).done(function (data) {
                var cdsParser = new _CDSParser2.default();
                var cdsConfig = cdsParser.parseCDSConfig(data);
                deferred.resolve(cdsConfig);
            }).fail(deferred.reject);

            return deferred;
        }
    }, {
        key: 'loadCDSResponse',
        value: function loadCDSResponse(cdsConfig) {

            cdsConfig = cdsConfig instanceof _CDSConfig2.default ? cdsConfig : new _CDSConfig2.default();

            var url = cdsConfig.cdsUrl + '/coicds-list-valid-application-publications';

            var requestContent = '';
            if (cdsConfig.cdsUsername.length == 0 && cdsConfig.cdsPassword.length == 0) {
                requestContent = '<request applicationId="' + cdsConfig.cdsLibraryId + '"/>';
            } else {
                requestContent = '<request applicationId="' + cdsConfig.cdsLibraryId + '" username="' + cdsConfig.cdsUsername + '" password="' + cdsConfig.cdsPassword + '"/>';
            }

            var deferred = new $.Deferred();

            $.post(url, requestContent).done(function (data) {
                var cdsParser = new _CDSParser2.default();
                var cdsResponse = cdsParser.parseCDSResponse(data);
                deferred.resolve(cdsResponse);
            }).fail(deferred.reject);

            return deferred;
        }
    }]);

    return CDSLoader;
}();

exports.default = CDSLoader;

},{"../model/CDSConfig":26,"../parser/CDSParser":73}],25:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _LibraryXMLParser = require('../parser/LibraryXMLParser');

var _LibraryXMLParser2 = _interopRequireDefault(_LibraryXMLParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LibraryLoader = function () {
    function LibraryLoader() {
        _classCallCheck(this, LibraryLoader);
    }

    _createClass(LibraryLoader, [{
        key: 'load',
        value: function load(url) {

            var deferred = new $.Deferred();

            $.get(url).done(function (data) {
                var parser = new _LibraryXMLParser2.default();
                var library = parser.parseLibrary(data);
                deferred.resolve(library);
            }).fail(deferred.reject);;

            return deferred;
        }
    }]);

    return LibraryLoader;
}();

exports.default = LibraryLoader;

},{"../parser/LibraryXMLParser":74}],26:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CDSConfig = function CDSConfig() {
    _classCallCheck(this, CDSConfig);

    this.cdsUrl = '';
    this.cdsLibraryId = '';
    this.cdsUseDefaultUsername = true;
    this.cdsUsername = '';
    this.cdsPassword = '';
};

exports.default = CDSConfig;

},{}],27:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CDSPublication = function CDSPublication() {
    _classCallCheck(this, CDSPublication);

    this.id = '';
    this.name = '';
    this.recursive = false;
};

exports.default = CDSPublication;

},{}],28:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CDSConfig = function CDSConfig() {
    _classCallCheck(this, CDSConfig);

    this.code = '';
    this.message = '';
    this.publications = {};
};

exports.default = CDSConfig;

},{}],29:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Library = function () {
    function Library() {
        _classCallCheck(this, Library);

        this.libraryId = 0;
        this.title = "";
        this.horizontalIndex = false;
        this.verticalIndex = false;
        this.compressedResources = false;
        this.visualTemplate = null;
        this.deviceLanguageList = [];
        this.defaultLanguage = '';
        this.enableAnalytics = false;
        this.analyticsWebId = '';
        this.appUrl = '';
        this.indexSortType = '';
        this.singleIssueApp = false;
        this.expandPagesXml = false;
        this.catalogList = [];
    }

    _createClass(Library, [{
        key: 'getRecursiveCatalogList',
        value: function getRecursiveCatalogList() {
            var res = [];
            res = res.concat(this.catalogList);
            this.catalogList.forEach(function (elem) {
                res = res.concat(elem.getRecursiveChildList());
            });
            return res;
        }
    }]);

    return Library;
}();

exports.default = Library;

},{}],30:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LibraryBanner = function LibraryBanner() {
    _classCallCheck(this, LibraryBanner);

    this.image = '';
    this.url = '';
    this.width = 0;
    this.height = 0;
    this.language = '';
};

exports.default = LibraryBanner;

},{}],31:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LibraryCatalog = function () {
    function LibraryCatalog() {
        _classCallCheck(this, LibraryCatalog);

        this.catalogId = 0;
        this.title = '';
        this.subtitle = '';
        // LibraryCatalogType (PDF, INTERACTIVE, FOLDER, INTELLIGENT_FOLDER, VIDEO, WEB)
        this.catalogType = '';
        this.catalogVideoType = '';
        this.catalogWebType = '';
        this.url = '';
        // URL relativa
        this.path = '';
        // En el caso de que sea una publicación del tipo FOLDER aquí estarían los catálogos hijo
        this.childList = [];
        this.fullscreen = false;
        this.horizontalImage = '';
        this.verticalImage = '';
        this.deviceLanguage = [];
        this.deviceType = [];
        this.publishDate = '';
        this.useAsRoot = false;

        this.horizontalBanner = [];
        this.verticalBanner = [];
        this.bannerInterval = 0;

        this.showExitButton = false;
        this.showIndexButton = false;
        this.showPageSlider = false;
        this.showBookmarksButton = false;
        this.showCatalogMenu = false;
        this.showShareButton = false;

        this.changePageMode = '';

        this.intelligentFolderUrl = '';

        this._parent = undefined;
    }

    _createClass(LibraryCatalog, [{
        key: 'getRecursiveChildList',
        value: function getRecursiveChildList() {
            var res = [];
            res = res.concat(this.childList);
            this.childList.forEach(function (elem) {
                res = res.concat(elem.getRecursiveChildList());
            });
            return res;
        }
    }]);

    return LibraryCatalog;
}();

exports.default = LibraryCatalog;

},{}],32:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
        value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VisualTemplate = function VisualTemplate() {
        _classCallCheck(this, VisualTemplate);

        this.horizontalBanner = [];
        this.verticalBanner = [];
        this.bannerInterval = 0;

        this.horizontalLibraryInfoImages = [];
        this.verticalLibraryInfoImages = [];

        this.showExitButton = false;
        this.showIndexButton = false;
        this.showPageSlider = false;
        this.showBookmarksButton = false;
        this.showCatalogMenu = false;
        this.showShareButton = false;
        this.showSearchButton = false;
        this.showChangeLanguageButton = false;

        this.toolbarTintColor = '';
        this.toolbarTintSecondaryColor = '';
        this.toolbarBackgroundColor = '';
        this.listCatalogsBackgroundColor = '';
        this.catalogTitleColor = '';
        this.catalogDescriptionColor = '';
        this.catalogButtonColor = '';
        this.separatorLineColor = '';
};

exports.default = VisualTemplate;

},{}],33:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CanvasDimension = function CanvasDimension() {
    _classCallCheck(this, CanvasDimension);

    this.width = 0.0;
    this.height = 0.0;
};

exports.default = CanvasDimension;

},{}],34:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InteractiveCatalog = function () {
    function InteractiveCatalog() {
        _classCallCheck(this, InteractiveCatalog);

        this.catalogId = '';
        this.title = '';
        this.navigationType = ''; // InteractiveCatalogNavigationType { MAGAZINE_2X1_ADAPTABLE, MAGAZINE_2X1_INDEPENDENT_ORIENTATIONS, INDEPENDENT_ORIENTATIONS, ONLY_HORIZONTAL, ONLY_VERTICAL }
        this.firstPageLeft = false; // 2x1
        this.horizontalSize = undefined; // CanvasDimension
        this.verticalSize = undefined; // CanvasDimension
        this.universalSize = undefined; // CanvasDimension
        this.pages = []; // List of InteractiveCatalogPage
        this.indexPages = []; // List of InteractiveCatalogIndexPage
        this.numPages = 0;
        this.indexNumPage = 0;
        this.fullScreen = false;
        this.horizontalAlignmentType = ''; // AlignmentType { CENTERED, *BORDER_CENTERED_ALIGNED, BORDER_LEFT_ALIGNED, BORDER_RIGHT_ALIGNED }
        this.openActions = []; // List of ItemAction
        this.indexType = undefined; // IndexType
        this.backgroundColor = '';

        this._currentPageIndex = -1;
        this._currentPage = undefined;
        this._items = [];
    }

    _createClass(InteractiveCatalog, [{
        key: 'goToPage',
        value: function goToPage(pageIndex) {
            if (pageIndex >= 0 && pageIndex < this.pages.length && pageIndex != this._currentPageIndex) {
                this._currentPageIndex = pageIndex;
                this._currentPage = this.pages[pageIndex];
                return true;
            }
            return false;
        }
    }, {
        key: 'goToPrevPage',
        value: function goToPrevPage() {
            return this.goToPage(this._currentPageIndex - 1);
        }
    }, {
        key: 'goToNextPage',
        value: function goToNextPage() {
            return this.goToPage(this._currentPageIndex + 1);
        }
    }]);

    return InteractiveCatalog;
}();

exports.default = InteractiveCatalog;

},{}],35:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InteractiveCatalogIndexPage = function InteractiveCatalogIndexPage() {
    _classCallCheck(this, InteractiveCatalogIndexPage);

    this.horizontalIndexImage = '';
    this.verticalIndexImage = '';
    this.numPage = 0;
    this.title = '';
    this.description = '';
};

exports.default = InteractiveCatalogIndexPage;

},{}],36:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
        value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InteractiveCatalogPage = function InteractiveCatalogPage() {
        _classCallCheck(this, InteractiveCatalogPage);

        this.pageId = '';
        this.title = '';
        this.description = '';

        this.horizontalIndexImage = '';
        this.verticalIndexImage = '';

        this.horizontalLayers = []; // List of InteractiveCatalogPageLayer
        this.verticalLayers = []; // List of InteractiveCatalogPageLayer
        this.universalLayers = []; // List of InteractiveCatalogPageLayer

        this.horizontalSize = undefined; // CanvasDimension
        this.verticalSize = undefined; // CanvasDimension
        this.universalSize = undefined; // CanvasDimension

        this.openPageActions = []; // List of ItemAction

        this.horizontalChangePageMode = '';
        this.verticalChangePageMode = '';

        this.horizontalPageVerticalScrollPager = false;
        this.verticalPageVerticalScrollPager = false;

        this.backgroundColor = '';
};

exports.default = InteractiveCatalogPage;

},{}],37:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
        value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InteractiveCatalogPageItem = function InteractiveCatalogPageItem() {
        _classCallCheck(this, InteractiveCatalogPageItem);

        this.itemId = 0;
        this.itemName = '';

        this.left = 0;
        this.top = 0;
        this.width = 0;
        this.height = 0;

        this.hidden = false;
        this.draggable = false;
        this.clonable = false;

        this.deviceLanguages = [];
        this.deviceTypes = [];
};

exports.default = InteractiveCatalogPageItem;

},{}],38:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InteractiveCatalogPageLayer = function InteractiveCatalogPageLayer() {
    _classCallCheck(this, InteractiveCatalogPageLayer);

    this.name = '';
    this.items = []; // List of InteractiveCatalogPageItem
    this.hidden = false;
};

exports.default = InteractiveCatalogPageLayer;

},{}],39:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ItemAction2 = require('./ItemAction');

var _ItemAction3 = _interopRequireDefault(_ItemAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExitCatalogAction = function (_ItemAction) {
    _inherits(ExitCatalogAction, _ItemAction);

    function ExitCatalogAction() {
        _classCallCheck(this, ExitCatalogAction);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(ExitCatalogAction).call(this));
    }

    return ExitCatalogAction;
}(_ItemAction3.default);

exports.default = ExitCatalogAction;

},{"./ItemAction":45}],40:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ItemAction2 = require('./ItemAction');

var _ItemAction3 = _interopRequireDefault(_ItemAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GoToNextStateAction = function (_ItemAction) {
    _inherits(GoToNextStateAction, _ItemAction);

    function GoToNextStateAction() {
        _classCallCheck(this, GoToNextStateAction);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GoToNextStateAction).call(this));

        _this.itemId = 0;
        _this.stopInLast = false;
        return _this;
    }

    return GoToNextStateAction;
}(_ItemAction3.default);

exports.default = GoToNextStateAction;

},{"./ItemAction":45}],41:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ItemAction2 = require('./ItemAction');

var _ItemAction3 = _interopRequireDefault(_ItemAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GoToPageAction = function (_ItemAction) {
    _inherits(GoToPageAction, _ItemAction);

    function GoToPageAction() {
        _classCallCheck(this, GoToPageAction);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GoToPageAction).call(this));

        _this.page = 0;
        return _this;
    }

    return GoToPageAction;
}(_ItemAction3.default);

exports.default = GoToPageAction;

},{"./ItemAction":45}],42:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ItemAction2 = require('./ItemAction');

var _ItemAction3 = _interopRequireDefault(_ItemAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GoToPreviousStateAction = function (_ItemAction) {
    _inherits(GoToPreviousStateAction, _ItemAction);

    function GoToPreviousStateAction() {
        _classCallCheck(this, GoToPreviousStateAction);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GoToPreviousStateAction).call(this));

        _this.itemId = 0;
        _this.stopInFirst = false;
        return _this;
    }

    return GoToPreviousStateAction;
}(_ItemAction3.default);

exports.default = GoToPreviousStateAction;

},{"./ItemAction":45}],43:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ItemAction2 = require('./ItemAction');

var _ItemAction3 = _interopRequireDefault(_ItemAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GoToStateAction = function (_ItemAction) {
    _inherits(GoToStateAction, _ItemAction);

    function GoToStateAction() {
        _classCallCheck(this, GoToStateAction);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GoToStateAction).call(this));

        _this.itemId = 0;
        _this.stateName = '';
        return _this;
    }

    return GoToStateAction;
}(_ItemAction3.default);

exports.default = GoToStateAction;

},{"./ItemAction":45}],44:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ItemAction2 = require('./ItemAction');

var _ItemAction3 = _interopRequireDefault(_ItemAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HideItemAction = function (_ItemAction) {
    _inherits(HideItemAction, _ItemAction);

    function HideItemAction() {
        _classCallCheck(this, HideItemAction);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(HideItemAction).call(this));

        _this.itemId = 0;
        return _this;
    }

    return HideItemAction;
}(_ItemAction3.default);

exports.default = HideItemAction;

},{"./ItemAction":45}],45:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ItemAction = function ItemAction() {
    _classCallCheck(this, ItemAction);

    this.animationType = undefined; // AnimationType
    this.animationDuration = 0.0;
    this.animationRepeat = false;
};

exports.default = ItemAction;

},{}],46:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ItemAction2 = require('./ItemAction');

var _ItemAction3 = _interopRequireDefault(_ItemAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OpenCatalogAction = function (_ItemAction) {
    _inherits(OpenCatalogAction, _ItemAction);

    function OpenCatalogAction() {
        _classCallCheck(this, OpenCatalogAction);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(OpenCatalogAction).call(this));

        _this.catalogId = '';
        return _this;
    }

    return OpenCatalogAction;
}(_ItemAction3.default);

exports.default = OpenCatalogAction;

},{"./ItemAction":45}],47:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ItemAction2 = require('./ItemAction');

var _ItemAction3 = _interopRequireDefault(_ItemAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OpenWebAction = function (_ItemAction) {
    _inherits(OpenWebAction, _ItemAction);

    function OpenWebAction() {
        _classCallCheck(this, OpenWebAction);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(OpenWebAction).call(this));

        _this.url = '';
        _this.title = '';
        _this.openOutside = true;
        return _this;
    }

    return OpenWebAction;
}(_ItemAction3.default);

exports.default = OpenWebAction;

},{"./ItemAction":45}],48:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ItemAction2 = require('./ItemAction');

var _ItemAction3 = _interopRequireDefault(_ItemAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PauseAudioAction = function (_ItemAction) {
    _inherits(PauseAudioAction, _ItemAction);

    function PauseAudioAction() {
        _classCallCheck(this, PauseAudioAction);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PauseAudioAction).call(this));

        _this.itemId = 0;
        return _this;
    }

    return PauseAudioAction;
}(_ItemAction3.default);

exports.default = PauseAudioAction;

},{"./ItemAction":45}],49:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ItemAction2 = require('./ItemAction');

var _ItemAction3 = _interopRequireDefault(_ItemAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PauseMovieAction = function (_ItemAction) {
    _inherits(PauseMovieAction, _ItemAction);

    function PauseMovieAction() {
        _classCallCheck(this, PauseMovieAction);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PauseMovieAction).call(this));

        _this.itemId = 0;
        return _this;
    }

    return PauseMovieAction;
}(_ItemAction3.default);

exports.default = PauseMovieAction;

},{"./ItemAction":45}],50:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ItemAction2 = require('./ItemAction');

var _ItemAction3 = _interopRequireDefault(_ItemAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlayAudioAction = function (_ItemAction) {
    _inherits(PlayAudioAction, _ItemAction);

    function PlayAudioAction() {
        _classCallCheck(this, PlayAudioAction);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PlayAudioAction).call(this));

        _this.itemId = 0;
        return _this;
    }

    return PlayAudioAction;
}(_ItemAction3.default);

exports.default = PlayAudioAction;

},{"./ItemAction":45}],51:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ItemAction2 = require('./ItemAction');

var _ItemAction3 = _interopRequireDefault(_ItemAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlayMovieAction = function (_ItemAction) {
    _inherits(PlayMovieAction, _ItemAction);

    function PlayMovieAction() {
        _classCallCheck(this, PlayMovieAction);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PlayMovieAction).call(this));

        _this.itemId = 0;
        return _this;
    }

    return PlayMovieAction;
}(_ItemAction3.default);

exports.default = PlayMovieAction;

},{"./ItemAction":45}],52:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ItemAction2 = require('./ItemAction');

var _ItemAction3 = _interopRequireDefault(_ItemAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResumeAudioAction = function (_ItemAction) {
    _inherits(ResumeAudioAction, _ItemAction);

    function ResumeAudioAction() {
        _classCallCheck(this, ResumeAudioAction);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ResumeAudioAction).call(this));

        _this.itemId = 0;
        return _this;
    }

    return ResumeAudioAction;
}(_ItemAction3.default);

exports.default = ResumeAudioAction;

},{"./ItemAction":45}],53:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ItemAction2 = require('./ItemAction');

var _ItemAction3 = _interopRequireDefault(_ItemAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResumeMovieAction = function (_ItemAction) {
    _inherits(ResumeMovieAction, _ItemAction);

    function ResumeMovieAction() {
        _classCallCheck(this, ResumeMovieAction);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ResumeMovieAction).call(this));

        _this.itemId = 0;
        return _this;
    }

    return ResumeMovieAction;
}(_ItemAction3.default);

exports.default = ResumeMovieAction;

},{"./ItemAction":45}],54:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ItemAction2 = require('./ItemAction');

var _ItemAction3 = _interopRequireDefault(_ItemAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShowItemAction = function (_ItemAction) {
    _inherits(ShowItemAction, _ItemAction);

    function ShowItemAction() {
        _classCallCheck(this, ShowItemAction);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ShowItemAction).call(this));

        _this.itemId = 0;
        return _this;
    }

    return ShowItemAction;
}(_ItemAction3.default);

exports.default = ShowItemAction;

},{"./ItemAction":45}],55:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ItemAction2 = require('./ItemAction');

var _ItemAction3 = _interopRequireDefault(_ItemAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StopAudioAction = function (_ItemAction) {
    _inherits(StopAudioAction, _ItemAction);

    function StopAudioAction() {
        _classCallCheck(this, StopAudioAction);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(StopAudioAction).call(this));

        _this.itemId = 0;
        return _this;
    }

    return StopAudioAction;
}(_ItemAction3.default);

exports.default = StopAudioAction;

},{"./ItemAction":45}],56:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ItemAction2 = require('./ItemAction');

var _ItemAction3 = _interopRequireDefault(_ItemAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StopMovieAction = function (_ItemAction) {
    _inherits(StopMovieAction, _ItemAction);

    function StopMovieAction() {
        _classCallCheck(this, StopMovieAction);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(StopMovieAction).call(this));

        _this.itemId = 0;
        return _this;
    }

    return StopMovieAction;
}(_ItemAction3.default);

exports.default = StopMovieAction;

},{"./ItemAction":45}],57:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ItemAction2 = require('./ItemAction');

var _ItemAction3 = _interopRequireDefault(_ItemAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ToggleMenuAction = function (_ItemAction) {
    _inherits(ToggleMenuAction, _ItemAction);

    function ToggleMenuAction() {
        _classCallCheck(this, ToggleMenuAction);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(ToggleMenuAction).call(this));
    }

    return ToggleMenuAction;
}(_ItemAction3.default);

exports.default = ToggleMenuAction;

},{"./ItemAction":45}],58:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _InteractiveCatalogPageItem = require('../InteractiveCatalogPageItem');

var _InteractiveCatalogPageItem2 = _interopRequireDefault(_InteractiveCatalogPageItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AnimatedImageItem = function (_InteractiveCatalogPa) {
    _inherits(AnimatedImageItem, _InteractiveCatalogPa);

    function AnimatedImageItem() {
        _classCallCheck(this, AnimatedImageItem);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AnimatedImageItem).call(this));

        _this.paths = [];
        _this.step = 0.0;
        _this.loop = false;

        _this._images = [];
        _this._currentIndex = -1;
        _this._interval = undefined;
        return _this;
    }

    _createClass(AnimatedImageItem, [{
        key: 'clear',
        value: function clear() {
            if (this._interval != undefined) clearInterval(this._interval);

            this._images = [];
            this._currentIndex = -1;
            this._interval = undefined;
        }
    }, {
        key: 'start',
        value: function start() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this._images[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var img = _step.value;

                    img.hide();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this._currentIndex = 0;
            this._images[this._currentIndex].show();
            this._interval = setInterval(this.onNext.bind(this), this.step * 1000 / this._images.length);
        }
    }, {
        key: 'onNext',
        value: function onNext() {
            var nextIndex = this._currentIndex + 1;

            if (nextIndex == this._images.length) {
                if (!this.loop) {
                    clearInterval(this._interval);
                    return;
                }
                nextIndex = 0;
            }

            this._images[this._currentIndex].hide();
            this._currentIndex = nextIndex;
            this._images[this._currentIndex].show();
        }
    }]);

    return AnimatedImageItem;
}(_InteractiveCatalogPageItem2.default);

exports.default = AnimatedImageItem;

},{"../InteractiveCatalogPageItem":37}],59:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _InteractiveCatalogPageItem = require('../InteractiveCatalogPageItem');

var _InteractiveCatalogPageItem2 = _interopRequireDefault(_InteractiveCatalogPageItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AudioItem = function (_InteractiveCatalogPa) {
    _inherits(AudioItem, _InteractiveCatalogPa);

    function AudioItem() {
        _classCallCheck(this, AudioItem);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AudioItem).call(this));

        _this.path = '';
        _this.loop = false;
        _this.autoPlay = false;
        _this.stopOnPageTurn = false;
        return _this;
    }

    return AudioItem;
}(_InteractiveCatalogPageItem2.default);

exports.default = AudioItem;

},{"../InteractiveCatalogPageItem":37}],60:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _InteractiveCatalogPageItem = require('../InteractiveCatalogPageItem');

var _InteractiveCatalogPageItem2 = _interopRequireDefault(_InteractiveCatalogPageItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BrowserItem = function (_InteractiveCatalogPa) {
    _inherits(BrowserItem, _InteractiveCatalogPa);

    function BrowserItem() {
        _classCallCheck(this, BrowserItem);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BrowserItem).call(this));

        _this.url = '';
        _this.preLoad = false;
        return _this;
    }

    return BrowserItem;
}(_InteractiveCatalogPageItem2.default);

exports.default = BrowserItem;

},{"../InteractiveCatalogPageItem":37}],61:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _InteractiveCatalogPageItem = require('../InteractiveCatalogPageItem');

var _InteractiveCatalogPageItem2 = _interopRequireDefault(_InteractiveCatalogPageItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonItem = function (_InteractiveCatalogPa) {
    _inherits(ButtonItem, _InteractiveCatalogPa);

    function ButtonItem() {
        _classCallCheck(this, ButtonItem);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ButtonItem).call(this));

        _this.actions = [];
        return _this;
    }

    return ButtonItem;
}(_InteractiveCatalogPageItem2.default);

exports.default = ButtonItem;

},{"../InteractiveCatalogPageItem":37}],62:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _InteractiveCatalogPageItem = require('../InteractiveCatalogPageItem');

var _InteractiveCatalogPageItem2 = _interopRequireDefault(_InteractiveCatalogPageItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GalleryItem = function (_InteractiveCatalogPa) {
    _inherits(GalleryItem, _InteractiveCatalogPa);

    function GalleryItem() {
        _classCallCheck(this, GalleryItem);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GalleryItem).call(this));

        _this.paths = [];
        return _this;
    }

    return GalleryItem;
}(_InteractiveCatalogPageItem2.default);

exports.default = GalleryItem;

},{"../InteractiveCatalogPageItem":37}],63:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _InteractiveCatalogPageItem = require('../InteractiveCatalogPageItem');

var _InteractiveCatalogPageItem2 = _interopRequireDefault(_InteractiveCatalogPageItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImageButtonItem = function (_InteractiveCatalogPa) {
    _inherits(ImageButtonItem, _InteractiveCatalogPa);

    function ImageButtonItem() {
        _classCallCheck(this, ImageButtonItem);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ImageButtonItem).call(this));

        _this.normalPath = '';
        _this.actions = [];
        return _this;
    }

    _createClass(ImageButtonItem, [{
        key: 'clone',
        value: function clone() {
            var target = new ImageButtonItem();
            $.extend(target, this);
            return target;
        }
    }]);

    return ImageButtonItem;
}(_InteractiveCatalogPageItem2.default);

exports.default = ImageButtonItem;

},{"../InteractiveCatalogPageItem":37}],64:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _InteractiveCatalogPageItem = require('../InteractiveCatalogPageItem');

var _InteractiveCatalogPageItem2 = _interopRequireDefault(_InteractiveCatalogPageItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImageItem = function (_InteractiveCatalogPa) {
    _inherits(ImageItem, _InteractiveCatalogPa);

    function ImageItem() {
        _classCallCheck(this, ImageItem);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ImageItem).call(this));

        _this.path = '';
        return _this;
    }

    _createClass(ImageItem, [{
        key: 'clone',
        value: function clone() {
            var target = new ImageItem();
            $.extend(target, this);
            return target;
        }
    }]);

    return ImageItem;
}(_InteractiveCatalogPageItem2.default);

exports.default = ImageItem;

},{"../InteractiveCatalogPageItem":37}],65:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MultiStateObject = function MultiStateObject() {
    _classCallCheck(this, MultiStateObject);

    this.active = false;
    this.stateName = '';
    this.item = undefined;
};

exports.default = MultiStateObject;

},{}],66:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _InteractiveCatalogPageItem = require('../InteractiveCatalogPageItem');

var _InteractiveCatalogPageItem2 = _interopRequireDefault(_InteractiveCatalogPageItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MultiStateObjectItem = function (_InteractiveCatalogPa) {
    _inherits(MultiStateObjectItem, _InteractiveCatalogPa);

    function MultiStateObjectItem() {
        _classCallCheck(this, MultiStateObjectItem);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(MultiStateObjectItem).call(this));

        _this.stateObjects = [];

        _this._current = 0;
        return _this;
    }

    _createClass(MultiStateObjectItem, [{
        key: 'goToState',
        value: function goToState(stateName) {
            for (var i in this.stateObjects) {
                var stateObject = this.stateObjects[i];
                if (stateObject.stateName == stateName) {
                    this._current = i;
                    break;
                }
            }
        }
    }, {
        key: 'goToNextState',
        value: function goToNextState() {
            var stopInLast = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];

            if (this._current < this.stateObjects.length - 1) {
                this._current++;
            } else if (!stopInLast) {
                this._current = 0;
            }
        }
    }, {
        key: 'goToPreviousState',
        value: function goToPreviousState() {
            var stopInFirst = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];

            if (this._current > 0) {
                this._current--;
            } else if (!stopInFirst) {
                this._current = this.stateObjects.length - 1;
            }
        }
    }, {
        key: 'refresh',
        value: function refresh(itemDiv) {
            var currentStateName = this.stateObjects[this._current].stateName;

            for (var stateName in itemDiv._stateObjectDivs) {
                var stateObjectDiv = itemDiv._stateObjectDivs[stateName];
                stateObjectDiv.css('display', stateName == currentStateName ? '' : 'none');
            }
        }
    }]);

    return MultiStateObjectItem;
}(_InteractiveCatalogPageItem2.default);

exports.default = MultiStateObjectItem;

},{"../InteractiveCatalogPageItem":37}],67:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _InteractiveCatalogPageItem = require('../InteractiveCatalogPageItem');

var _InteractiveCatalogPageItem2 = _interopRequireDefault(_InteractiveCatalogPageItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PanoramaImageItem = function (_InteractiveCatalogPa) {
    _inherits(PanoramaImageItem, _InteractiveCatalogPa);

    function PanoramaImageItem() {
        _classCallCheck(this, PanoramaImageItem);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PanoramaImageItem).call(this));

        _this.path = '';
        _this.contentWidth = 0.0;
        _this.contentHeight = 0.0;
        return _this;
    }

    return PanoramaImageItem;
}(_InteractiveCatalogPageItem2.default);

exports.default = PanoramaImageItem;

},{"../InteractiveCatalogPageItem":37}],68:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _InteractiveCatalogPageItem = require('../InteractiveCatalogPageItem');

var _InteractiveCatalogPageItem2 = _interopRequireDefault(_InteractiveCatalogPageItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScrollImageItem = function (_InteractiveCatalogPa) {
    _inherits(ScrollImageItem, _InteractiveCatalogPa);

    function ScrollImageItem() {
        _classCallCheck(this, ScrollImageItem);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ScrollImageItem).call(this));

        _this.path = '';
        _this.contentWidth = 0.0;
        _this.contentHeight = 0.0;
        _this.showBars = false;
        return _this;
    }

    return ScrollImageItem;
}(_InteractiveCatalogPageItem2.default);

exports.default = ScrollImageItem;

},{"../InteractiveCatalogPageItem":37}],69:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _InteractiveCatalogPageItem = require('../InteractiveCatalogPageItem');

var _InteractiveCatalogPageItem2 = _interopRequireDefault(_InteractiveCatalogPageItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TouchAlphaImageItem = function (_InteractiveCatalogPa) {
    _inherits(TouchAlphaImageItem, _InteractiveCatalogPa);

    function TouchAlphaImageItem() {
        _classCallCheck(this, TouchAlphaImageItem);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TouchAlphaImageItem).call(this));

        _this.path = '';
        return _this;
    }

    return TouchAlphaImageItem;
}(_InteractiveCatalogPageItem2.default);

exports.default = TouchAlphaImageItem;

},{"../InteractiveCatalogPageItem":37}],70:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _InteractiveCatalogPageItem = require('../InteractiveCatalogPageItem');

var _InteractiveCatalogPageItem2 = _interopRequireDefault(_InteractiveCatalogPageItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TouchImageSequenceItem = function (_InteractiveCatalogPa) {
    _inherits(TouchImageSequenceItem, _InteractiveCatalogPa);

    function TouchImageSequenceItem() {
        _classCallCheck(this, TouchImageSequenceItem);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TouchImageSequenceItem).call(this));

        _this.paths = [];
        _this.loop = false;
        _this.direction = '';

        _this._images = [];
        _this._currentIndex = -1;
        return _this;
    }

    _createClass(TouchImageSequenceItem, [{
        key: 'clear',
        value: function clear() {
            this._images = [];
            this._currentIndex = -1;
        }
    }, {
        key: 'start',
        value: function start() {
            this._currentIndex = 0;
            this._images[this._currentIndex].show();
        }
    }, {
        key: 'goToNext',
        value: function goToNext() {
            this._images[this._currentIndex].hide();

            if (this._currentIndex < this._images.length - 1) {
                this._currentIndex++;
            } else if (this.loop) {
                this._currentIndex = 0;
            }

            this._images[this._currentIndex].show();
        }
    }, {
        key: 'goToPrevious',
        value: function goToPrevious() {
            this._images[this._currentIndex].hide();

            if (this._currentIndex > 0) {
                this._currentIndex--;
            } else if (this.loop) {
                this._currentIndex = this._images.length - 1;
            }

            this._images[this._currentIndex].show();
        }
    }]);

    return TouchImageSequenceItem;
}(_InteractiveCatalogPageItem2.default);

exports.default = TouchImageSequenceItem;

},{"../InteractiveCatalogPageItem":37}],71:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _InteractiveCatalogPageItem = require('../InteractiveCatalogPageItem');

var _InteractiveCatalogPageItem2 = _interopRequireDefault(_InteractiveCatalogPageItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VideoItem = function (_InteractiveCatalogPa) {
    _inherits(VideoItem, _InteractiveCatalogPa);

    function VideoItem() {
        _classCallCheck(this, VideoItem);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(VideoItem).call(this));

        _this.path = '';
        _this.loop = false;
        _this.autoPlay = false;
        _this.autoPlayAlways = false;
        _this.fullScreen = false;
        _this.controlsStyle = ''; // VideoControlsStyle
        return _this;
    }

    return VideoItem;
}(_InteractiveCatalogPageItem2.default);

exports.default = VideoItem;

},{"../InteractiveCatalogPageItem":37}],72:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _InteractiveCatalogPageItem = require('../InteractiveCatalogPageItem');

var _InteractiveCatalogPageItem2 = _interopRequireDefault(_InteractiveCatalogPageItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WebZipItem = function (_InteractiveCatalogPa) {
    _inherits(WebZipItem, _InteractiveCatalogPa);

    function WebZipItem() {
        _classCallCheck(this, WebZipItem);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(WebZipItem).call(this));

        _this.zipPath = '';
        _this.preLoad = false;
        return _this;
    }

    return WebZipItem;
}(_InteractiveCatalogPageItem2.default);

exports.default = WebZipItem;

},{"../InteractiveCatalogPageItem":37}],73:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
        value: true
});

var _CDSConfig = require('../model/CDSConfig');

var _CDSConfig2 = _interopRequireDefault(_CDSConfig);

var _CDSResponse = require('../model/CDSResponse');

var _CDSResponse2 = _interopRequireDefault(_CDSResponse);

var _CDSPublication = require('../model/CDSPublication');

var _CDSPublication2 = _interopRequireDefault(_CDSPublication);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CDSParser = function () {
        function CDSParser() {
                _classCallCheck(this, CDSParser);
        }

        _createClass(CDSParser, [{
                key: 'parseCDSConfig',
                value: function parseCDSConfig(data) {

                        var cdsConfig = new _CDSConfig2.default();

                        var xml = $(data);
                        var node = xml.children().first();

                        cdsConfig.cdsUrl = node.children('ns2\\:cdsUrl').text();
                        cdsConfig.cdsLibraryId = node.children('ns2\\:cdsLibraryId').text();
                        cdsConfig.cdsUseDefaultUsername = node.children('ns2\\:cdsUseDefaultUsername').text() == "true";

                        return cdsConfig;
                }
        }, {
                key: 'parseCDSResponse',
                value: function parseCDSResponse(data) {

                        var cdsResponse = new _CDSResponse2.default();

                        var xml = $(data);
                        var nodeResult = xml.children().first();

                        cdsResponse.code = nodeResult.attr('code');
                        cdsResponse.message = nodeResult.attr('message');

                        var nodePublications = nodeResult.children('publications');
                        nodePublications.children('publication').each(function (i, elem) {
                                var nodePublication = $(elem);
                                var cdsPublication = new _CDSPublication2.default();

                                cdsPublication.id = nodePublication.attr('id');
                                cdsPublication.name = nodePublication.attr('name');
                                cdsPublication.recursive = nodePublication.attr('recursive') == "true";

                                cdsResponse.publications[cdsPublication.id] = cdsPublication;
                        });

                        return cdsResponse;
                }
        }]);

        return CDSParser;
}();

exports.default = CDSParser;

},{"../model/CDSConfig":26,"../model/CDSPublication":27,"../model/CDSResponse":28}],74:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
        value: true
});

var _Library = require('../model/Library');

var _Library2 = _interopRequireDefault(_Library);

var _LibraryCatalog = require('../model/LibraryCatalog');

var _LibraryCatalog2 = _interopRequireDefault(_LibraryCatalog);

var _LibraryBanner = require('../model/LibraryBanner');

var _LibraryBanner2 = _interopRequireDefault(_LibraryBanner);

var _VisualTemplate = require('../model/VisualTemplate');

var _VisualTemplate2 = _interopRequireDefault(_VisualTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LibraryXMLParser = function () {
        function LibraryXMLParser() {
                _classCallCheck(this, LibraryXMLParser);
        }

        _createClass(LibraryXMLParser, [{
                key: 'parseLibrary',
                value: function parseLibrary(data) {
                        var _this = this;

                        var library = new _Library2.default();

                        var xml = $(data);
                        var nodeLibrary = xml.children().first();

                        library.libraryId = nodeLibrary.children('ns2\\:libraryId').text();
                        library.title = nodeLibrary.children('ns2\\:title').text();
                        library.horizontalIndex = nodeLibrary.children('ns2\\:horizontalIndex').text();
                        library.verticalIndex = nodeLibrary.children('ns2\\:verticalIndex').text();
                        library.compressedResources = nodeLibrary.children('ns2\\:compressedResources').text();
                        library.visualTemplate = this.parseVisualTemplate(nodeLibrary.children('ns2\\:visualTemplate'));
                        nodeLibrary.children('ns2\\:deviceLanguage').each(function (i, elem) {
                                library.deviceLanguageList.push($(elem).text());
                        });
                        library.defaultLanguage = nodeLibrary.children('ns2\\:defaultLanguage').text();
                        library.enableAnalytics = nodeLibrary.children('ns2\\:enableAnalytics').text();
                        library.analyticsWebId = nodeLibrary.children('ns2\\:analyticsWebId').text();
                        library.appUrl = nodeLibrary.children('ns2\\:appUrl').text();
                        library.indexSortType = nodeLibrary.children('ns2\\:indexSortType').text();
                        library.singleIssueApp = nodeLibrary.children('ns2\\:singleIssueApp').text() == 'true';
                        library.expandPagesXml = nodeLibrary.children('ns2\\:expandPagesXml').text() == 'true';

                        nodeLibrary.children('ns2\\:catalog').each(function (i, elem) {
                                var libraryCatalog = _this.parseLibraryCatalog(elem, library.visualTemplate);
                                library.catalogList.push(libraryCatalog);
                        });

                        return library;
                }
        }, {
                key: 'parseIntelligentFolder',
                value: function parseIntelligentFolder(data, visualTemplate) {

                        var xml = $(data);
                        var nodeIntelligentFolder = xml.children().first();
                        return this.parseLibraryCatalog(nodeIntelligentFolder, visualTemplate, '');
                }
        }, {
                key: 'parseVisualTemplate',
                value: function parseVisualTemplate(data) {
                        var _this2 = this;

                        var visualTemplate = new _VisualTemplate2.default();

                        var nodeVisualTemplate = $(data);

                        nodeVisualTemplate.children('ns2\\:horizontalBanner').each(function (i, elem) {
                                var libraryBanner = _this2.parseLibraryBanner(elem);
                                visualTemplate.horizontalBanner.push(libraryBanner);
                        });
                        nodeVisualTemplate.children('ns2\\:verticalBanner').each(function (i, elem) {
                                var libraryBanner = _this2.parseLibraryBanner(elem);
                                visualTemplate.verticalBanner.push(libraryBanner);
                        });
                        visualTemplate.bannerInterval = nodeVisualTemplate.children('ns2\\:bannerInterval').text();

                        nodeVisualTemplate.children('ns2\\:horizontalLibraryInfoImage').each(function (i, elem) {
                                visualTemplate.horizontalLibraryInfoImages.push($(elem).text());
                        });
                        nodeVisualTemplate.children('ns2\\:verticalLibraryInfoImage').each(function (i, elem) {
                                visualTemplate.verticalLibraryInfoImages.push($(elem).text());
                        });

                        visualTemplate.showExitButton = nodeVisualTemplate.children('ns2\\:showExitButton').text() == "true";
                        visualTemplate.showIndexButton = nodeVisualTemplate.children('ns2\\:showIndexButton').text() == "true";
                        visualTemplate.showPageSlider = nodeVisualTemplate.children('ns2\\:showPageSlider').text() == "true";
                        visualTemplate.showBookmarksButton = nodeVisualTemplate.children('ns2\\:showBookmarksButton').text() == "true";
                        visualTemplate.showCatalogMenu = nodeVisualTemplate.children('ns2\\:showCatalogMenu').text() == "true";
                        visualTemplate.showShareButton = nodeVisualTemplate.children('ns2\\:showShareButton').text() == "true";
                        visualTemplate.showSearchButton = nodeVisualTemplate.children('ns2\\:showSearchButton').text() == "true";
                        visualTemplate.showChangeLanguageButton = nodeVisualTemplate.children('ns2\\:showChangeLanguageButton').text() == "true";

                        visualTemplate.toolbarTintColor = this.parseColor(nodeVisualTemplate.children('ns2\\:toolbarTintColor'), '#000000');
                        visualTemplate.toolbarTintSecondaryColor = this.parseColor(nodeVisualTemplate.children('ns2\\:toolbarTintSecondaryColor'), '#00A99D');
                        visualTemplate.toolbarBackgroundColor = this.parseColor(nodeVisualTemplate.children('ns2\\:toolbarBackgroundColor'), '#F2F2F2');
                        visualTemplate.listCatalogsBackgroundColor = this.parseColor(nodeVisualTemplate.children('ns2\\:listCatalogsBackgroundColor'), '#4D4D4D');
                        visualTemplate.catalogTitleColor = this.parseColor(nodeVisualTemplate.children('ns2\\:catalogTitleColor'), '#FFFFFF');
                        visualTemplate.catalogDescriptionColor = this.parseColor(nodeVisualTemplate.children('ns2\\:catalogDescriptionColor'), '#B3B3B3');
                        visualTemplate.catalogButtonColor = this.parseColor(nodeVisualTemplate.children('ns2\\:catalogButtonColor'), '#FFFFFF');
                        visualTemplate.separatorLineColor = this.parseColor(nodeVisualTemplate.children('ns2\\:separatorLineColor'), '#FFFFFF');

                        return visualTemplate;
                }
        }, {
                key: 'parseLibraryBanner',
                value: function parseLibraryBanner(data) {
                        var prefix = arguments.length <= 1 || arguments[1] === undefined ? 'ns2\\:' : arguments[1];

                        var libraryBanner = new _LibraryBanner2.default();

                        var nodeLibraryBanner = $(data);

                        libraryBanner.image = nodeLibraryBanner.children(prefix + 'image').text();
                        libraryBanner.url = nodeLibraryBanner.children(prefix + 'url').text();
                        libraryBanner.width = nodeLibraryBanner.children(prefix + 'width').text();
                        libraryBanner.height = nodeLibraryBanner.children(prefix + 'height').text();
                        libraryBanner.language = nodeLibraryBanner.children(prefix + 'language').text();

                        return libraryBanner;
                }
        }, {
                key: 'parseLibraryCatalog',
                value: function parseLibraryCatalog(data, visualTemplate) {
                        var _this3 = this;

                        var prefix = arguments.length <= 2 || arguments[2] === undefined ? 'ns2\\:' : arguments[2];

                        var libraryCatalog = new _LibraryCatalog2.default();

                        var nodeLibraryCatalog = $(data);

                        libraryCatalog.catalogId = nodeLibraryCatalog.children(prefix + 'catalogId').text();
                        libraryCatalog.title = nodeLibraryCatalog.children(prefix + 'title').text();
                        libraryCatalog.subtitle = nodeLibraryCatalog.children(prefix + 'subtitle').text();
                        libraryCatalog.catalogType = nodeLibraryCatalog.children(prefix + 'catalogType').text();
                        libraryCatalog.catalogVideoType = nodeLibraryCatalog.children(prefix + 'catalogVideoType').text();
                        libraryCatalog.catalogWebType = nodeLibraryCatalog.children(prefix + 'catalogWebType').text();
                        libraryCatalog.url = nodeLibraryCatalog.children(prefix + 'url').text();
                        libraryCatalog.path = nodeLibraryCatalog.children(prefix + 'path').text();

                        nodeLibraryCatalog.children(prefix + 'child').each(function (i, elem) {
                                var child = _this3.parseLibraryCatalog(elem, visualTemplate, prefix);
                                libraryCatalog.childList.push(child);
                                child._parent = libraryCatalog;
                        });

                        libraryCatalog.fullscreen = nodeLibraryCatalog.children(prefix + 'fullscreen').text();
                        libraryCatalog.horizontalImage = nodeLibraryCatalog.children(prefix + 'horizontalImage').text();
                        libraryCatalog.verticalImage = nodeLibraryCatalog.children(prefix + 'verticalImage').text();

                        nodeLibraryCatalog.children(prefix + 'deviceLanguage').each(function (i, elem) {
                                libraryCatalog.deviceLanguage.push($(elem).text());
                        });

                        nodeLibraryCatalog.children(prefix + 'deviceType').each(function (i, elem) {
                                libraryCatalog.deviceType.push($(elem).text());
                        });

                        libraryCatalog.publishDate = new Date(nodeLibraryCatalog.children(prefix + 'publishDate').text());
                        libraryCatalog.useAsRoot = nodeLibraryCatalog.children(prefix + 'useAsRoot').text() == "true";

                        nodeLibraryCatalog.children(prefix + 'horizontalBanner').each(function (i, elem) {
                                var libraryBanner = _this3.parseLibraryBanner(elem, prefix);
                                libraryCatalog.horizontalBanner.push(libraryBanner);
                        });
                        nodeLibraryCatalog.children(prefix + 'verticalBanner').each(function (i, elem) {
                                var libraryBanner = _this3.parseLibraryBanner(elem, prefix);
                                libraryCatalog.verticalBanner.push(libraryBanner);
                        });
                        libraryCatalog.bannerInterval = nodeLibraryCatalog.children(prefix + 'bannerInterval').text();

                        var showExitButton = nodeLibraryCatalog.children(prefix + 'showExitButton').text();
                        libraryCatalog.showExitButton = showExitButton == '' ? visualTemplate.showExitButton : showExitButton == "true";

                        var showIndexButton = nodeLibraryCatalog.children(prefix + 'showIndexButton').text();
                        libraryCatalog.showIndexButton = showIndexButton == '' ? visualTemplate.showIndexButton : showIndexButton == "true";

                        var showPageSlider = nodeLibraryCatalog.children(prefix + 'showPageSlider').text();
                        libraryCatalog.showPageSlider = showPageSlider == '' ? visualTemplate.showPageSlider : showPageSlider == "true";

                        var showBookmarksButton = nodeLibraryCatalog.children(prefix + 'showBookmarksButton').text();
                        libraryCatalog.showBookmarksButton = showBookmarksButton == '' ? visualTemplate.showBookmarksButton : showBookmarksButton == "true";

                        var showCatalogMenu = nodeLibraryCatalog.children(prefix + 'showCatalogMenu').text();
                        libraryCatalog.showCatalogMenu = showCatalogMenu == '' ? visualTemplate.showCatalogMenu : showCatalogMenu == "true";

                        var showShareButton = nodeLibraryCatalog.children(prefix + 'showShareButton').text();
                        libraryCatalog.showShareButton = showShareButton == '' ? visualTemplate.showShareButton : showShareButton == "true";

                        libraryCatalog.changePageMode = nodeLibraryCatalog.children(prefix + 'changePageMode').text();

                        libraryCatalog.intelligentFolderUrl = nodeLibraryCatalog.children(prefix + 'intelligentFolderUrl').text();

                        return libraryCatalog;
                }
        }, {
                key: 'parseColor',
                value: function parseColor(node) {
                        var defaultColor = arguments.length <= 1 || arguments[1] === undefined ? '#FFFFFF' : arguments[1];

                        var colorString = node.text();

                        if (!colorString || colorString.length == 0) return defaultColor;

                        if (colorString.charAt(0) == '#') colorString = colorString.slice(1);

                        var bytes = [];
                        while (colorString.length >= 2) {
                                bytes.push(parseInt(colorString.slice(0, 2), 16));
                                colorString = colorString.slice(2);
                        }

                        var r = bytes[0] ? bytes[0] : 0;
                        var g = bytes[1] ? bytes[1] : 0;
                        var b = bytes[2] ? bytes[2] : 0;
                        var a = bytes[3] ? bytes[3] / 255 : 1;

                        var color = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';

                        return color;
                }
        }]);

        return LibraryXMLParser;
}();

exports.default = LibraryXMLParser;

},{"../model/Library":29,"../model/LibraryBanner":30,"../model/LibraryCatalog":31,"../model/VisualTemplate":32}],75:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _InteractiveCatalogIndexPage = require('../../model/interactive/InteractiveCatalogIndexPage');

var _InteractiveCatalogIndexPage2 = _interopRequireDefault(_InteractiveCatalogIndexPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InteractiveCatalogIndexPageParser = function () {
    function InteractiveCatalogIndexPageParser() {
        _classCallCheck(this, InteractiveCatalogIndexPageParser);
    }

    _createClass(InteractiveCatalogIndexPageParser, null, [{
        key: 'parse',
        value: function parse(node) {
            var interactiveCatalogIndexPage = new _InteractiveCatalogIndexPage2.default();

            interactiveCatalogIndexPage.horizontalIndexImage = node.children('ns2\\:horizontalIndexImage').text();
            interactiveCatalogIndexPage.verticalIndexImage = node.children('ns2\\:verticalIndexImage').text();
            interactiveCatalogIndexPage.numPage = parseInt(node.children('ns2\\:numPage').text());
            interactiveCatalogIndexPage.title = node.children('ns2\\:title').text();
            interactiveCatalogIndexPage.description = node.children('ns2\\:description').text();

            return interactiveCatalogIndexPage;
        }
    }]);

    return InteractiveCatalogIndexPageParser;
}();

exports.default = InteractiveCatalogIndexPageParser;

},{"../../model/interactive/InteractiveCatalogIndexPage":35}],76:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _InteractiveCatalogPageItem = require('../../model/interactive/InteractiveCatalogPageItem');

var _InteractiveCatalogPageItem2 = _interopRequireDefault(_InteractiveCatalogPageItem);

var _ImageItem = require('../../model/interactive/items/ImageItem');

var _ImageItem2 = _interopRequireDefault(_ImageItem);

var _ButtonItem = require('../../model/interactive/items/ButtonItem');

var _ButtonItem2 = _interopRequireDefault(_ButtonItem);

var _ImageButtonItem = require('../../model/interactive/items/ImageButtonItem');

var _ImageButtonItem2 = _interopRequireDefault(_ImageButtonItem);

var _AudioItem = require('../../model/interactive/items/AudioItem');

var _AudioItem2 = _interopRequireDefault(_AudioItem);

var _VideoItem = require('../../model/interactive/items/VideoItem');

var _VideoItem2 = _interopRequireDefault(_VideoItem);

var _ScrollImageItem = require('../../model/interactive/items/ScrollImageItem');

var _ScrollImageItem2 = _interopRequireDefault(_ScrollImageItem);

var _GalleryItem = require('../../model/interactive/items/GalleryItem');

var _GalleryItem2 = _interopRequireDefault(_GalleryItem);

var _AnimatedImageItem = require('../../model/interactive/items/AnimatedImageItem');

var _AnimatedImageItem2 = _interopRequireDefault(_AnimatedImageItem);

var _WebZipItem = require('../../model/interactive/items/WebZipItem');

var _WebZipItem2 = _interopRequireDefault(_WebZipItem);

var _BrowserItem = require('../../model/interactive/items/BrowserItem');

var _BrowserItem2 = _interopRequireDefault(_BrowserItem);

var _MultiStateObjectItem = require('../../model/interactive/items/MultiStateObjectItem');

var _MultiStateObjectItem2 = _interopRequireDefault(_MultiStateObjectItem);

var _MultiStateObject = require('../../model/interactive/items/MultiStateObject');

var _MultiStateObject2 = _interopRequireDefault(_MultiStateObject);

var _PanoramaImageItem = require('../../model/interactive/items/PanoramaImageItem');

var _PanoramaImageItem2 = _interopRequireDefault(_PanoramaImageItem);

var _TouchAlphaImageItem = require('../../model/interactive/items/TouchAlphaImageItem');

var _TouchAlphaImageItem2 = _interopRequireDefault(_TouchAlphaImageItem);

var _TouchImageSequenceItem = require('../../model/interactive/items/TouchImageSequenceItem');

var _TouchImageSequenceItem2 = _interopRequireDefault(_TouchImageSequenceItem);

var _ItemActionParser = require('./ItemActionParser');

var _ItemActionParser2 = _interopRequireDefault(_ItemActionParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InteractiveCatalogPageItemParser = function () {
    function InteractiveCatalogPageItemParser() {
        _classCallCheck(this, InteractiveCatalogPageItemParser);
    }

    _createClass(InteractiveCatalogPageItemParser, null, [{
        key: 'parse',
        value: function parse(node) {
            var interactiveCatalogPageItem = new _InteractiveCatalogPageItem2.default();

            var type = node.attr('xsi:type');
            switch (type) {
                case 'ns2:ImageItem':
                    interactiveCatalogPageItem = new _ImageItem2.default();
                    interactiveCatalogPageItem.path = node.children('ns2\\:path').text();
                    break;
                case 'ns2:ButtonItem':
                    interactiveCatalogPageItem = new _ButtonItem2.default();
                    node.children('ns2\\:action').each(function (i, elem) {
                        interactiveCatalogPageItem.actions.push(_ItemActionParser2.default.parse($(elem)));
                    });
                    break;
                case 'ns2:ImageButtonItem':
                    interactiveCatalogPageItem = new _ImageButtonItem2.default();
                    interactiveCatalogPageItem.normalPath = node.children('ns2\\:normalPath').text();
                    node.children('ns2\\:action').each(function (i, elem) {
                        interactiveCatalogPageItem.actions.push(_ItemActionParser2.default.parse($(elem)));
                    });
                    break;
                case 'ns2:AudioItem':
                    interactiveCatalogPageItem = new _AudioItem2.default();
                    interactiveCatalogPageItem.path = node.children('ns2\\:path').text();
                    interactiveCatalogPageItem.loop = node.children('ns2\\:loop').text() == 'true';
                    interactiveCatalogPageItem.autoPlay = node.children('ns2\\:autoPlay').text() == 'true';
                    interactiveCatalogPageItem.stopOnPageTurn = node.children('ns2\\:stopOnPageTurn').text() == 'true';
                    break;
                case 'ns2:VideoItem':
                    interactiveCatalogPageItem = new _VideoItem2.default();
                    interactiveCatalogPageItem.path = node.children('ns2\\:path').text();
                    interactiveCatalogPageItem.loop = node.children('ns2\\:loop').text() == 'true';
                    interactiveCatalogPageItem.autoPlay = node.children('ns2\\:autoPlay').text() == 'true';
                    interactiveCatalogPageItem.autoPlayAlways = node.children('ns2\\:autoPlayAlways').text() == 'true';
                    interactiveCatalogPageItem.fullScreen = node.children('ns2\\:fullScreen').text() == 'true';
                    interactiveCatalogPageItem.controlsStyle = node.children('ns2\\:controlsStyle').text();
                    break;
                case 'ns2:ScrollImageItem':
                    interactiveCatalogPageItem = new _ScrollImageItem2.default();
                    interactiveCatalogPageItem.path = node.children('ns2\\:path').text();
                    interactiveCatalogPageItem.contentWidth = InteractiveCatalogPageItemParser.parseLayoutNumericValue(node.children('ns2\\:contentWidth'));
                    interactiveCatalogPageItem.contentHeight = InteractiveCatalogPageItemParser.parseLayoutNumericValue(node.children('ns2\\:contentHeight'));
                    interactiveCatalogPageItem.showBars = node.children('ns2\\:showBars').text() == 'true';
                    break;
                case 'ns2:GalleryItem':
                    interactiveCatalogPageItem = new _GalleryItem2.default();
                    node.children('ns2\\:path').each(function (i, elem) {
                        interactiveCatalogPageItem.paths.push($(elem).text());
                    });
                    break;
                case 'ns2:AnimatedImageItem':
                    interactiveCatalogPageItem = new _AnimatedImageItem2.default();
                    node.children('ns2\\:path').each(function (i, elem) {
                        interactiveCatalogPageItem.paths.push($(elem).text());
                    });
                    interactiveCatalogPageItem.step = parseFloat(node.children('ns2\\:step').text());
                    interactiveCatalogPageItem.loop = node.children('ns2\\:loop').text() == 'true';
                    break;
                case 'ns2:WebZipItem':
                    interactiveCatalogPageItem = new _WebZipItem2.default();
                    interactiveCatalogPageItem.zipPath = node.children('ns2\\:zipPath').text();
                    interactiveCatalogPageItem.preLoad = node.children('ns2\\:preLoad').text() == 'true';
                    break;
                case 'ns2:BrowserItem':
                    interactiveCatalogPageItem = new _BrowserItem2.default();
                    interactiveCatalogPageItem.url = node.children('ns2\\:url').text();
                    interactiveCatalogPageItem.preLoad = node.children('ns2\\:preLoad').text() == 'true';
                    break;
                case 'ns2:MultiStateObjectItem':
                    interactiveCatalogPageItem = new _MultiStateObjectItem2.default();
                    node.children('ns2\\:stateObject').each(function (i, elem) {
                        var node = $(elem);
                        var stateObject = new _MultiStateObject2.default();
                        stateObject.active = node.children('ns2\\:active').text() == 'true';
                        stateObject.stateName = node.children('ns2\\:stateName').text();
                        stateObject.item = InteractiveCatalogPageItemParser.parse(node.children('ns2\\:item'));
                        interactiveCatalogPageItem.stateObjects.push(stateObject);
                    });
                    break;
                case 'ns2:PanoramaImageItem':
                    interactiveCatalogPageItem = new _PanoramaImageItem2.default();
                    interactiveCatalogPageItem.path = node.children('ns2\\:path').text();
                    interactiveCatalogPageItem.contentWidth = InteractiveCatalogPageItemParser.parseLayoutNumericValue(node.children('ns2\\:contentWidth'));
                    interactiveCatalogPageItem.contentHeight = InteractiveCatalogPageItemParser.parseLayoutNumericValue(node.children('ns2\\:contentHeight'));
                    break;
                case 'ns2:TouchAlphaImageItem':
                    interactiveCatalogPageItem = new _TouchAlphaImageItem2.default();
                    interactiveCatalogPageItem.path = node.children('ns2\\:path').text();
                    break;
                case 'ns2:TouchImageSequenceItem':
                    interactiveCatalogPageItem = new _TouchImageSequenceItem2.default();
                    node.children('ns2\\:path').each(function (i, elem) {
                        interactiveCatalogPageItem.paths.push($(elem).text());
                    });
                    interactiveCatalogPageItem.loop = node.children('ns2\\:loop').text() == 'true';
                    interactiveCatalogPageItem.direction = node.children('ns2\\:direction').text();
                    break;
            }

            interactiveCatalogPageItem.itemId = parseInt(node.children('ns2\\:itemId').text());
            interactiveCatalogPageItem.itemName = node.children('ns2\\:itemName').text();

            interactiveCatalogPageItem.left = InteractiveCatalogPageItemParser.parseLayoutNumericValue(node.children('ns2\\:left'));
            interactiveCatalogPageItem.top = InteractiveCatalogPageItemParser.parseLayoutNumericValue(node.children('ns2\\:top'));
            interactiveCatalogPageItem.width = InteractiveCatalogPageItemParser.parseLayoutNumericValue(node.children('ns2\\:width'));
            interactiveCatalogPageItem.height = InteractiveCatalogPageItemParser.parseLayoutNumericValue(node.children('ns2\\:height'));

            interactiveCatalogPageItem.hidden = node.children('ns2\\:hidden').text() == 'true';
            interactiveCatalogPageItem.draggable = node.children('ns2\\:draggable').text() == 'true';
            interactiveCatalogPageItem.clonable = node.children('ns2\\:clonable').text() == 'true';

            node.children('ns2\\:deviceLanguage').each(function (i, elem) {
                // TODO: Parsear nodos
                interactiveCatalogPageItem.deviceLanguages.push($(elem).text());
            });

            node.children('ns2\\:deviceType').each(function (i, elem) {
                // TODO: Parsear nodos
                interactiveCatalogPageItem.deviceTypes.push($(elem).text());
            });

            return interactiveCatalogPageItem;
        }
    }, {
        key: 'parseLayoutNumericValue',
        value: function parseLayoutNumericValue(node) {
            return parseFloat(parseFloat(node.attr('value')));
        }
    }]);

    return InteractiveCatalogPageItemParser;
}();

exports.default = InteractiveCatalogPageItemParser;

},{"../../model/interactive/InteractiveCatalogPageItem":37,"../../model/interactive/items/AnimatedImageItem":58,"../../model/interactive/items/AudioItem":59,"../../model/interactive/items/BrowserItem":60,"../../model/interactive/items/ButtonItem":61,"../../model/interactive/items/GalleryItem":62,"../../model/interactive/items/ImageButtonItem":63,"../../model/interactive/items/ImageItem":64,"../../model/interactive/items/MultiStateObject":65,"../../model/interactive/items/MultiStateObjectItem":66,"../../model/interactive/items/PanoramaImageItem":67,"../../model/interactive/items/ScrollImageItem":68,"../../model/interactive/items/TouchAlphaImageItem":69,"../../model/interactive/items/TouchImageSequenceItem":70,"../../model/interactive/items/VideoItem":71,"../../model/interactive/items/WebZipItem":72,"./ItemActionParser":80}],77:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
        value: true
});

var _InteractiveCatalogPageLayer = require('../../model/interactive/InteractiveCatalogPageLayer');

var _InteractiveCatalogPageLayer2 = _interopRequireDefault(_InteractiveCatalogPageLayer);

var _InteractiveCatalogPageItemParser = require('./InteractiveCatalogPageItemParser');

var _InteractiveCatalogPageItemParser2 = _interopRequireDefault(_InteractiveCatalogPageItemParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InteractiveCatalogPageLayerParser = function () {
        function InteractiveCatalogPageLayerParser() {
                _classCallCheck(this, InteractiveCatalogPageLayerParser);
        }

        _createClass(InteractiveCatalogPageLayerParser, null, [{
                key: 'parse',
                value: function parse(node) {
                        var interactiveCatalogPageLayer = new _InteractiveCatalogPageLayer2.default();

                        interactiveCatalogPageLayer.name = node.children('ns2\\:name').text();

                        node.children('ns2\\:item').each(function (i, elem) {
                                interactiveCatalogPageLayer.items.push(_InteractiveCatalogPageItemParser2.default.parse($(elem)));
                        });

                        interactiveCatalogPageLayer.hidden = node.children('ns2\\:hidden').text() == 'true';

                        return interactiveCatalogPageLayer;
                }
        }]);

        return InteractiveCatalogPageLayerParser;
}();

exports.default = InteractiveCatalogPageLayerParser;

},{"../../model/interactive/InteractiveCatalogPageLayer":38,"./InteractiveCatalogPageItemParser":76}],78:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
        value: true
});

var _InteractiveCatalogPage = require('../../model/interactive/InteractiveCatalogPage');

var _InteractiveCatalogPage2 = _interopRequireDefault(_InteractiveCatalogPage);

var _CanvasDimension = require('../../model/interactive/CanvasDimension');

var _CanvasDimension2 = _interopRequireDefault(_CanvasDimension);

var _InteractiveCatalogPageLayerParser = require('./InteractiveCatalogPageLayerParser');

var _InteractiveCatalogPageLayerParser2 = _interopRequireDefault(_InteractiveCatalogPageLayerParser);

var _ItemActionParser = require('./ItemActionParser');

var _ItemActionParser2 = _interopRequireDefault(_ItemActionParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InteractiveCatalogPageParser = function () {
        function InteractiveCatalogPageParser() {
                _classCallCheck(this, InteractiveCatalogPageParser);
        }

        _createClass(InteractiveCatalogPageParser, null, [{
                key: 'parse',
                value: function parse(node) {
                        var interactiveCatalogPage = new _InteractiveCatalogPage2.default();

                        interactiveCatalogPage.pageId = node.children('ns2\\:pageId').text();
                        interactiveCatalogPage.title = node.children('ns2\\:title').text();
                        interactiveCatalogPage.description = node.children('ns2\\:description').text();

                        interactiveCatalogPage.horizontalIndexImage = node.children('ns2\\:horizontalIndexImage').text();
                        interactiveCatalogPage.verticalIndexImage = node.children('ns2\\:verticalIndexImage').text();

                        node.children('ns2\\:horizontalLayer').each(function (i, elem) {
                                interactiveCatalogPage.horizontalLayers.push(_InteractiveCatalogPageLayerParser2.default.parse($(elem)));
                        });

                        node.children('ns2\\:verticalLayer').each(function (i, elem) {
                                interactiveCatalogPage.verticalLayers.push(_InteractiveCatalogPageLayerParser2.default.parse($(elem)));
                        });

                        node.children('ns2\\:universalLayer').each(function (i, elem) {
                                interactiveCatalogPage.universalLayers.push(_InteractiveCatalogPageLayerParser2.default.parse($(elem)));
                        });

                        interactiveCatalogPage.horizontalSize = InteractiveCatalogPageParser.parseCanvasDimension(node.children('ns2\\:horizontalSize'));
                        interactiveCatalogPage.verticalSize = InteractiveCatalogPageParser.parseCanvasDimension(node.children('ns2\\:verticalSize'));
                        interactiveCatalogPage.universalSize = InteractiveCatalogPageParser.parseCanvasDimension(node.children('ns2\\:universalSize'));

                        node.children('ns2\\:openPageActions').each(function (i, elem) {
                                interactiveCatalogPage.openPageActions.push(_ItemActionParser2.default.parse($(elem)));
                        });

                        interactiveCatalogPage.horizontalChangePageMode = node.children('ns2\\:horizontalChangePageMode').text();
                        interactiveCatalogPage.verticalChangePageMode = node.children('ns2\\:verticalChangePageMode').text();

                        interactiveCatalogPage.horizontalPageVerticalScrollPager = false;
                        interactiveCatalogPage.verticalPageVerticalScrollPager = false;

                        interactiveCatalogPage.backgroundColor = node.children('ns2\\:backgroundColor').text();

                        return interactiveCatalogPage;
                }
        }, {
                key: 'parseCanvasDimension',
                value: function parseCanvasDimension(node) {
                        if (node.length > 0) {
                                var canvasDimension = new _CanvasDimension2.default();
                                canvasDimension.width = parseFloat(node.attr('width'));
                                canvasDimension.height = parseFloat(node.attr('height'));
                                return canvasDimension;
                        }
                        return undefined;
                }
        }]);

        return InteractiveCatalogPageParser;
}();

exports.default = InteractiveCatalogPageParser;

},{"../../model/interactive/CanvasDimension":33,"../../model/interactive/InteractiveCatalogPage":36,"./InteractiveCatalogPageLayerParser":77,"./ItemActionParser":80}],79:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
        value: true
});

var _InteractiveCatalog = require('../../model/interactive/InteractiveCatalog');

var _InteractiveCatalog2 = _interopRequireDefault(_InteractiveCatalog);

var _CanvasDimension = require('../../model/interactive/CanvasDimension');

var _CanvasDimension2 = _interopRequireDefault(_CanvasDimension);

var _InteractiveCatalogPageParser = require('./InteractiveCatalogPageParser');

var _InteractiveCatalogPageParser2 = _interopRequireDefault(_InteractiveCatalogPageParser);

var _InteractiveCatalogIndexPageParser = require('./InteractiveCatalogIndexPageParser');

var _InteractiveCatalogIndexPageParser2 = _interopRequireDefault(_InteractiveCatalogIndexPageParser);

var _ItemActionParser = require('./ItemActionParser');

var _ItemActionParser2 = _interopRequireDefault(_ItemActionParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InteractiveCatalogParser = function () {
        function InteractiveCatalogParser() {
                _classCallCheck(this, InteractiveCatalogParser);
        }

        _createClass(InteractiveCatalogParser, [{
                key: 'parse',
                value: function parse(data) {

                        var interactiveCatalog = new _InteractiveCatalog2.default();

                        var xml = $(data);
                        var rootNode = xml.children().first();

                        interactiveCatalog.catalogId = rootNode.children('ns2\\:catalogId').text();
                        interactiveCatalog.title = rootNode.children('ns2\\:title').text();
                        interactiveCatalog.navigationType = rootNode.children('ns2\\:navigationType').text();
                        interactiveCatalog.firstPageLeft = rootNode.children('ns2\\:firstPageLeft').text() == 'true';
                        interactiveCatalog.horizontalSize = InteractiveCatalogParser.parseCanvasDimension(rootNode.children('ns2\\:horizontalSize'));
                        interactiveCatalog.verticalSize = InteractiveCatalogParser.parseCanvasDimension(rootNode.children('ns2\\:verticalSize'));
                        interactiveCatalog.universalSize = InteractiveCatalogParser.parseCanvasDimension(rootNode.children('ns2\\:universalSize'));

                        rootNode.children('ns2\\:page').each(function (i, elem) {
                                interactiveCatalog.pages.push(_InteractiveCatalogPageParser2.default.parse($(elem)));
                        });

                        rootNode.children('ns2\\:indexPage').each(function (i, elem) {
                                interactiveCatalog.indexPages.push(_InteractiveCatalogIndexPageParser2.default.parse($(elem)));
                        });

                        interactiveCatalog.numPages = parseInt(rootNode.children('ns2\\:numPages').text());
                        interactiveCatalog.indexNumPage = parseInt(rootNode.children('ns2\\:indexNumPage').text());
                        interactiveCatalog.fullScreen = rootNode.children('ns2\\:fullScreen').text() == 'true';
                        interactiveCatalog.horizontalAlignmentType = rootNode.children('ns2\\:horizontalAlignmentType').text();

                        rootNode.children('ns2\\:openAction').each(function (i, elem) {
                                interactiveCatalog.openActions.push(_ItemActionParser2.default.parse($(elem)));
                        });

                        interactiveCatalog.indexType = rootNode.children('ns2\\:indexType').text();
                        interactiveCatalog.backgroundColor = rootNode.children('ns2\\:backgroundColor').text();

                        return interactiveCatalog;
                }
        }], [{
                key: 'parseCanvasDimension',
                value: function parseCanvasDimension(node) {
                        if (node.length > 0) {
                                var canvasDimension = new _CanvasDimension2.default();
                                canvasDimension.width = parseFloat(node.attr('width'));
                                canvasDimension.height = parseFloat(node.attr('height'));
                                return canvasDimension;
                        }
                        return undefined;
                }
        }]);

        return InteractiveCatalogParser;
}();

exports.default = InteractiveCatalogParser;

},{"../../model/interactive/CanvasDimension":33,"../../model/interactive/InteractiveCatalog":34,"./InteractiveCatalogIndexPageParser":75,"./InteractiveCatalogPageParser":78,"./ItemActionParser":80}],80:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ItemAction = require('../../model/interactive/actions/ItemAction');

var _ItemAction2 = _interopRequireDefault(_ItemAction);

var _GoToPageAction = require('../../model/interactive/actions/GoToPageAction');

var _GoToPageAction2 = _interopRequireDefault(_GoToPageAction);

var _HideItemAction = require('../../model/interactive/actions/HideItemAction');

var _HideItemAction2 = _interopRequireDefault(_HideItemAction);

var _ShowItemAction = require('../../model/interactive/actions/ShowItemAction');

var _ShowItemAction2 = _interopRequireDefault(_ShowItemAction);

var _OpenWebAction = require('../../model/interactive/actions/OpenWebAction');

var _OpenWebAction2 = _interopRequireDefault(_OpenWebAction);

var _PlayAudioAction = require('../../model/interactive/actions/PlayAudioAction');

var _PlayAudioAction2 = _interopRequireDefault(_PlayAudioAction);

var _PauseAudioAction = require('../../model/interactive/actions/PauseAudioAction');

var _PauseAudioAction2 = _interopRequireDefault(_PauseAudioAction);

var _ResumeAudioAction = require('../../model/interactive/actions/ResumeAudioAction');

var _ResumeAudioAction2 = _interopRequireDefault(_ResumeAudioAction);

var _StopAudioAction = require('../../model/interactive/actions/StopAudioAction');

var _StopAudioAction2 = _interopRequireDefault(_StopAudioAction);

var _PlayMovieAction = require('../../model/interactive/actions/PlayMovieAction');

var _PlayMovieAction2 = _interopRequireDefault(_PlayMovieAction);

var _PauseMovieAction = require('../../model/interactive/actions/PauseMovieAction');

var _PauseMovieAction2 = _interopRequireDefault(_PauseMovieAction);

var _ResumeMovieAction = require('../../model/interactive/actions/ResumeMovieAction');

var _ResumeMovieAction2 = _interopRequireDefault(_ResumeMovieAction);

var _StopMovieAction = require('../../model/interactive/actions/StopMovieAction');

var _StopMovieAction2 = _interopRequireDefault(_StopMovieAction);

var _ToggleMenuAction = require('../../model/interactive/actions/ToggleMenuAction');

var _ToggleMenuAction2 = _interopRequireDefault(_ToggleMenuAction);

var _ExitCatalogAction = require('../../model/interactive/actions/ExitCatalogAction');

var _ExitCatalogAction2 = _interopRequireDefault(_ExitCatalogAction);

var _GoToStateAction = require('../../model/interactive/actions/GoToStateAction');

var _GoToStateAction2 = _interopRequireDefault(_GoToStateAction);

var _GoToNextStateAction = require('../../model/interactive/actions/GoToNextStateAction');

var _GoToNextStateAction2 = _interopRequireDefault(_GoToNextStateAction);

var _GoToPreviousStateAction = require('../../model/interactive/actions/GoToPreviousStateAction');

var _GoToPreviousStateAction2 = _interopRequireDefault(_GoToPreviousStateAction);

var _OpenCatalogAction = require('../../model/interactive/actions/OpenCatalogAction');

var _OpenCatalogAction2 = _interopRequireDefault(_OpenCatalogAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ItemActionParser = function () {
    function ItemActionParser() {
        _classCallCheck(this, ItemActionParser);
    }

    _createClass(ItemActionParser, null, [{
        key: 'parse',
        value: function parse(node) {
            var itemAction = new _ItemAction2.default();

            var type = node.attr('xsi:type');
            switch (type) {
                case 'ns2:GoToPageAction':
                    itemAction = new _GoToPageAction2.default();
                    itemAction.page = parseInt(node.children('ns2\\:page').text());
                    break;
                case 'ns2:HideItemAction':
                    itemAction = new _HideItemAction2.default();
                    itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                    break;
                case 'ns2:ShowItemAction':
                    itemAction = new _ShowItemAction2.default();
                    itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                    break;
                case 'ns2:OpenWebAction':
                    itemAction = new _OpenWebAction2.default();
                    itemAction.url = node.children('ns2\\:url').text();
                    itemAction.title = node.children('ns2\\:title').text();
                    itemAction.openOutside = node.children('ns2\\:openOutside').text() == 'true';
                    break;
                case 'ns2:PlayAudioAction':
                    itemAction = new _PlayAudioAction2.default();
                    itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                    break;
                case 'ns2:PauseAudioAction':
                    itemAction = new _PauseAudioAction2.default();
                    itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                    break;
                case 'ns2:ResumeAudioAction':
                    itemAction = new _ResumeAudioAction2.default();
                    itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                    break;
                case 'ns2:StopAudioAction':
                    itemAction = new _StopAudioAction2.default();
                    itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                    break;
                case 'ns2:PlayMovieAction':
                    itemAction = new _PlayMovieAction2.default();
                    itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                    break;
                case 'ns2:PauseMovieAction':
                    itemAction = new _PauseMovieAction2.default();
                    itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                    break;
                case 'ns2:ResumeMovieAction':
                    itemAction = new _ResumeMovieAction2.default();
                    itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                    break;
                case 'ns2:StopMovieAction':
                    itemAction = new _StopMovieAction2.default();
                    itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                    break;
                case 'ns2:ToggleMenuAction':
                    itemAction = new _ToggleMenuAction2.default();
                    break;
                case 'ns2:ExitCatalogAction':
                    itemAction = new _ExitCatalogAction2.default();
                    break;
                case 'ns2:GoToStateAction':
                    itemAction = new _GoToStateAction2.default();
                    itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                    itemAction.stateName = parseInt(node.children('ns2\\:stateName').text());
                    break;
                case 'ns2:GoToNextStateAction':
                    itemAction = new _GoToNextStateAction2.default();
                    itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                    itemAction.stopInLast = node.children('ns2\\:stopInLast').text() == 'true';
                    break;
                case 'ns2:GoToPreviousStateAction':
                    itemAction = new _GoToPreviousStateAction2.default();
                    itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                    itemAction.stopInFirst = node.children('ns2\\:stopInFirst').text() == 'true';
                    break;
                case 'ns2:OpenCatalogAction':
                    itemAction = new _OpenCatalogAction2.default();
                    itemAction.catalogId = node.children('ns2\\:catalogId').text();
                    break;
            }

            itemAction.animationType = node.children('ns2\\:animationType').text();
            itemAction.animationDuration = parseFloat(node.children('ns2\\:animationDuration').text());
            itemAction.animationRepeat = node.children('ns2\\:animationRepeat').text() == 'true';

            return itemAction;
        }
    }]);

    return ItemActionParser;
}();

exports.default = ItemActionParser;

},{"../../model/interactive/actions/ExitCatalogAction":39,"../../model/interactive/actions/GoToNextStateAction":40,"../../model/interactive/actions/GoToPageAction":41,"../../model/interactive/actions/GoToPreviousStateAction":42,"../../model/interactive/actions/GoToStateAction":43,"../../model/interactive/actions/HideItemAction":44,"../../model/interactive/actions/ItemAction":45,"../../model/interactive/actions/OpenCatalogAction":46,"../../model/interactive/actions/OpenWebAction":47,"../../model/interactive/actions/PauseAudioAction":48,"../../model/interactive/actions/PauseMovieAction":49,"../../model/interactive/actions/PlayAudioAction":50,"../../model/interactive/actions/PlayMovieAction":51,"../../model/interactive/actions/ResumeAudioAction":52,"../../model/interactive/actions/ResumeMovieAction":53,"../../model/interactive/actions/ShowItemAction":54,"../../model/interactive/actions/StopAudioAction":55,"../../model/interactive/actions/StopMovieAction":56,"../../model/interactive/actions/ToggleMenuAction":57}],81:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BrowserUtils = function () {
    function BrowserUtils() {
        _classCallCheck(this, BrowserUtils);
    }

    _createClass(BrowserUtils, null, [{
        key: "getUserLanguages",
        value: function getUserLanguages() {
            return navigator.languages ? navigator.languages : [navigator.language || navigator.userLanguage];
        }
    }]);

    return BrowserUtils;
}();

exports.default = BrowserUtils;

},{}],82:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CDSFilter = function () {
    function CDSFilter() {
        _classCallCheck(this, CDSFilter);
    }

    _createClass(CDSFilter, null, [{
        key: "filterLibrary",
        value: function filterLibrary(library, publications) {
            library.catalogList = CDSFilter.filterCatalogList(library.catalogList, publications);
        }
    }, {
        key: "filterCatalogList",
        value: function filterCatalogList(catalogList, publications) {
            return catalogList.filter(function (elem, i, array) {
                var publication = publications[elem.catalogId];
                if (publication) {
                    if (!publication.recursive) {
                        elem.childList = CDSFilter.filterCatalogList(elem.childList, publications);
                    }
                    return true;
                }
                return false;
            });
        }
    }]);

    return CDSFilter;
}();

exports.default = CDSFilter;

},{}],83:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CSSEffects = function () {
    function CSSEffects() {
        _classCallCheck(this, CSSEffects);
    }

    _createClass(CSSEffects, null, [{
        key: 'createContainer3dFor',
        value: function createContainer3dFor(item) {
            return $('<div>', {
                css: {
                    'left': item.css('left'),
                    'top': item.css('top'),
                    'width': item.css('width'),
                    'height': item.css('height'),
                    'position': 'absolute',
                    'perspective': item.css('width')
                }
            });
        }
    }, {
        key: 'createObject3dIn',
        value: function createObject3dIn(container3d) {
            return $('<div>', {
                css: {
                    'width': '100%',
                    'height': '100%',
                    'position': 'absolute',
                    'transform-style': 'preserve-3d',
                    'transition': 'all 1.0s ease-in-out'
                }
            }).appendTo(container3d);
        }
    }, {
        key: 'createFrontFaceOf',
        value: function createFrontFaceOf(item) {
            var face = $(item).clone();
            face.css({
                'left': '0',
                'top': '0',
                'width': '100%',
                'height': '100%',
                'position': 'absolute',
                'backface-visibility': 'hidden'
            });
            return face;
        }
    }, {
        key: 'createBackFaceOf',
        value: function createBackFaceOf(item) {
            var face = $(item).clone();
            face.css({
                'left': 0,
                'top': 0,
                'width': '100%',
                'height': '100%',
                'position': 'absolute',
                'display': 'block',
                'backface-visibility': 'hidden',
                'transform': 'rotateY(180deg)'
            });
            return face;
        }
    }, {
        key: 'flip',
        value: function flip(item, degrees, face, before, after) {
            var container3d = CSSEffects.createContainer3dFor(item);
            var object3d = CSSEffects.createObject3dIn(container3d);
            face.appendTo(object3d);

            container3d.insertAfter(item);
            before();
            object3d.one('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function () {
                after();
                container3d.remove();
            });
            setTimeout(function () {
                return object3d.css('transform', 'rotateY(' + degrees + 'deg)');
            }, 100);
        }
    }, {
        key: 'hideFlip',
        value: function hideFlip(item, degrees) {
            CSSEffects.flip(item, degrees, CSSEffects.createFrontFaceOf(item), function () {
                item.hide();
            }, function () {});
        }
    }, {
        key: 'hideFlipLeft',
        value: function hideFlipLeft(item) {
            CSSEffects.hideFlip(item, 180);
        }
    }, {
        key: 'hideFlipRight',
        value: function hideFlipRight(item) {
            CSSEffects.hideFlip(item, -180);
        }
    }, {
        key: 'showFlip',
        value: function showFlip(item, degrees) {
            CSSEffects.flip(item, degrees, CSSEffects.createBackFaceOf(item), function () {}, function () {
                item.show();
            });
        }
    }, {
        key: 'showFlipLeft',
        value: function showFlipLeft(item) {
            CSSEffects.showFlip(item, 180);
        }
    }, {
        key: 'showFlipRight',
        value: function showFlipRight(item) {
            CSSEffects.showFlip(item, -180);
        }
    }]);

    return CSSEffects;
}();

exports.default = CSSEffects;

},{}],84:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _LibraryCatalog = require('../model/LibraryCatalog');

var _LibraryCatalog2 = _interopRequireDefault(_LibraryCatalog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LibraryCatalogFilter = function () {
    function LibraryCatalogFilter() {
        _classCallCheck(this, LibraryCatalogFilter);
    }

    _createClass(LibraryCatalogFilter, null, [{
        key: 'filter',
        value: function filter(catalogList, args) {

            var deviceType = args['deviceType'];
            var deviceLanguage = args['deviceLanguage'];
            var catalogId = args['catalogId'];
            var title = args['title'];

            var res = catalogList;

            if (deviceType) res = LibraryCatalogFilter.filterByDeviceType(res, deviceType);

            if (deviceLanguage) res = LibraryCatalogFilter.filterByDeviceLanguage(res, deviceLanguage);

            if (catalogId) res = LibraryCatalogFilter.filterByCatalogId(res, catalogId);

            if (title) res = LibraryCatalogFilter.filterByTitle(res, title);

            return res;
        }
    }, {
        key: 'filterByDeviceType',
        value: function filterByDeviceType(catalogList, deviceType) {
            return catalogList.filter(function (elem, i, array) {
                return elem.deviceType.length == 0 || elem.deviceType.some(function (e) {
                    return e == "ALL" || e == deviceType;
                });
            });
        }
    }, {
        key: 'filterByDeviceLanguage',
        value: function filterByDeviceLanguage(catalogList, deviceLanguage) {
            return catalogList.filter(function (elem, i, array) {
                return elem.deviceLanguage.length == 0 || elem.deviceLanguage.some(function (e) {
                    return e == "ALL" || e == deviceLanguage;
                });
            });
        }
    }, {
        key: 'filterByCatalogId',
        value: function filterByCatalogId(catalogList, catalogId) {
            return catalogList.filter(function (elem, i, array) {
                return elem.catalogId.toLowerCase() == catalogId.toLowerCase();
            });
        }
    }, {
        key: 'filterByTitle',
        value: function filterByTitle(catalogList, title) {
            return catalogList.filter(function (elem, i, array) {
                return elem.title.toLowerCase().search(title.toLowerCase()) >= 0;
            });
        }
    }]);

    return LibraryCatalogFilter;
}();

exports.default = LibraryCatalogFilter;

},{"../model/LibraryCatalog":31}],85:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _LibraryCatalog = require('../model/LibraryCatalog');

var _LibraryCatalog2 = _interopRequireDefault(_LibraryCatalog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LibraryCatalogSorter = function () {
    function LibraryCatalogSorter() {
        _classCallCheck(this, LibraryCatalogSorter);
    }

    _createClass(LibraryCatalogSorter, null, [{
        key: 'sort',
        value: function sort(catalogList, indexSortType) {
            if (indexSortType == 'MANUAL') {
                return catalogList;
            } else {
                var result = catalogList.slice();

                switch (indexSortType) {
                    case 'PUBLISH_DATE_NEWEST_FIRST':
                        result.sort(function (a, b) {
                            return a.publishDate - b.publishDate;
                        });
                        break;
                    case 'PUBLISH_DATE_OLDEST_FIRST':
                        result.sort(function (a, b) {
                            return b.publishDate - a.publishDate;
                        });
                        break;
                }

                return result;
            }
        }
    }]);

    return LibraryCatalogSorter;
}();

exports.default = LibraryCatalogSorter;

},{"../model/LibraryCatalog":31}],86:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var URLUtils = function () {
    function URLUtils() {
        _classCallCheck(this, URLUtils);
    }

    _createClass(URLUtils, null, [{
        key: 'getURL',
        value: function getURL(path) {

            var url = window.location.origin;

            if (path.charAt(0) == '/') {
                url += path;
            } else {
                url += window.location.pathname;
                url = url.slice(0, url.lastIndexOf('/'));
                url += '/' + path;
            }

            return url;
        }
    }]);

    return URLUtils;
}();

exports.default = URLUtils;

},{}],87:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _View2 = require('../core/View');

var _View3 = _interopRequireDefault(_View2);

var _URLUtils = require('../util/URLUtils');

var _URLUtils2 = _interopRequireDefault(_URLUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CatalogListView = function (_View) {
    _inherits(CatalogListView, _View);

    function CatalogListView() {
        _classCallCheck(this, CatalogListView);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(CatalogListView).apply(this, arguments));
    }

    _createClass(CatalogListView, [{
        key: 'createView',
        value: function createView(model) {
            var _this2 = this;

            var library = model['library'];
            var baseUrl = model['baseUrl'];
            var visualTemplate = model['visualTemplate'];
            var catalogList = model['catalogList'];

            var wrapperDiv = $('<div>', {
                css: {
                    'padding': '20px'
                }
            });

            var catalogListDOM = $('<div>', {
                'data-equalizer': '',
                class: 'row'
            }).appendTo(wrapperDiv);

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = catalogList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var libraryCatalog = _step.value;

                    var catalog = $('<div>', {
                        class: 'col-lg-2 col-md-3 col-sm-4 col-xs-6'
                    }).appendTo(catalogListDOM);

                    var thumbnail = $('<div>', {
                        class: 'thumbnail',
                        style: 'background-color: ' + visualTemplate.listCatalogsBackgroundColor + ';'
                    }).appendTo(catalog);

                    var watchDiv = $('<div>', {
                        'data-equalizer-watch': ''
                    }).appendTo(thumbnail);

                    var img = $('<img>', {
                        class: 'img-responsive',
                        css: {
                            'width': '100%'
                        },
                        src: libraryCatalog.horizontalImage.search('http') >= 0 ? libraryCatalog.horizontalImage : _URLUtils2.default.getURL(baseUrl + libraryCatalog.horizontalImage)
                    }).appendTo(watchDiv).on('load', function () {
                        // Equalizer
                        new Foundation.Equalizer(catalogListDOM);
                    });

                    var caption = $('<div>', {
                        class: 'caption'
                    }).appendTo(watchDiv);

                    var title = $('<h3>', {
                        class: '',
                        style: 'color: ' + visualTemplate.catalogTitleColor + ';',
                        text: '' + libraryCatalog.title
                    }).appendTo(caption);

                    var subtitle = $('<p>', {
                        class: '',
                        style: 'color: ' + visualTemplate.catalogDescriptionColor + ';',
                        text: '' + libraryCatalog.subtitle
                    }).appendTo(caption);

                    var buttonsDiv = $('<div>', {
                        class: 'caption',
                        css: {
                            'margin-top': '8px'
                        }
                    }).appendTo(thumbnail);

                    // Button Ver
                    if (libraryCatalog.catalogType == 'OTHER') {
                        var btnName = this.app.polyglot.t("Download");

                        $('<a>', {
                            class: 'btn',
                            style: 'background-color: ' + visualTemplate.listCatalogsBackgroundColor + '; color: ' + visualTemplate.catalogButtonColor + '; border: 1px solid ' + visualTemplate.catalogButtonColor + ';',
                            text: btnName,
                            href: libraryCatalog.path.search('http') >= 0 ? libraryCatalog.path : _URLUtils2.default.getURL(baseUrl + libraryCatalog.path),
                            target: '_blank'
                        }).appendTo(buttonsDiv);
                    } else {
                        (function () {
                            var btnName = '';

                            if (libraryCatalog.catalogType == 'FOLDER' || libraryCatalog.catalogType == 'INTELLIGENT_FOLDER') {
                                btnName = _this2.app.polyglot.t("Open");
                            } else if (libraryCatalog.catalogType == 'PDF' || libraryCatalog.catalogType == 'INTERACTIVE' || libraryCatalog.catalogType == 'VIDEO' || libraryCatalog.catalogType == 'WEB') {
                                btnName = _this2.app.polyglot.t("See");
                            }

                            var btn = $('<a>', {
                                class: 'btn',
                                style: 'background-color: ' + visualTemplate.listCatalogsBackgroundColor + '; color: ' + visualTemplate.catalogButtonColor + '; border: 1px solid ' + visualTemplate.catalogButtonColor + ';',
                                text: btnName,
                                click: _this2.onViewCatalog.bind(_this2)
                            }).prop('COILibraryCatalog', libraryCatalog).appendTo(buttonsDiv);

                            img.css('cursor', 'pointer');
                            img.on('click', function () {
                                btn.trigger('click');
                            });
                        })();
                    }

                    // Button Ver fuera (solo PDF)
                    if (libraryCatalog.catalogType == 'PDF') {
                        var btnName = this.app.polyglot.t("See outside");

                        $('<a>', {
                            class: 'btn',
                            style: 'background-color: ' + visualTemplate.listCatalogsBackgroundColor + '; color: ' + visualTemplate.catalogButtonColor + '; border: 1px solid ' + visualTemplate.catalogButtonColor + '; margin-left: 8px;',
                            text: btnName,
                            href: libraryCatalog.path.search('http') >= 0 ? libraryCatalog.path : _URLUtils2.default.getURL(baseUrl + libraryCatalog.path),
                            target: '_blank'
                        }).appendTo(buttonsDiv);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return wrapperDiv;
        }
    }, {
        key: 'onViewCatalog',
        value: function onViewCatalog(event) {
            var libraryCatalog = $(event.currentTarget).prop('COILibraryCatalog');
            this.app.callAction('loadLibraryCatalog', {
                'libraryCatalog': libraryCatalog
            });
            //this.app.getController('LibraryController').loadLibraryCatalog({
            //    'libraryCatalog': libraryCatalog
            //});
        }
    }]);

    return CatalogListView;
}(_View3.default);

exports.default = CatalogListView;

},{"../core/View":23,"../util/URLUtils":86}],88:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _View2 = require('../core/View');

var _View3 = _interopRequireDefault(_View2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropdownMenuView = function (_View) {
    _inherits(DropdownMenuView, _View);

    function DropdownMenuView() {
        _classCallCheck(this, DropdownMenuView);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(DropdownMenuView).apply(this, arguments));
    }

    _createClass(DropdownMenuView, [{
        key: 'createView',
        value: function createView(model) {

            var menuJson = model['menuJson'];
            var visualTemplate = model['visualTemplate'];

            return this.createMenuDropdown(menuJson, visualTemplate);
        }
    }, {
        key: 'createMenuDropdown',
        value: function createMenuDropdown(menuJson, visualTemplate) {

            var menuDropdown = $('<div>', {
                class: 'dropdown',
                style: 'float: right'
            });

            this.createSearchModal().appendTo(menuDropdown);

            var mainMenuList = this.createMenuList(menuJson, visualTemplate, menuDropdown);

            var menuDropdownBtn = $('<button>', {
                class: 'btn btn-xs btn-default dropdown-toggle',
                css: {
                    'background-color': '' + visualTemplate.toolbarBackgroundColor,
                    'color': '' + visualTemplate.toolbarTintSecondaryColor,
                    'border': '0px'
                },
                type: 'button',
                'data-toggle': 'dropdown',
                click: function click(e) {
                    $('ul.dropdown-menu').css('display', 'none');
                    mainMenuList.css('display', '');
                }
            }).appendTo(menuDropdown);

            $('<span>', {
                class: 'glyphicon glyphicon-option-horizontal',
                css: {
                    'font-size': '22px',
                    'display': 'block'
                }
            }).appendTo(menuDropdownBtn);

            return menuDropdown;
        }
    }, {
        key: 'createMenuList',
        value: function createMenuList(menuJson, visualTemplate, menuDropdown) {
            var _this2 = this;

            var backMenuList = arguments.length <= 3 || arguments[3] === undefined ? undefined : arguments[3];

            var menuList = $('<ul>', {
                class: 'dropdown-menu dropdown-menu-right',
                css: {
                    'background-color': '' + visualTemplate.toolbarBackgroundColor
                }
            }).appendTo(menuDropdown);

            if (backMenuList != undefined) {

                this.createMenuListElement($('<span>', { class: 'glyphicon glyphicon-menu-left', css: { 'margin-left': '-8px' } }), visualTemplate, function (e) {
                    menuList.css('display', 'none');
                    backMenuList.css('display', '');
                    menuDropdown.addClass('open');
                    e.stopPropagation();
                }).appendTo(menuList);

                $('<li>', {
                    role: 'separator',
                    class: 'divider'
                }).appendTo(menuList);
            }

            for (var key in menuJson) {
                var value = menuJson[key];

                if (typeof value === 'function') {

                    this.createMenuListElement(key, visualTemplate, value.bind(this)).appendTo(menuList);
                } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
                    (function () {

                        var subMenuList = _this2.createMenuList(value, visualTemplate, menuDropdown, menuList);

                        _this2.createMenuListElement(key, visualTemplate, function (e) {
                            menuList.css('display', 'none');
                            subMenuList.css('display', '');
                            menuDropdown.addClass('open');
                            e.stopPropagation();
                        }).appendTo(menuList);
                    })();
                }
            }

            return menuList;
        }
    }, {
        key: 'createMenuListElement',
        value: function createMenuListElement(html, visualTemplate, onClick) {

            var menuListElement = $('<li>', {});

            $('<a>', {
                html: html,
                css: {
                    'background-color': '' + visualTemplate.toolbarBackgroundColor,
                    'color': '' + visualTemplate.toolbarTintSecondaryColor,
                    'cursor': 'pointer'
                },
                click: onClick
            }).hover(function () {
                $(this).css("background-color", '' + visualTemplate.toolbarTintColor);
            }, function () {
                $(this).css("background-color", '' + visualTemplate.toolbarBackgroundColor);
            }).appendTo(menuListElement);

            return menuListElement;
        }
    }, {
        key: 'createSearchModal',
        value: function createSearchModal() {
            var textSearch = this.app.polyglot.t("Search");
            var textOK = this.app.polyglot.t("OK");
            var textCancel = this.app.polyglot.t("Cancel");

            var modalFade = $('<div>', {
                id: 'searchModal',
                class: 'modal fade',
                tabindex: '-1',
                role: 'dialog'
            });

            var modalDialog = $('<div>', {
                class: 'modal-dialog modal-sm'
            }).appendTo(modalFade);

            var modalContent = $('<div>', {
                class: 'modal-content'
            }).appendTo(modalDialog);

            var modalHeader = $('<div>', {
                class: 'modal-header'
            }).appendTo(modalContent);

            $('<button>', {
                type: 'button',
                class: 'close',
                'data-dismiss': 'modal',
                html: '<span aria-hidden="true">&times;</span>',
                'aria-label': 'Close'
            }).appendTo(modalHeader);

            $('<h4>', {
                class: 'modal-title',
                text: textSearch
            }).appendTo(modalHeader);

            var modalBody = $('<div>', {
                class: 'modal-body',
                keypress: function keypress(e) {
                    if (e.keyCode == $.ui.keyCode.ENTER) {
                        $('#searchButton').trigger("click");
                    }
                }
            }).appendTo(modalContent);

            $('<input>', {
                id: 'searchInput',
                type: 'text',
                class: 'form-control'
            }).appendTo(modalBody);

            var modalFooter = $('<div>', {
                class: 'modal-footer'
            }).appendTo(modalContent);

            $('<button>', {
                type: 'button',
                class: 'btn btn-default',
                'data-dismiss': 'modal',
                text: textCancel
            }).appendTo(modalFooter);

            $('<button>', {
                id: 'searchButton',
                type: 'button',
                class: 'btn btn-primary',
                text: textOK,
                click: function () {
                    $('#searchModal').on('hidden.bs.modal', function () {
                        var searchString = $('#searchInput').val();
                        this.app.callAction('searchLibraryCatalogs', {
                            'searchString': searchString
                        });
                    }.bind(this)).modal('hide');
                }.bind(this)
            }).appendTo(modalFooter);

            return modalFade;
        }
    }]);

    return DropdownMenuView;
}(_View3.default);

exports.default = DropdownMenuView;

},{"../core/View":23}],89:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _View2 = require('../core/View');

var _View3 = _interopRequireDefault(_View2);

var _LibraryCatalogToolbarView = require('./LibraryCatalogToolbarView');

var _LibraryCatalogToolbarView2 = _interopRequireDefault(_LibraryCatalogToolbarView);

var _LibraryBannerView = require('./LibraryBannerView');

var _LibraryBannerView2 = _interopRequireDefault(_LibraryBannerView);

var _CatalogListView = require('./CatalogListView');

var _CatalogListView2 = _interopRequireDefault(_CatalogListView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FolderView = function (_View) {
    _inherits(FolderView, _View);

    function FolderView() {
        _classCallCheck(this, FolderView);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(FolderView).apply(this, arguments));
    }

    _createClass(FolderView, [{
        key: 'createView',
        value: function createView(model) {

            var libraryCatalog = model['libraryCatalog'];
            var visualTemplate = model['visualTemplate'];

            var libraryDOM = $('<div>', {
                class: 'folder',
                style: 'background-color: ' + visualTemplate.listCatalogsBackgroundColor + '; min-height: 100%;'
            });

            if (libraryCatalog.showCatalogMenu) {
                this.app.createView(new _LibraryCatalogToolbarView2.default(), {
                    'libraryCatalog': libraryCatalog,
                    'visualTemplate': visualTemplate
                }).appendTo(libraryDOM);
            }

            // Comprobar si el catalogo tiene las propiedades!
            if (libraryCatalog.horizontalBanner && libraryCatalog.verticalBanner) {
                var banners = libraryCatalog.horizontalBanner.length > 0 ? libraryCatalog.horizontalBanner : libraryCatalog.verticalBanner;
                this.app.createView(new _LibraryBannerView2.default(), {
                    'baseUrl': this.app.baseUrl,
                    'banners': banners,
                    'bannerInterval': libraryCatalog.bannerInterval
                }).appendTo(libraryDOM);
            }

            this.app.createView(new _CatalogListView2.default(), model).appendTo(libraryDOM);

            return libraryDOM;
        }
    }]);

    return FolderView;
}(_View3.default);

exports.default = FolderView;

},{"../core/View":23,"./CatalogListView":87,"./LibraryBannerView":90,"./LibraryCatalogToolbarView":91}],90:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _View2 = require('../core/View');

var _View3 = _interopRequireDefault(_View2);

var _URLUtils = require('../util/URLUtils');

var _URLUtils2 = _interopRequireDefault(_URLUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LibraryBannerView = function (_View) {
    _inherits(LibraryBannerView, _View);

    function LibraryBannerView() {
        _classCallCheck(this, LibraryBannerView);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(LibraryBannerView).apply(this, arguments));
    }

    _createClass(LibraryBannerView, [{
        key: 'createView',
        value: function createView(model) {
            var _this2 = this;

            var baseUrl = model['baseUrl'];
            var banners = model['banners'];
            var bannerInterval = model['bannerInterval'];

            var bannerDOM = $('<div>', {
                class: 'banner'
            });

            banners = banners.filter(function (elem, i, array) {
                return elem.language == '' || elem.language == _this2.app.currentDeviceLanguage;
            });

            var slides = $('<div>', {
                id: '' + (banners.length > 1 ? 'slides' : '')
            }).appendTo(bannerDOM);

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = banners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var banner = _step.value;

                    var onClick = undefined;

                    var URL_PREFIX_HTTP = 'http://';
                    var URL_PREFIX_HTTPS = 'https://';
                    var URL_PREFIX_COI_OPENISSUE = 'cointeractive://openissue/';

                    var link = undefined;

                    if (banner.url.startsWith(URL_PREFIX_COI_OPENISSUE)) {
                        (function () {
                            var catalogId = banner.url.slice(URL_PREFIX_COI_OPENISSUE.length);
                            onClick = function onClick() {
                                _this2.app.loadCatalogById(catalogId, true);return false;
                            };
                            link = $('<a>', {
                                click: onClick ? onClick.bind(_this2) : '',
                                css: {
                                    'cursor': 'pointer'
                                }
                            }).appendTo(slides);
                        })();
                    } else if (banner.url.startsWith(URL_PREFIX_HTTP) || banner.url.startsWith(URL_PREFIX_HTTPS)) {
                        link = $('<a>', {
                            href: banner.url,
                            target: '_blank'
                        }).appendTo(slides);
                    } else {
                        link = $('<a>', {
                            click: function click() {
                                return false;
                            }
                        }).appendTo(slides);
                    }

                    $('<img>', {
                        src: banner.image.search('http') >= 0 ? banner.image : _URLUtils2.default.getURL(baseUrl + banner.image),
                        style: 'width: 100%;'
                    }).appendTo(link);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (banners.length > 1) {
                var width = banners[0].width;
                var height = banners[0].height;
                this.app.bannerSliderOptions = this.buildSliderOptions(width, height, bannerInterval);
            }

            return bannerDOM;
        }
    }, {
        key: 'buildSliderOptions',
        value: function buildSliderOptions(width, height, interval) {
            return {
                width: width,
                height: height,
                navigation: {
                    active: false,
                    // [boolean] Generates next and previous buttons.
                    // You can set to false and use your own buttons.
                    // User defined buttons must have the following:
                    // previous button: class="slidesjs-previous slidesjs-navigation"
                    // next button: class="slidesjs-next slidesjs-navigation"
                    effect: "slide"
                    // [string] Can be either "slide" or "fade".
                },
                play: {
                    active: false,
                    // [boolean] Generate the play and stop buttons.
                    // You cannot use your own buttons. Sorry.
                    effect: "slide",
                    // [string] Can be either "slide" or "fade".
                    interval: interval * 1000,
                    // [number] Time spent on each slide in milliseconds.
                    auto: true,
                    // [boolean] Start playing the slideshow on load.
                    swap: true,
                    // [boolean] show/hide stop and play buttons
                    pauseOnHover: true,
                    // [boolean] pause a playing slideshow on hover
                    restartDelay: interval * 1000
                    // [number] restart delay on inactive slideshow
                }
            };
        }
    }]);

    return LibraryBannerView;
}(_View3.default);

exports.default = LibraryBannerView;

},{"../core/View":23,"../util/URLUtils":86}],91:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _View2 = require('../core/View');

var _View3 = _interopRequireDefault(_View2);

var _DropdownMenuView = require('./DropdownMenuView');

var _DropdownMenuView2 = _interopRequireDefault(_DropdownMenuView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LibraryCatalogToolbarView = function (_View) {
    _inherits(LibraryCatalogToolbarView, _View);

    function LibraryCatalogToolbarView() {
        _classCallCheck(this, LibraryCatalogToolbarView);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(LibraryCatalogToolbarView).apply(this, arguments));
    }

    _createClass(LibraryCatalogToolbarView, [{
        key: 'createView',
        value: function createView(model) {

            var libraryCatalog = model['libraryCatalog'];
            var visualTemplate = model['visualTemplate'];

            var toolbarDOM = $('<div>', {
                class: 'toolbar',
                css: {
                    'margin': '0px',
                    'padding': '8px',
                    'width': '100%',
                    'height': '40px',
                    //'position': 'absolute',
                    //'left': '0',
                    //'top': '0',
                    'background-color': visualTemplate.toolbarBackgroundColor
                }
            });

            // Back button
            if (!libraryCatalog.useAsRoot && libraryCatalog.showExitButton) {
                var btnName = this.app.polyglot.t("Back");
                $('<button>', {
                    class: 'btn btn-xs btn-default',
                    css: {
                        'background-color': '' + visualTemplate.toolbarBackgroundColor,
                        'color': '' + visualTemplate.toolbarTintSecondaryColor,
                        'border': '0px',
                        'font-size': '16px',
                        'font-weight': 'bold',
                        'float': 'left'
                    },
                    text: btnName,
                    click: this.onBackButtonPressed.bind(this)
                }).appendTo(toolbarDOM);
            }

            // Menu dropdown
            if (libraryCatalog.catalogType != "PDF") {
                var menuJson = {};

                if (this.app.cds) {
                    var textLogin = this.app.polyglot.t("Login");
                    var textLogout = this.app.polyglot.t("Logout");

                    if (this.app.cdsConfig.cdsUsername.length == 0) menuJson[textLogin] = function () {
                        this.login();
                    }.bind(this);else menuJson[textLogout] = function () {
                        this.logout();
                    }.bind(this);
                }

                if (visualTemplate.showSearchButton) {
                    var btnName = this.app.polyglot.t("Search");
                    menuJson[btnName] = function () {
                        $('#searchModal').on('shown.bs.modal', function () {
                            $('#searchInput').focus();
                        }).modal('show');
                    }.bind(this);
                }

                if (visualTemplate.showChangeLanguageButton) {
                    var btnName = this.app.polyglot.t("Languages");
                    menuJson[btnName] = {
                        'Español': function () {
                            this.changeLanguage('es');
                        }.bind(this),
                        'English': function () {
                            this.changeLanguage('en');
                        }.bind(this),
                        'Chino': function () {
                            this.changeLanguage('zh');
                        }.bind(this)
                    };
                }

                if (this.app.library.appUrl && this.app.library.appUrl.length > 0) {
                    var btnName = this.app.polyglot.t("Web");
                    menuJson[btnName] = function () {
                        window.open(this.app.library.appUrl, '_blank');
                    }.bind(this);
                }

                if (!$.isEmptyObject(menuJson)) {
                    this.app.createView(new _DropdownMenuView2.default(), {
                        'menuJson': menuJson,
                        'visualTemplate': visualTemplate
                    }).appendTo(toolbarDOM);
                }

                if (this.app.cds && this.app.cdsConfig.cdsUsername.length > 0) {
                    $('<div>', {
                        text: this.app.cdsConfig.cdsUsername,
                        css: {
                            'float': 'right',
                            'color': visualTemplate.toolbarTintSecondaryColor,
                            'font-weight': 'bold'
                        }
                    }).appendTo(toolbarDOM);
                }
            } else {
                // Es PDF
                // Share button
                $('<div>', {
                    id: 'shareButtons',
                    class: '',
                    css: {
                        'background-color': '' + visualTemplate.toolbarBackgroundColor,
                        'color': '' + visualTemplate.toolbarTintSecondaryColor,
                        'border': '0px',
                        'font-size': '16px',
                        'font-weight': 'bold',
                        'float': 'right',
                        'margin-top': '-8px',
                        'margin-left': '8px'
                    },
                    text: this.app.polyglot.t("Share")
                }).appendTo(toolbarDOM).jsSocials({
                    showCount: false,
                    showLabel: false,
                    shares: ["email", "twitter", "facebook"],
                    on: {
                        click: this.onShareButtonPressed.bind(this)
                    }
                });

                // Download button
                $('<button>', {
                    class: 'btn btn-xs btn-default',
                    css: {
                        'background-color': '' + visualTemplate.toolbarBackgroundColor,
                        'color': '' + visualTemplate.toolbarTintSecondaryColor,
                        'border': '0px',
                        'font-size': '16px',
                        'font-weight': 'bold',
                        'float': 'right'
                    },
                    html: '<i class="fa fa-download"></i> ' + this.app.polyglot.t("Download"),
                    click: this.onDownloadButtonPressed.bind(this, model['url'], libraryCatalog.title + '.pdf')
                }).appendTo(toolbarDOM);
            }

            // Toolbar title
            $('<h1>', {
                text: libraryCatalog.title,
                css: {
                    'margin': '0px',
                    'text-align': 'center',
                    'font-size': '1.5em',
                    'color': visualTemplate.toolbarTintColor
                }
            }).appendTo(toolbarDOM);

            $('<div>', {
                css: {
                    'clear': 'both'
                }
            }).appendTo(toolbarDOM);

            return toolbarDOM;
        }
    }, {
        key: 'onBackButtonPressed',
        value: function onBackButtonPressed() {
            this.app.goBack();
        }
    }, {
        key: 'changeLanguage',
        value: function changeLanguage(lang) {
            this.app.changeCurrentLanguage(lang);
        }
    }, {
        key: 'login',
        value: function login() {
            var _this2 = this;

            var textUsername = this.app.polyglot.t("Username");
            var textPassword = this.app.polyglot.t("Password");
            var textRemember = this.app.polyglot.t("Remember");
            var textLogin = this.app.polyglot.t("Login");

            $('#loginDialog').remove();

            var d = $('<div>', {
                id: 'loginDialog',
                title: textLogin,
                html: '<label for="login_username">' + textUsername + ':</label><br/><input type="text" id="login_username"/><br/>' + '<label for="login_password">' + textPassword + ':</label><br/><input type="password" id="login_password"/><br/>' + '<input type="checkbox" id="login_remember"><label for="login_remember" style="margin-left:5px;">' + textRemember + '</label>',
                keypress: function keypress(e) {
                    if (e.keyCode == $.ui.keyCode.ENTER) {
                        $('#loginButton').trigger("click");
                    }
                }
            }).dialog({
                modal: true,
                buttons: [{
                    id: 'loginButton',
                    text: textLogin,
                    click: function click() {
                        var username = d.children('#login_username').val();
                        var password = d.children('#login_password').val();
                        var remember = d.children('#login_remember').is(':checked');

                        if (username.length > 0 || password.length > 0) {
                            $('#loginDialog').dialog("close");
                            _this2.app.login(username, password, remember);
                        }
                    }
                }]
            });
        }
    }, {
        key: 'logout',
        value: function logout() {
            this.app.logout();
        }
    }, {
        key: 'onDownloadButtonPressed',
        value: function onDownloadButtonPressed(fileURL, fileName) {
            var url = window.location.href.replace('index.html', '');
            ga('send', 'event', 'Descargar', 'click', 'En la url ' + url);
            this.save2Disk(fileURL, fileName);
        }
    }, {
        key: 'save2Disk',
        value: function save2Disk(fileURL, fileName) {
            // for non-IE
            if (!window.ActiveXObject) {
                var save = document.createElement('a');
                save.href = fileURL;
                save.target = '_blank';
                save.download = fileName || 'unknown';

                var evt = new MouseEvent('click', {
                    'view': window,
                    'bubbles': true,
                    'cancelable': false
                });
                save.dispatchEvent(evt);

                (window.URL || window.webkitURL).revokeObjectURL(save.href);
            }

            // for IE < 11
            else if (!!window.ActiveXObject && document.execCommand) {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL);
                    _window.close();
                }
        }
    }, {
        key: 'onShareButtonPressed',
        value: function onShareButtonPressed() {
            var url = window.location.href.replace('index.html', '');
            ga('send', 'event', 'Compartir', 'click', 'En la url ' + url);
        }
    }]);

    return LibraryCatalogToolbarView;
}(_View3.default);

exports.default = LibraryCatalogToolbarView;

},{"../core/View":23,"./DropdownMenuView":88}],92:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _View2 = require('../core/View');

var _View3 = _interopRequireDefault(_View2);

var _URLUtils = require('../util/URLUtils');

var _URLUtils2 = _interopRequireDefault(_URLUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LibraryInfoView = function (_View) {
    _inherits(LibraryInfoView, _View);

    function LibraryInfoView() {
        _classCallCheck(this, LibraryInfoView);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(LibraryInfoView).apply(this, arguments));
    }

    _createClass(LibraryInfoView, [{
        key: 'createView',
        value: function createView(model) {
            var _this2 = this;

            var visualTemplate = model['visualTemplate'];

            var images = visualTemplate.horizontalLibraryInfoImages;
            images = images.length > 0 ? images : visualTemplate.verticalLibraryInfoImages;

            this.imgWidth = 0;
            this.imgHeight = 0;

            this.infoBackground = $('<div>', {
                css: {
                    'position': 'absolute',
                    'left': '0px',
                    'top': '0px',
                    'width': '100%',
                    'height': '100%',
                    'z-index': '99',
                    'background-color': 'rgba(0,0,0,0.7)'
                }
            }).click(function () {
                _this2.infoBackground.remove();
            }).appendTo('body');

            this.infoBox = $('<div>', {
                css: {
                    'position': 'relative',
                    'left': '50%',
                    'top': '50%',
                    'transform': 'translate(-50%, -50%)',
                    'padding': '20px',
                    'border-radius': '10px',
                    'background-color': '#DEDEDE'
                }
            }).click(function (e) {
                e.stopPropagation();
            }).appendTo(this.infoBackground);

            this.infoContent = $('<div>', {
                css: {}
            }).appendTo(this.infoBox);

            this.infoContent.hide();

            var deferred = new $.Deferred();
            var promise = deferred;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                var _loop = function _loop() {
                    var path = _step.value;

                    promise = promise.then(function () {
                        var img = $('<img>', {
                            src: '' + _URLUtils2.default.getURL(_this2.app.baseUrl + path)
                        }).appendTo(_this2.infoContent);

                        var d = new $.Deferred();

                        img.load(function () {
                            _this2.imgWidth = img[0].width;
                            _this2.imgHeight = img[0].height;
                            d.resolve();
                        });

                        return d;
                    });
                };

                for (var _iterator = images[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    _loop();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            promise.then(function () {
                _this2.onResize();
                if (images.length > 1) {
                    _this2.infoContent.slidesjs({
                        width: _this2.imgWidth,
                        height: _this2.imgHeight,
                        navigation: {
                            active: false
                        }
                    });
                } else {
                    _this2.infoContent.children('img').css({
                        'width': '100%',
                        'height': '100%'
                    });
                }
                _this2.infoContent.show();
            });

            deferred.resolve();

            $(window).resize(this.onResize.bind(this));
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            var maxWidth = this.infoBackground.width() * 0.8;
            var maxHeight = this.infoBackground.height() * 0.8;

            var widthRatio = maxWidth / this.imgWidth;
            var heightRatio = maxHeight / this.imgHeight;
            var scaleRatio = widthRatio < heightRatio ? widthRatio : heightRatio;

            var width = this.imgWidth * scaleRatio;
            var height = this.imgHeight * scaleRatio;

            this.infoBox.css('width', width + 40);

            this.infoContent.css('width', width);
            this.infoContent.css('height', height);
        }
    }]);

    return LibraryInfoView;
}(_View3.default);

exports.default = LibraryInfoView;

},{"../core/View":23,"../util/URLUtils":86}],93:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _View2 = require('../core/View');

var _View3 = _interopRequireDefault(_View2);

var _DropdownMenuView = require('./DropdownMenuView');

var _DropdownMenuView2 = _interopRequireDefault(_DropdownMenuView);

var _LibraryInfoView = require('./LibraryInfoView');

var _LibraryInfoView2 = _interopRequireDefault(_LibraryInfoView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LibraryToolbarView = function (_View) {
    _inherits(LibraryToolbarView, _View);

    function LibraryToolbarView() {
        _classCallCheck(this, LibraryToolbarView);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(LibraryToolbarView).apply(this, arguments));
    }

    _createClass(LibraryToolbarView, [{
        key: 'createView',
        value: function createView(model) {

            var library = model['library'];

            var toolbarDOM = $('<div>', {
                class: 'toolbar',
                style: 'padding: 8px; background-color: ' + library.visualTemplate.toolbarBackgroundColor + '; text-align: center;'
            });

            var menuJson = {};

            if (this.app.cds) {
                var textLogin = this.app.polyglot.t("Login");
                var textLogout = this.app.polyglot.t("Logout");

                if (this.app.cdsConfig.cdsUsername.length == 0) menuJson[textLogin] = function () {
                    this.login();
                }.bind(this);else menuJson[textLogout] = function () {
                    this.logout();
                }.bind(this);
            }

            if (library.visualTemplate.showSearchButton) {
                var btnName = this.app.polyglot.t("Search");
                menuJson[btnName] = function () {
                    $('#searchModal').on('shown.bs.modal', function () {
                        $('#searchInput').focus();
                    }).modal('show');
                }.bind(this);
            }

            if (library.visualTemplate.showChangeLanguageButton) {
                var btnName = this.app.polyglot.t("Languages");
                menuJson[btnName] = {
                    'Español': function () {
                        this.changeLanguage('es');
                    }.bind(this),
                    'English': function () {
                        this.changeLanguage('en');
                    }.bind(this),
                    'Chino': function () {
                        this.changeLanguage('zh');
                    }.bind(this)
                };
            }

            if (library.appUrl && library.appUrl.length > 0) {
                var btnName = this.app.polyglot.t("Web");
                menuJson[btnName] = function () {
                    window.open(library.appUrl, '_blank');
                }.bind(this);
            }

            if (library.visualTemplate.horizontalLibraryInfoImages.length > 0 || library.visualTemplate.verticalLibraryInfoImages.length > 0) {

                var btnName = this.app.polyglot.t("Help");
                menuJson[btnName] = function () {
                    this.app.createView(new _LibraryInfoView2.default(), {
                        'visualTemplate': library.visualTemplate
                    });
                }.bind(this);
            }

            if (!$.isEmptyObject(menuJson)) {
                this.app.createView(new _DropdownMenuView2.default(), {
                    'menuJson': menuJson,
                    'visualTemplate': library.visualTemplate
                }).appendTo(toolbarDOM);
            }

            if (this.app.cds && this.app.cdsConfig.cdsUsername.length > 0) {
                $('<div>', {
                    text: this.app.cdsConfig.cdsUsername,
                    css: {
                        'float': 'right',
                        'color': library.visualTemplate.toolbarTintSecondaryColor,
                        'font-weight': 'bold'
                    }
                }).appendTo(toolbarDOM);
            }

            // Toolbar title
            $('<h1>', {
                css: {
                    'margin': '0px',
                    'font-size': '1.4em',
                    'color': '' + library.visualTemplate.toolbarTintColor
                },
                text: '' + library.title
            }).appendTo(toolbarDOM);

            $('<div>', {
                css: {
                    'clear': 'both'
                }
            }).appendTo(toolbarDOM);

            return toolbarDOM;
        }
    }, {
        key: 'changeLanguage',
        value: function changeLanguage(lang) {
            this.app.changeCurrentLanguage(lang);
        }
    }, {
        key: 'login',
        value: function login() {
            var _this2 = this;

            var textUsername = this.app.polyglot.t("Username");
            var textPassword = this.app.polyglot.t("Password");
            var textRemember = this.app.polyglot.t("Remember");
            var textLogin = this.app.polyglot.t("Login");

            $('#loginDialog').remove();

            var d = $('<div>', {
                id: 'loginDialog',
                title: textLogin,
                html: '<label for="login_username">' + textUsername + ':</label><br/><input type="text" id="login_username"/><br/>' + '<label for="login_password">' + textPassword + ':</label><br/><input type="password" id="login_password"/><br/>' + '<input type="checkbox" id="login_remember"><label for="login_remember" style="margin-left:5px;">' + textRemember + '</label>',
                keypress: function keypress(e) {
                    if (e.keyCode == $.ui.keyCode.ENTER) {
                        $('#loginButton').trigger("click");
                    }
                }
            }).dialog({
                modal: true,
                buttons: [{
                    id: 'loginButton',
                    text: textLogin,
                    click: function click() {
                        var username = d.children('#login_username').val();
                        var password = d.children('#login_password').val();
                        var remember = d.children('#login_remember').is(':checked');

                        if (username.length > 0 || password.length > 0) {
                            $('#loginDialog').dialog("close");
                            _this2.app.login(username, password, remember);
                        }
                    }
                }]
            });
        }
    }, {
        key: 'logout',
        value: function logout() {
            this.app.logout();
        }
    }]);

    return LibraryToolbarView;
}(_View3.default);

exports.default = LibraryToolbarView;

},{"../core/View":23,"./DropdownMenuView":88,"./LibraryInfoView":92}],94:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
        value: true
});

var _View2 = require('../core/View');

var _View3 = _interopRequireDefault(_View2);

var _LibraryToolbarView = require('./LibraryToolbarView');

var _LibraryToolbarView2 = _interopRequireDefault(_LibraryToolbarView);

var _LibraryBannerView = require('./LibraryBannerView');

var _LibraryBannerView2 = _interopRequireDefault(_LibraryBannerView);

var _CatalogListView = require('./CatalogListView');

var _CatalogListView2 = _interopRequireDefault(_CatalogListView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LibraryView = function (_View) {
        _inherits(LibraryView, _View);

        function LibraryView() {
                _classCallCheck(this, LibraryView);

                return _possibleConstructorReturn(this, Object.getPrototypeOf(LibraryView).apply(this, arguments));
        }

        _createClass(LibraryView, [{
                key: 'createView',
                value: function createView(model) {

                        var library = model['library'];
                        var catalogList = model['catalogList'];

                        $(document).prop('title', library.title);

                        var libraryDOM = $('<div>', {
                                class: 'library',
                                style: 'background-color: ' + library.visualTemplate.listCatalogsBackgroundColor + '; min-height: 100%;'
                        });

                        this.app.createView(new _LibraryToolbarView2.default(), {
                                'library': library
                        }).appendTo(libraryDOM);

                        var banners = library.visualTemplate.horizontalBanner.length > 0 ? library.visualTemplate.horizontalBanner : library.visualTemplate.verticalBanner;
                        this.app.createView(new _LibraryBannerView2.default(), {
                                'baseUrl': this.app.baseUrl,
                                'banners': banners,
                                'bannerInterval': library.visualTemplate.bannerInterval
                        }).appendTo(libraryDOM);

                        this.app.createView(new _CatalogListView2.default(), {
                                'library': library,
                                'baseUrl': this.app.baseUrl,
                                'visualTemplate': library.visualTemplate,
                                'catalogList': catalogList
                        }).appendTo(libraryDOM);

                        return libraryDOM;
                }
        }]);

        return LibraryView;
}(_View3.default);

exports.default = LibraryView;

},{"../core/View":23,"./CatalogListView":87,"./LibraryBannerView":90,"./LibraryToolbarView":93}],95:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _View2 = require('../core/View');

var _View3 = _interopRequireDefault(_View2);

var _LibraryCatalogToolbarView = require('./LibraryCatalogToolbarView');

var _LibraryCatalogToolbarView2 = _interopRequireDefault(_LibraryCatalogToolbarView);

var _CatalogListView = require('./CatalogListView');

var _CatalogListView2 = _interopRequireDefault(_CatalogListView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PDFView = function (_View) {
    _inherits(PDFView, _View);

    function PDFView() {
        _classCallCheck(this, PDFView);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(PDFView).apply(this, arguments));
    }

    _createClass(PDFView, [{
        key: 'createView',
        value: function createView(model) {

            var libraryCatalog = model['libraryCatalog'];
            var url = model['url'];
            var visualTemplate = model['visualTemplate'];

            var pdfDOM = $('<div>', {
                css: {
                    'margin': '0px',
                    'padding': '0px',
                    'height': '100%',
                    'overflow-y': 'hidden'
                }
            });

            var toolbar = undefined;

            if (libraryCatalog.showCatalogMenu) {
                toolbar = this.app.createView(new _LibraryCatalogToolbarView2.default(), {
                    'libraryCatalog': libraryCatalog,
                    'visualTemplate': visualTemplate,
                    'url': url
                }).appendTo(pdfDOM);
            }

            var pdfviewerHeight = $(window).height() - (toolbar ? toolbar.height() : 0);

            var iframe = $('<iframe>', {
                src: 'lib/pdfjs/web/viewer.html?file=' + encodeURI(url),
                css: {
                    'border': 'none',
                    'width': '100%',
                    'min-height': pdfviewerHeight + 'px'
                }
            }).appendTo(pdfDOM);

            $(window).resize(function () {
                var pdfviewerHeight = $(window).height() - (toolbar ? toolbar.height() : 0);
                iframe.css({
                    'width': '100%',
                    'min-height': pdfviewerHeight + 'px'
                });
            });

            //let canvas = $('<canvas>', {
            //    class: 'pdf',
            //    style: 'min.width: 100%; min-height: 100%;'
            //}).appendTo(pdfDOM);
            //
            //canvas[0].width = window.innerWidth;
            //canvas[0].height = window.innerHeight;
            //
            //var context = canvas[0].getContext('2d');
            //
            //console.log(canvas);
            //var desiredWidth = window.innerWidth;
            //var viewport = page.getViewport(1);
            //console.log(viewport);
            //var scale = desiredWidth / viewport.width;
            //console.log(scale);
            //var scaledViewport = page.getViewport(scale);
            //console.log(scaledViewport);
            //
            //canvas[0].height = scaledViewport.height;
            //
            //var renderContext = {
            //    canvasContext: context,
            //    viewport: scaledViewport
            //};
            //page.render(renderContext);

            return pdfDOM;
        }
    }]);

    return PDFView;
}(_View3.default);

exports.default = PDFView;

},{"../core/View":23,"./CatalogListView":87,"./LibraryCatalogToolbarView":91}],96:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _View2 = require('../core/View');

var _View3 = _interopRequireDefault(_View2);

var _DropdownMenuView = require('./DropdownMenuView');

var _DropdownMenuView2 = _interopRequireDefault(_DropdownMenuView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimpleToolbarView = function (_View) {
    _inherits(SimpleToolbarView, _View);

    function SimpleToolbarView() {
        _classCallCheck(this, SimpleToolbarView);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(SimpleToolbarView).apply(this, arguments));
    }

    _createClass(SimpleToolbarView, [{
        key: 'createView',
        value: function createView(model) {

            var libraryCatalog = model['libraryCatalog'];
            var visualTemplate = model['visualTemplate'];

            var toolbarDOM = $('<div>', {
                class: 'toolbar',
                css: {
                    'margin': '0px',
                    'padding': '8px',
                    'width': '100%',
                    'height': '40px',
                    'background-color': visualTemplate.toolbarBackgroundColor
                }
            });

            // Back button
            if (!libraryCatalog.useAsRoot && libraryCatalog.showExitButton) {
                var btnName = this.app.polyglot.t("Back");
                $('<button>', {
                    class: 'btn btn-xs btn-default',
                    css: {
                        'background-color': '' + visualTemplate.toolbarBackgroundColor,
                        'color': '' + visualTemplate.toolbarTintSecondaryColor,
                        'border': '0px',
                        'font-size': '16px',
                        'font-weight': 'bold',
                        'float': 'left'
                    },
                    text: btnName,
                    click: this.onBackButtonPressed.bind(this)
                }).appendTo(toolbarDOM);
            }

            // Toolbar title
            $('<h1>', {
                text: libraryCatalog.title,
                css: {
                    'margin': '0px',
                    'text-align': 'center',
                    'font-size': '1.5em',
                    'color': visualTemplate.toolbarTintColor
                }
            }).appendTo(toolbarDOM);

            $('<div>', {
                css: {
                    'clear': 'both'
                }
            }).appendTo(toolbarDOM);

            return toolbarDOM;
        }
    }, {
        key: 'onBackButtonPressed',
        value: function onBackButtonPressed() {
            this.app.goBack();
        }
    }]);

    return SimpleToolbarView;
}(_View3.default);

exports.default = SimpleToolbarView;

},{"../core/View":23,"./DropdownMenuView":88}],97:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _View2 = require('../../core/View');

var _View3 = _interopRequireDefault(_View2);

var _URLUtils = require('../../util/URLUtils');

var _URLUtils2 = _interopRequireDefault(_URLUtils);

var _ImageItem = require('../../model/interactive/items/ImageItem');

var _ImageItem2 = _interopRequireDefault(_ImageItem);

var _ButtonItem = require('../../model/interactive/items/ButtonItem');

var _ButtonItem2 = _interopRequireDefault(_ButtonItem);

var _ImageButtonItem = require('../../model/interactive/items/ImageButtonItem');

var _ImageButtonItem2 = _interopRequireDefault(_ImageButtonItem);

var _AudioItem = require('../../model/interactive/items/AudioItem');

var _AudioItem2 = _interopRequireDefault(_AudioItem);

var _VideoItem = require('../../model/interactive/items/VideoItem');

var _VideoItem2 = _interopRequireDefault(_VideoItem);

var _ScrollImageItem = require('../../model/interactive/items/ScrollImageItem');

var _ScrollImageItem2 = _interopRequireDefault(_ScrollImageItem);

var _GalleryItem = require('../../model/interactive/items/GalleryItem');

var _GalleryItem2 = _interopRequireDefault(_GalleryItem);

var _AnimatedImageItem = require('../../model/interactive/items/AnimatedImageItem');

var _AnimatedImageItem2 = _interopRequireDefault(_AnimatedImageItem);

var _WebZipItem = require('../../model/interactive/items/WebZipItem');

var _WebZipItem2 = _interopRequireDefault(_WebZipItem);

var _BrowserItem = require('../../model/interactive/items/BrowserItem');

var _BrowserItem2 = _interopRequireDefault(_BrowserItem);

var _MultiStateObjectItem = require('../../model/interactive/items/MultiStateObjectItem');

var _MultiStateObjectItem2 = _interopRequireDefault(_MultiStateObjectItem);

var _PanoramaImageItem = require('../../model/interactive/items/PanoramaImageItem');

var _PanoramaImageItem2 = _interopRequireDefault(_PanoramaImageItem);

var _TouchAlphaImageItem = require('../../model/interactive/items/TouchAlphaImageItem');

var _TouchAlphaImageItem2 = _interopRequireDefault(_TouchAlphaImageItem);

var _TouchImageSequenceItem = require('../../model/interactive/items/TouchImageSequenceItem');

var _TouchImageSequenceItem2 = _interopRequireDefault(_TouchImageSequenceItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InteractiveCatalogView = function (_View) {
    _inherits(InteractiveCatalogView, _View);

    function InteractiveCatalogView() {
        _classCallCheck(this, InteractiveCatalogView);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(InteractiveCatalogView).apply(this, arguments));
    }

    _createClass(InteractiveCatalogView, [{
        key: 'createView',
        value: function createView(model, container) {
            var _this2 = this;

            this.baseUrl = model['baseUrl'];
            this.visualTemplate = model['visualTemplate'];
            this.libraryCatalog = model['libraryCatalog'];
            this.interactiveCatalog = model['interactiveCatalog'];

            this.interactiveCatalog.goToPage(0);
            this.interactiveCatalog._toolbarDisplay = false;

            this.interactiveCatalogContainer = $('<div>', {
                class: 'interactive-catalog-container'
            }).appendTo(container);

            this.render();

            $(window).resize(this.onResize.bind(this));

            $(window).keydown(function (e) {
                if (e.which == 37) {
                    // Left arrow
                    if (_this2.isNavigationEnabled() && _this2.goToPrevPage()) _this2.render();
                } else if (e.which == 39) {
                    // Right arrow
                    if (_this2.isNavigationEnabled() && _this2.goToNextPage()) _this2.render();
                }
            });

            $(window).off('mousedown mouseup mousemove');

            $(window).on('mousedown', function (e) {
                e.stopPropagation();
                window.dragging = true;
                window.pageX = e.pageX;
            });

            $(window).on('mouseup', function (e) {
                e.stopPropagation();
                window.dragging = false;
                window.draggable = false;
            });

            $(window).on('mousemove', function (e) {
                e.stopPropagation();
                if (window.draggable) {
                    var layerOffset = window.draggable.layer.offset();
                    var left = e.pageX - layerOffset.left - window.draggable.draggingOffsetX;
                    var top = e.pageY - layerOffset.top - window.draggable.draggingOffsetY;
                    window.draggable.item.css('left', left);
                    window.draggable.item.css('top', top);
                } else if (window.dragging) {
                    var horizontalDistance = e.pageX - window.pageX;
                    var horizontalDistanceThreshold = 120;

                    if (horizontalDistance >= horizontalDistanceThreshold) {
                        window.dragging = false;
                        if (_this2.isNavigationEnabled() && _this2.goToPrevPage()) _this2.render();
                    }
                    if (horizontalDistance <= -horizontalDistanceThreshold) {
                        window.dragging = false;
                        if (_this2.isNavigationEnabled() && _this2.goToNextPage()) _this2.render();
                    }
                }
            });

            return this.interactiveCatalogContainer;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            this.interactiveCatalogContainer.empty();
            this.renderInteractiveCatalog(this.interactiveCatalogContainer);

            if (this.libraryCatalog.showCatalogMenu) {
                (function () {
                    var toolbar = _this3.renderToolbar();
                    _this3.interactiveCatalogContainer.append(toolbar).click(function (e) {
                        if (!e.isDefaultPrevented()) {
                            toolbar.fadeToggle();
                            _this3.interactiveCatalog._toolbarDisplay = !_this3.interactiveCatalog._toolbarDisplay;
                        }
                    });
                })();
            }

            if (this.libraryCatalog.showPageSlider) {
                (function () {
                    var pageSlider = _this3.renderPageSlider();
                    _this3.interactiveCatalogContainer.append(pageSlider).click(function (e) {
                        if (!e.isDefaultPrevented()) {
                            pageSlider.fadeToggle();
                        }
                    });
                })();
            }

            this.onRendered();
        }
    }, {
        key: 'onRendered',
        value: function onRendered() {
            // Custom Scrollbar
            $('.scrollable').each(function (i, elem) {
                var itemDiv = $(elem);
                var axis = itemDiv.attr('axis');
                itemDiv.mCustomScrollbar({
                    axis: axis,
                    theme: 'minimal-dark'
                });
            });
            // Panorama
            $(".panorama").panorama_viewer({
                repeat: true,
                direction: "horizontal",
                animationTime: 700,
                easing: "ease-out",
                overlay: false
            });
            // ScratchPad
            $(".scratchPad").each(function (i, elem) {
                var itemDiv = $(elem);
                var fg = itemDiv.attr('fg');
                itemDiv.wScratchPad({
                    size: 50, // The size of the brush/scratch.
                    bg: null, // Background (image path or hex color).
                    fg: fg, // Foreground (image path or hex color).
                    realtime: false, // Calculates percentage in realitime.
                    scratchDown: null, // Set scratchDown callback.
                    scratchUp: null, // Set scratchUp callback.
                    scratchMove: null, // Set scratcMove callback.
                    cursor: 'pointer' // Set cursor.
                });
            });
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            this.render();
        }
    }, {
        key: 'goToPrevPage',
        value: function goToPrevPage() {
            if (this.interactiveCatalog.navigationType.startsWith('MAGAZINE_2X1') && this.app.currentOrientation == 'HORIZONTAL') {

                var currentPageIndex = this.interactiveCatalog._currentPageIndex;
                var prevPageIndex = currentPageIndex;

                if (this.interactiveCatalog.firstPageLeft) prevPageIndex -= currentPageIndex % 2 == 0 ? 2 : 3;else prevPageIndex -= currentPageIndex % 2 == 0 ? 3 : 2;

                if (prevPageIndex < 0) prevPageIndex = 0;

                return this.interactiveCatalog.goToPage(prevPageIndex);
            }
            return this.interactiveCatalog.goToPrevPage();
        }
    }, {
        key: 'goToNextPage',
        value: function goToNextPage() {
            if (this.interactiveCatalog.navigationType.startsWith('MAGAZINE_2X1') && this.app.currentOrientation == 'HORIZONTAL') {

                var currentPageIndex = this.interactiveCatalog._currentPageIndex;
                var nextPageIndex = currentPageIndex;

                if (this.interactiveCatalog.firstPageLeft) nextPageIndex += currentPageIndex % 2 == 0 ? 2 : 1;else nextPageIndex += currentPageIndex % 2 == 0 ? 1 : 2;

                if (nextPageIndex > this.interactiveCatalog.pages.length - 1) nextPageIndex = this.interactiveCatalog.pages.length - 1;

                return this.interactiveCatalog.goToPage(nextPageIndex);
            }
            return this.interactiveCatalog.goToNextPage();
        }
    }, {
        key: 'canGoToPrevPage',
        value: function canGoToPrevPage() {
            var currentPageIndex = this.interactiveCatalog._currentPageIndex;

            if (this.interactiveCatalog.navigationType.startsWith('MAGAZINE_2X1') && this.app.currentOrientation == 'HORIZONTAL') {

                if (this.interactiveCatalog.firstPageLeft) return currentPageIndex > 1;else return currentPageIndex > 0;
            }

            return currentPageIndex > 0;
        }
    }, {
        key: 'canGoToNextPage',
        value: function canGoToNextPage() {
            var currentPageIndex = this.interactiveCatalog._currentPageIndex;
            var numPages = this.interactiveCatalog.pages.length;

            if (this.interactiveCatalog.navigationType.startsWith('MAGAZINE_2X1') && this.app.currentOrientation == 'HORIZONTAL') {

                if (this.interactiveCatalog.firstPageLeft) return numPages % 2 == 0 ? currentPageIndex < numPages - 2 : currentPageIndex < numPages - 1;else return numPages % 2 == 0 ? currentPageIndex < numPages - 1 : currentPageIndex < numPages - 2;
            }

            return currentPageIndex < numPages - 1;
        }
    }, {
        key: 'renderInteractiveCatalog',
        value: function renderInteractiveCatalog(container) {

            var backgroundColor = this.getInteractiveCatalogBackgroundColor();

            var sizePercent = 100 * window.devicePixelRatio + '%';

            var interactiveCatalogDiv = $('<div>', {
                class: 'interactive-catalog',
                css: {
                    'width': sizePercent,
                    'height': sizePercent,
                    'background-color': backgroundColor
                }
            }).appendTo(container);

            var currentNavigationType = this.interactiveCatalog.navigationType;
            var currentOrientation = this.app.currentOrientation;

            if (currentNavigationType.startsWith('MAGAZINE_2X1') && currentOrientation == 'HORIZONTAL') {
                this.renderDoublePage(interactiveCatalogDiv);
            } else {
                this.renderSinglePage(interactiveCatalogDiv);
            }

            this.renderNavigationButtons(interactiveCatalogDiv);
        }
    }, {
        key: 'getInteractiveCatalogBackgroundColor',
        value: function getInteractiveCatalogBackgroundColor() {
            var interactiveCatalog = this.interactiveCatalog;
            var interactiveCatalogPage = this.interactiveCatalog._currentPage;

            return interactiveCatalogPage.backgroundColor != '' ? interactiveCatalogPage.backgroundColor : interactiveCatalog.backgroundColor != '' ? interactiveCatalog.backgroundColor : 'white';
        }
    }, {
        key: 'renderSinglePage',
        value: function renderSinglePage(container) {

            var pageContainer = $('<div>', {
                class: 'interactive-page-container interactive-page-container-single'
            }).appendTo(container);

            this.renderPage(this.interactiveCatalog._currentPage, pageContainer);
        }
    }, {
        key: 'renderDoublePage',
        value: function renderDoublePage(container) {

            var leftPageContainer = $('<div>', {
                class: 'interactive-page-container interactive-page-container-left'
            }).appendTo(container);

            var rightPageContainer = $('<div>', {
                class: 'interactive-page-container interactive-page-container-right'
            }).appendTo(container);

            var currentPageIndex = this.interactiveCatalog._currentPageIndex;

            if (currentPageIndex % 2 == 0 && this.interactiveCatalog.firstPageLeft || currentPageIndex % 2 == 1 && !this.interactiveCatalog.firstPageLeft) {

                this.renderPage(this.interactiveCatalog.pages[currentPageIndex], leftPageContainer);

                if (currentPageIndex < this.interactiveCatalog.pages.length - 1) this.renderPage(this.interactiveCatalog.pages[currentPageIndex + 1], rightPageContainer);
            } else if (currentPageIndex % 2 == 0 && !this.interactiveCatalog.firstPageLeft || currentPageIndex % 2 == 1 && this.interactiveCatalog.firstPageLeft) {

                this.renderPage(this.interactiveCatalog.pages[currentPageIndex], rightPageContainer);

                if (currentPageIndex > 0) this.renderPage(this.interactiveCatalog.pages[currentPageIndex - 1], leftPageContainer);
            }
        }
    }, {
        key: 'getFormat',
        value: function getFormat(navigationType, deviceOrientation) {
            if (navigationType == 'ONLY_HORIZONTAL') return 'HORIZONTAL';

            if (navigationType == 'ONLY_VERTICAL') return 'VERTICAL';

            if (navigationType == 'MAGAZINE_2X1_ADAPTABLE') return 'UNIVERSAL';

            if (navigationType == 'INDEPENDENT_ORIENTATIONS' || navigationType == 'MAGAZINE_2X1_INDEPENDENT_ORIENTATIONS') return deviceOrientation;
        }
    }, {
        key: 'renderPage',
        value: function renderPage(page, container) {
            var _this4 = this;

            var maxWidth = container.width();
            var maxHeight = container.height();
            // console.log('Max size: ' + maxWidth + ', ' + maxHeight);

            var format = this.getFormat(this.interactiveCatalog.navigationType, this.app.currentOrientation);

            var size = undefined;
            if (format == 'HORIZONTAL') size = page.horizontalSize;
            if (format == 'VERTICAL') size = page.verticalSize;
            if (format == 'UNIVERSAL') size = page.universalSize;

            var width = size.width;
            var height = size.height;
            // console.log('Size: ' + width + ', ' + height);

            var widthRatio = maxWidth / width;
            // console.log('width ratio: ' + widthRatio);
            var heightRatio = maxHeight / height;
            // console.log('height ratio: ' + heightRatio);

            this.scaleRatio = widthRatio < heightRatio ? widthRatio : heightRatio;
            // console.log('scale ratio: ' + this.scaleRatio);
            width = width * this.scaleRatio;
            height = height * this.scaleRatio;
            // console.log('final size: ' + width + ', ' + height);

            var pageDiv = $('<div>', {
                class: 'interactive-page interactive-page-centered',
                css: {
                    'width': width + 'px',
                    'height': height + 'px'
                }
            }).appendTo(container);

            if (this.interactiveCatalog.horizontalAlignmentType == 'BORDER_LEFT_ALIGNED' || this.interactiveCatalog.horizontalAlignmentType == 'BORDER_CENTERED_ALIGNED' && container.css('float') == 'right' || this.interactiveCatalog.horizontalAlignmentType == '' && container.css('float') == 'right') {
                pageDiv.removeClass('interactive-page-centered');
                pageDiv.addClass('interactive-page-left-aligned');
            }
            if (this.interactiveCatalog.horizontalAlignmentType == 'BORDER_RIGHT_ALIGNED' || this.interactiveCatalog.horizontalAlignmentType == 'BORDER_CENTERED_ALIGNED' && container.css('float') == 'left' || this.interactiveCatalog.horizontalAlignmentType == '' && container.css('float') == 'left') {
                pageDiv.removeClass('interactive-page-centered');
                pageDiv.addClass('interactive-page-right-aligned');
            }

            // Render layers
            var layers = undefined;
            if (format == 'HORIZONTAL') layers = page.horizontalLayers;
            if (format == 'VERTICAL') layers = page.verticalLayers;
            if (format == 'UNIVERSAL') layers = page.universalLayers;

            layers.forEach(function (layer) {
                _this4.renderLayer(layer, pageDiv).appendTo(pageDiv);
            });
        }
    }, {
        key: 'renderLayer',
        value: function renderLayer(layer, pageDiv) {
            var _this5 = this;

            var layerDiv = $('<div>', {
                css: {
                    'width': '100%,',
                    'height': '100%'
                }
            });

            var filteredItems = layer.items.filter(function (elem, i, array) {
                return elem.deviceTypes.length == 0 || elem.deviceTypes.some(function (e) {
                    return e == "ALL" || e == "WEB";
                });
            });

            filteredItems.forEach(function (item) {
                _this5.renderItem(item, layerDiv).appendTo(layerDiv);
            });

            return layerDiv;
        }
    }, {
        key: 'renderItem',
        value: function renderItem(item, layerDiv) {
            var _this6 = this;

            var itemDiv = $('<div>', {
                id: item.itemId,
                css: {
                    'width': this.scaleRatio * item.width + 'px',
                    'height': this.scaleRatio * item.height + 'px',
                    'position': 'absolute',
                    'left': this.scaleRatio * item.left + 'px',
                    'top': this.scaleRatio * item.top + 'px',
                    'display': item.hidden ? 'none' : ''
                }
            });

            // Clonable
            if (item.clonable) {
                itemDiv.css('cursor', 'copy');

                itemDiv.on('click', function (e) {
                    e.preventDefault();
                    var newItem = item.clone();
                    newItem.itemId = newItem.itemId + ' ' + Date.now();
                    newItem.clonable = false;
                    newItem.left = (layerDiv.width() - itemDiv.width()) / 2 / _this6.scaleRatio;
                    newItem.top = (layerDiv.height() - itemDiv.height()) / 2 / _this6.scaleRatio;
                    _this6.renderItem(newItem, layerDiv).appendTo(layerDiv);
                });
            }
            // Draggable (solo si no es clonable)
            else if (item.draggable) {
                    itemDiv.css('cursor', 'move');
                    itemDiv.on('click', function (e) {
                        e.preventDefault();
                    });
                    itemDiv.on('mousedown', function (e) {
                        window.draggable = {
                            layer: layerDiv,
                            item: itemDiv,
                            draggingOffsetX: e.offsetX,
                            draggingOffsetY: e.offsetY
                        };
                    });
                }

            if (item.itemId != 0) this.interactiveCatalog._items[item.itemId] = itemDiv;

            if (item instanceof _ImageItem2.default) {
                itemDiv.css({
                    'background-image': 'url(' + _URLUtils2.default.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + item.path) + ')',
                    'background-size': this.scaleRatio * item.width + 'px ' + this.scaleRatio * item.height + 'px'
                });
            }

            if (item instanceof _ButtonItem2.default) {
                if (!itemDiv.css('cursor')) itemDiv.css('cursor', 'pointer');
                if (item.actions.length == 0 && !item.draggable && !item.clonable) {
                    itemDiv.css('pointer-events', 'none');
                }
                itemDiv.click(function (e) {
                    if (item.actions.length > 0) e.preventDefault();
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = item.actions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var itemAction = _step.value;

                            var interactiveCatalogController = _this6.app.getController("InteractiveCatalogController");
                            interactiveCatalogController.doAction(itemAction);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                });
            }

            if (item instanceof _ImageButtonItem2.default) {
                if (!itemDiv.css('cursor')) itemDiv.css('cursor', 'pointer');
                itemDiv.css({
                    'background-image': 'url(' + _URLUtils2.default.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + item.normalPath) + ')',
                    'background-size': this.scaleRatio * item.width + 'px ' + this.scaleRatio * item.height + 'px'
                });
                if (item.actions.length == 0 && !item.draggable && !item.clonable) {
                    itemDiv.css('pointer-events', 'none');
                }
                itemDiv.click(function (e) {
                    if (item.actions.length > 0) e.preventDefault();
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = item.actions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var itemAction = _step2.value;

                            var interactiveCatalogController = _this6.app.getController("InteractiveCatalogController");
                            interactiveCatalogController.doAction(itemAction);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                });
            }

            if (item instanceof _AudioItem2.default) {
                var audio = $('<audio>', {
                    'src': _URLUtils2.default.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + item.path),
                    'loop': item.loop,
                    'autoPlay': item.autoPlay
                });
                itemDiv.append(audio);
            }

            if (item instanceof _VideoItem2.default) {
                (function () {

                    itemDiv.on('click', function (e) {
                        e.preventDefault();
                    });

                    var video = $('<video>', {
                        'src': _URLUtils2.default.getURL(_this6.baseUrl + _this6.interactiveCatalog.catalogId + '/' + item.path),
                        'loop': item.loop,
                        'autoPlay': item.autoPlay,
                        'controls': false,
                        css: {
                            'width': '100%',
                            'height': '100%'
                        }
                    }).bind('webkitfullscreenchange mozfullscreenchange fullscreenchange', function () {
                        var isFullscreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
                        if (isFullscreen) $(window).off("resize");else $(window).resize(_this6.onResize.bind(_this6));
                    });

                    if (item.controlsStyle != 'NONE') {
                        video.click(function (e) {
                            console.log(video);
                            video[0].controls = !video[0].controls;
                            console.log(video);
                        });
                    }

                    itemDiv.append(video);

                    if (item.hidden) {
                        (function () {

                            var btnCloseVideo = $('<div>', {
                                css: {
                                    'display': 'none',
                                    'margin': '2px',
                                    'padding-left': '2px',
                                    'width': '18px',
                                    'height': '18px',
                                    'position': 'absolute',
                                    'top': '0',
                                    'right': '0',
                                    'cursor': 'pointer',
                                    'border-radius': '10px',
                                    'background': _this6.visualTemplate.toolbarBackgroundColor,
                                    'color': _this6.visualTemplate.toolbarTintSecondaryColor
                                }
                            }).on('click', function () {
                                video[0].pause();
                                video[0].currentTime = 0;
                                itemDiv.hide();
                            });

                            $('<span>', {
                                class: 'glyphicon glyphicon-remove',
                                'aria-hidden': 'true'
                            }).appendTo(btnCloseVideo);

                            itemDiv.append(btnCloseVideo);
                            itemDiv.hover(function () {
                                btnCloseVideo.stop().fadeIn();
                            }, function () {
                                btnCloseVideo.stop().fadeOut();
                            });
                        })();
                    }
                })();
            }

            if (item instanceof _ScrollImageItem2.default) {

                var axisX = item.width < item.contentWidth;
                var axisY = item.height < item.contentHeight;
                var axis = (axisY ? 'y' : '') + (axisX ? 'x' : '');
                itemDiv.attr('axis', axis);
                itemDiv.addClass('scrollable');
                itemDiv.css({
                    'overflow': 'auto'
                });

                $('<div>', {
                    css: {
                        'width': this.scaleRatio * item.contentWidth + 'px',
                        'height': this.scaleRatio * item.contentHeight + 'px',
                        'background-image': 'url(' + _URLUtils2.default.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + item.path) + ')',
                        'background-size': this.scaleRatio * item.contentWidth + 'px ' + this.scaleRatio * item.contentHeight + 'px'
                    }
                }).appendTo(itemDiv);
            }

            if (item instanceof _GalleryItem2.default) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {

                    for (var _iterator3 = item.paths[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var path = _step3.value;

                        $('<img>', {
                            width: this.scaleRatio * item.width,
                            height: this.scaleRatio * item.height,
                            src: '' + _URLUtils2.default.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + path)
                        }).appendTo(itemDiv);
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }

                itemDiv.css('z-index', '0'); // Evitar que la galería tape otras cosas..

                itemDiv.slidesjs({
                    width: this.scaleRatio * item.width,
                    height: this.scaleRatio * item.height,
                    navigation: {
                        active: false
                    }
                });
            }

            if (item instanceof _AnimatedImageItem2.default) {

                item.clear();

                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = item.paths[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var path = _step4.value;

                        var img = $('<img>', {
                            width: this.scaleRatio * item.width,
                            height: this.scaleRatio * item.height,
                            src: '' + _URLUtils2.default.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + path)
                        }).appendTo(itemDiv);

                        item._images.push(img);
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }

                item.start();
            }

            if (item instanceof _WebZipItem2.default) {
                (function () {

                    var path = item.zipPath.substring(0, item.zipPath.length - 4) + '/index.html';

                    var iframe = $('<iframe>', {
                        scrolling: 'no',
                        width: _this6.scaleRatio * item.width,
                        height: _this6.scaleRatio * item.height,
                        css: {
                            'border': 'none'
                        },
                        'src': _URLUtils2.default.getURL(_this6.baseUrl + _this6.interactiveCatalog.catalogId + '/' + path)
                    }).appendTo(itemDiv);

                    iframe.on('load', function () {
                        var interval = setInterval(function () {

                            if (this.contentWindow) {

                                if (this.contentWindow.document.body.clientHeight > 0) {
                                    clearInterval(interval);

                                    console.log("WebZipItem onLoad - scrollHeight: " + this.contentWindow.document.body.scrollHeight);

                                    // Es necesario que el contenedor sea visible para obtener el tamaño con
                                    // getBoundingClientRect... Si estaba oculto, mostrarlo y volver a ocultar
                                    var prevVisibility = itemDiv.css('visibility');
                                    var prevDisplay = itemDiv.css('display');
                                    itemDiv.css('visibility', 'hidden');
                                    itemDiv.css('display', '');

                                    console.log("WebZipItem onLoad - scrollHeight 2: " + this.contentWindow.document.body.scrollHeight);

                                    if (this.contentWindow.document.body.scrollWidth > iframe.width()) iframe.width(this.contentWindow.document.body.scrollWidth);
                                    if (this.contentWindow.document.body.scrollHeight > iframe.height()) iframe.height(this.contentWindow.document.body.scrollHeight);

                                    var axisX = iframe[0].getBoundingClientRect().width - itemDiv[0].getBoundingClientRect().width >= 1;
                                    var axisY = iframe[0].getBoundingClientRect().height - itemDiv[0].getBoundingClientRect().height >= 1;
                                    var axis = (axisY ? 'y' : '') + (axisX ? 'x' : '');
                                    itemDiv.css('display', prevDisplay);
                                    itemDiv.css('visibility', prevVisibility);

                                    if (axis == '') {
                                        itemDiv.mCustomScrollbar('destroy');
                                    } else {
                                        itemDiv.mCustomScrollbar({
                                            axis: axis,
                                            theme: 'minimal-dark'
                                        });
                                    }
                                }
                            } else {
                                clearInterval(interval);
                            }
                        }.bind(this), 50);
                    });
                })();
            }

            if (item instanceof _BrowserItem2.default) {

                $('<iframe>', {
                    width: this.scaleRatio * item.width,
                    height: this.scaleRatio * item.height,
                    css: {
                        'border': 'none'
                    },
                    'src': item.url
                }).appendTo(itemDiv);
            }

            if (item instanceof _MultiStateObjectItem2.default) {

                itemDiv._stateObjectDivs = {};
                itemDiv._item = item;
                item.stateObjects.forEach(function (stateObject) {
                    var stateObjectItem = _this6.renderItem(stateObject.item);
                    stateObjectItem.css('display', stateObject.active ? '' : 'none');
                    itemDiv.append(stateObjectItem);
                    itemDiv._stateObjectDivs[stateObject.stateName] = stateObjectItem;
                    if (stateObject.active) item.goToState(stateObject.stateName);
                });
            }

            if (item instanceof _PanoramaImageItem2.default) {

                itemDiv.addClass('panorama');
                itemDiv.css('display', 'none');
                itemDiv.on('click', function (e) {
                    e.preventDefault();
                });

                var img = $('<img>', {
                    src: _URLUtils2.default.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + item.path),
                    css: {
                        'width': this.scaleRatio * item.contentWidth + 'px',
                        'height': this.scaleRatio * item.contentHeight + 'px'
                        //'background-image': `url(${URLUtils.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + item.path)})`,
                        //'background-size': `${this.scaleRatio * item.contentWidth}px ${this.scaleRatio * item.contentHeight}px`
                    }
                }).appendTo(itemDiv);

                img.load(function () {
                    setTimeout(function () {
                        itemDiv.show();
                    }, 100);
                });
            }

            if (item instanceof _TouchAlphaImageItem2.default) {

                itemDiv.addClass('scratchPad');
                itemDiv.on('click', function (e) {
                    e.preventDefault();
                });
                itemDiv.on('mousedown', function (e) {
                    e.stopPropagation();itemDiv.css('background-color', '');
                });

                var backgroundColor = this.getInteractiveCatalogBackgroundColor();
                itemDiv.css('background-color', backgroundColor);

                var fg = _URLUtils2.default.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + item.path);
                itemDiv.attr('fg', fg);
            }

            if (item instanceof _TouchImageSequenceItem2.default) {

                item.clear();

                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = item.paths[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var path = _step5.value;

                        var img = $('<img>', {
                            width: this.scaleRatio * item.width,
                            height: this.scaleRatio * item.height,
                            src: '' + _URLUtils2.default.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + path),
                            css: {
                                'display': 'none',
                                'user-drag': 'none'
                            }
                        }).appendTo(itemDiv);

                        item._images.push(img);
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }

                item.start();

                itemDiv.dragging = false;

                itemDiv.on('mousemove', function (e) {
                    e.stopPropagation();
                    if (itemDiv.dragging) {
                        var stepOffset = itemDiv.width() / item._images.length;
                        var offsetDiff = e.offsetX - itemDiv.offsetX;

                        if (offsetDiff >= stepOffset) {
                            item.goToNext();
                            itemDiv.offsetX += stepOffset;
                        }
                        if (offsetDiff <= -stepOffset) {
                            item.goToPrevious();
                            itemDiv.offsetX -= stepOffset;
                        }
                    }
                });

                itemDiv.on('mouseup mouseleave', function (e) {
                    e.stopPropagation();
                    itemDiv.dragging = false;
                });

                itemDiv.on('mousedown', function (e) {
                    e.stopPropagation();
                    itemDiv.dragging = true;
                    itemDiv.offsetX = e.offsetX;
                });

                itemDiv.on('click', function (e) {
                    e.preventDefault();
                });
            }

            return itemDiv;
        }
    }, {
        key: 'renderToolbar',
        value: function renderToolbar() {
            var _this7 = this;

            var toolbarDiv = $('<div>', {
                'id': 'toolbar',
                css: {
                    'display': this.interactiveCatalog._toolbarDisplay ? '' : 'none',
                    'margin': '0px',
                    'padding': '8px',
                    'width': '100%',
                    'height': '40px',
                    'position': 'absolute',
                    'left': '0',
                    'top': '0',
                    'background-color': this.visualTemplate.toolbarBackgroundColor //'rgba(128,128,128,0.5)'
                }
            });

            // Back button
            if (!this.libraryCatalog.useAsRoot && this.libraryCatalog.showExitButton) {
                $('<button>', {
                    class: 'btn btn-xs btn-default',
                    css: {
                        'background-color': '' + this.visualTemplate.toolbarBackgroundColor,
                        'color': '' + this.visualTemplate.toolbarTintSecondaryColor,
                        'border': '0px',
                        'font-size': '16px',
                        'font-weight': 'bold',
                        'float': 'left'
                    },
                    text: 'Atrás',
                    click: this.onBackButtonPressed.bind(this)
                }).appendTo(toolbarDiv);
            }

            // Index
            if (this.libraryCatalog.showIndexButton) {
                if (this.interactiveCatalog.indexType == 'CATALOG_PAGE') {
                    var indexBtn = $('<button>', {
                        class: 'btn btn-xs btn-default',
                        css: {
                            'background-color': '' + this.visualTemplate.toolbarBackgroundColor,
                            'color': '' + this.visualTemplate.toolbarTintSecondaryColor,
                            'border': '0px',
                            'float': 'right'
                        },
                        type: 'button',
                        click: function click(e) {
                            e.preventDefault();
                            _this7.interactiveCatalog.goToPage(_this7.interactiveCatalog.indexNumPage);
                            _this7.render();
                        }
                    }).appendTo(toolbarDiv);

                    $('<span>', {
                        class: 'glyphicon glyphicon-th-list',
                        css: {
                            'font-size': '20px',
                            'display': 'block'
                        }
                    }).appendTo(indexBtn);
                } else {
                    this.createIndexDropdown(this.interactiveCatalog.indexPages, this.visualTemplate).appendTo(toolbarDiv);
                }
            }

            // Title
            var toolbarTitle = $('<h1>', {
                'text': this.interactiveCatalog._currentPage.title,
                'css': {
                    'margin': '0px',
                    'text-align': 'center',
                    'font-size': '1.5em',
                    'color': this.visualTemplate.toolbarTintColor
                }
            }).appendTo(toolbarDiv);

            return toolbarDiv;
        }
    }, {
        key: 'createIndexDropdown',
        value: function createIndexDropdown(indexJson, visualTemplate) {

            var indexDropdown = $('<div>', {
                class: 'dropdown',
                css: {
                    'float': 'right'
                }
            });

            var mainIndexList = this.createIndexList(indexJson, visualTemplate, indexDropdown);

            var indexDropdownBtn = $('<button>', {
                class: 'btn btn-xs btn-default dropdown-toggle',
                css: {
                    'background-color': '' + visualTemplate.toolbarBackgroundColor,
                    'color': '' + visualTemplate.toolbarTintSecondaryColor,
                    'border': '0px'
                },
                type: 'button',
                'data-toggle': 'dropdown',
                click: function click(e) {
                    e.preventDefault();
                    $('ul.dropdown-menu').css('display', 'none');
                    mainIndexList.css('display', '');
                }
            }).appendTo(indexDropdown);

            $('<span>', {
                class: 'glyphicon glyphicon-th-list',
                css: {
                    'font-size': '20px',
                    'display': 'block'
                }
            }).appendTo(indexDropdownBtn);

            return indexDropdown;
        }
    }, {
        key: 'createIndexList',
        value: function createIndexList(indexJson, visualTemplate, menuDropdown) {
            var _this8 = this;

            var indexList = $('<ul>', {
                class: 'dropdown-menu dropdown-menu-right',
                css: {
                    'max-height': '400px',
                    'overflow': 'auto',
                    'background-color': '' + visualTemplate.toolbarBackgroundColor
                }
            }).appendTo(menuDropdown);

            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                var _loop = function _loop() {
                    var indexPage = _step6.value;

                    var imgPath = _this8.baseUrl + _this8.interactiveCatalog.catalogId + '/';
                    if (indexPage.horizontalIndexImage) imgPath += indexPage.horizontalIndexImage;else if (indexPage.verticalIndexImage) imgPath += indexPage.verticalIndexImage;

                    var width = 210;
                    var height = 80;

                    var imgMaxWidth = 80;
                    var imgMaxHeight = height;

                    var img = $('<img>', { 'src': _URLUtils2.default.getURL(imgPath) });

                    var imgWidthRatio = imgMaxWidth / img[0].width;
                    var imgHeightRatio = imgMaxHeight / img[0].height;
                    var imgScaleRatio = imgWidthRatio < imgHeightRatio ? imgWidthRatio : imgHeightRatio;

                    img[0].width *= imgScaleRatio;
                    img[0].height *= imgScaleRatio;

                    img.css({
                        'position': 'relative',
                        'left': '50%',
                        'top': '50%',
                        'margin-left': '-' + img[0].width / 2 + 'px',
                        'margin-top': '-' + img[0].height / 2 + 'px'
                    });

                    var html = $('<div>', {
                        'css': {
                            'width': '210px',
                            'height': '80px'
                        }
                    }).append($('<div>', {
                        'css': {
                            'float': 'left',
                            'width': imgMaxWidth + 'px',
                            'height': imgMaxHeight + 'px'
                        }
                    }).append(img)).append($('<div>', {
                        'css': {
                            'float': 'right',
                            'width': '120px',
                            'height': '100%'
                        }
                    }).append($('<h4>', {
                        'text': indexPage.title
                    })).append($('<p>', {
                        'text': indexPage.description
                    })));

                    var onClick = function onClick(e) {
                        e.preventDefault();
                        _this8.interactiveCatalog.goToPage(indexPage.numPage);
                        _this8.render();
                    };

                    var selected = _this8.interactiveCatalog._currentPageIndex == indexPage.numPage;

                    _this8.createIndexListElement(html, visualTemplate, onClick.bind(_this8), selected).appendTo(indexList);
                };

                for (var _iterator6 = indexJson[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    _loop();
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }

            return indexList;
        }
    }, {
        key: 'createIndexListElement',
        value: function createIndexListElement(html, visualTemplate, onClick) {
            var selected = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];

            var indexListElement = $('<li>', {});

            var bgColor = selected ? visualTemplate.toolbarTintColor : visualTemplate.toolbarBackgroundColor;
            var color = selected ? visualTemplate.toolbarBackgroundColor : visualTemplate.toolbarTintColor;
            var colorHover = selected ? visualTemplate.toolbarBackgroundColor : visualTemplate.toolbarTintSecondaryColor;

            $('<a>', {
                html: html,
                css: {
                    'background-color': bgColor,
                    'color': color,
                    'cursor': 'pointer'
                },
                click: onClick
            }).hover(function () {
                $(this).css("color", colorHover);
            }, function () {
                $(this).css("color", color);
            }).appendTo(indexListElement);

            return indexListElement;
        }
    }, {
        key: 'onBackButtonPressed',
        value: function onBackButtonPressed() {
            this.app.goBack();
        }
    }, {
        key: 'renderPageSlider',
        value: function renderPageSlider() {

            var pageSliderDiv = $('<div>', {
                'id': 'pageSlider',
                css: {
                    'display': this.interactiveCatalog._toolbarDisplay ? '' : 'none',
                    'margin': '0px',
                    'padding': '8px',
                    'width': '100%',
                    'height': '40px',
                    'position': 'absolute',
                    'left': '0',
                    'bottom': '0',
                    'text-align': 'center'
                }
            }).on('click', function (e) {
                e.stopPropagation();
            }).on('mousedown', function (e) {
                e.stopPropagation();
            });

            var pageSliderPreview = $('<div>', {
                'id': 'pageSlider',
                css: {
                    'display': 'none',
                    'margin': 'auto',
                    'position': 'absolute',
                    'left': '50%',
                    'bottom': '0%',
                    'transform': 'translate(-50%, -50%)'
                }
            }).appendTo(pageSliderDiv);

            var slider = $('<div>', {
                css: {
                    'width': '90%',
                    'margin': 'auto'
                }
            }).appendTo(pageSliderDiv);

            slider.slider({
                orientation: "horizontal",
                range: "min",
                max: this.interactiveCatalog.indexPages.length - 1,
                value: this.interactiveCatalog._currentPageIndex,
                slide: function (event, ui) {
                    var indexPage = this.interactiveCatalog.indexPages[ui.value];

                    var imgPath = this.baseUrl + this.interactiveCatalog.catalogId + '/';
                    if (indexPage.horizontalIndexImage) imgPath += indexPage.horizontalIndexImage;else if (indexPage.verticalIndexImage) imgPath += indexPage.verticalIndexImage;

                    var imgMaxSize = 120;

                    var img = $('<img>', { 'src': _URLUtils2.default.getURL(imgPath) });

                    var imgWidthRatio = imgMaxSize / img[0].width;
                    var imgHeightRatio = imgMaxSize / img[0].height;
                    var imgScaleRatio = imgWidthRatio < imgHeightRatio ? imgWidthRatio : imgHeightRatio;

                    img[0].width *= imgScaleRatio;
                    img[0].height *= imgScaleRatio;

                    img.css({
                        'position': 'relative',
                        'left': '50%',
                        'top': '50%',
                        'transform': 'translate(-50%, -50%)'
                    });

                    pageSliderPreview.empty();
                    pageSliderPreview.append(img);
                    pageSliderPreview.append($('<p>', { text: indexPage.title }));
                    pageSliderPreview.show();
                }.bind(this),
                change: function (event, ui) {
                    this.interactiveCatalog.goToPage(ui.value);
                    this.render();
                }.bind(this)
            });

            return pageSliderDiv;
        }
    }, {
        key: 'renderNavigationButtons',
        value: function renderNavigationButtons(interactiveCatalogDiv) {
            var _this9 = this;

            // Size of the buttons
            var navigationBtnWidth = this.scaleRatio * 80;
            var navigationBtnHeight = this.scaleRatio * 150;

            // Max size of the buttons
            navigationBtnWidth = navigationBtnWidth > 60 ? 60 : navigationBtnWidth;
            navigationBtnHeight = navigationBtnHeight > 112 ? 112 : navigationBtnHeight;

            // Is navigation enabled?
            var isNavigationEnabled = this.isNavigationEnabled();

            // Left navigation button
            if (isNavigationEnabled && this.canGoToPrevPage()) {
                $('<div>', {
                    'class': 'navigation-btn navigation-btn-left',
                    'css': {
                        'width': navigationBtnWidth + 'px',
                        'height': navigationBtnHeight + 'px'
                    }
                }).appendTo(interactiveCatalogDiv).on('click', function (e) {
                    e.stopPropagation();
                    if (_this9.goToPrevPage()) _this9.render();
                });
            }

            // Right navigation button
            if (isNavigationEnabled && this.canGoToNextPage()) {
                $('<div>', {
                    'class': 'navigation-btn navigation-btn-right',
                    'css': {
                        'width': navigationBtnWidth + 'px',
                        'height': navigationBtnHeight + 'px'
                    }
                }).appendTo(interactiveCatalogDiv).on('click', function (e) {
                    e.stopPropagation();
                    if (_this9.goToNextPage()) _this9.render();
                });
            }
        }
    }, {
        key: 'isNavigationEnabled',
        value: function isNavigationEnabled() {
            var format = this.getFormat(this.interactiveCatalog.navigationType, this.app.currentOrientation);
            var currentPage = this.interactiveCatalog._currentPage;

            // let pageHorizontalChangePageMode = (currentPage.horizontalChangePageMode != '') ? currentPage.horizontalChangePageMode : 'AUTOMATIC';
            // let pageVerticalChangePageMode = (currentPage.verticalChangePageMode != '') ? currentPage.verticalChangePageMode : 'AUTOMATIC';
            // let pageChangePageMode = (format == 'VERTICAL') ? pageVerticalChangePageMode : pageHorizontalChangePageMode;
            var pageChangePageMode = format == 'VERTICAL' ? currentPage.verticalChangePageMode : currentPage.horizontalChangePageMode;

            // return (pageChangePageMode == 'AUTOMATIC') ? this.libraryCatalog.changePageMode != 'DISABLED' : pageChangePageMode != 'DISABLED';
            return pageChangePageMode == '' ? this.libraryCatalog.changePageMode != 'DISABLED' : pageChangePageMode != 'DISABLED';
        }
    }]);

    return InteractiveCatalogView;
}(_View3.default);

exports.default = InteractiveCatalogView;

},{"../../core/View":23,"../../model/interactive/items/AnimatedImageItem":58,"../../model/interactive/items/AudioItem":59,"../../model/interactive/items/BrowserItem":60,"../../model/interactive/items/ButtonItem":61,"../../model/interactive/items/GalleryItem":62,"../../model/interactive/items/ImageButtonItem":63,"../../model/interactive/items/ImageItem":64,"../../model/interactive/items/MultiStateObjectItem":66,"../../model/interactive/items/PanoramaImageItem":67,"../../model/interactive/items/ScrollImageItem":68,"../../model/interactive/items/TouchAlphaImageItem":69,"../../model/interactive/items/TouchImageSequenceItem":70,"../../model/interactive/items/VideoItem":71,"../../model/interactive/items/WebZipItem":72,"../../util/URLUtils":86}],98:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _VideoView2 = require('./VideoView');

var _VideoView3 = _interopRequireDefault(_VideoView2);

var _URLUtils = require('../../util/URLUtils');

var _URLUtils2 = _interopRequireDefault(_URLUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LocalVideoView = function (_VideoView) {
    _inherits(LocalVideoView, _VideoView);

    function LocalVideoView() {
        _classCallCheck(this, LocalVideoView);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(LocalVideoView).apply(this, arguments));
    }

    _createClass(LocalVideoView, [{
        key: 'createView',
        value: function createView(model) {

            var baseUrl = model['baseUrl'];
            var libraryCatalog = model['libraryCatalog'];

            var libraryDOM = _get(Object.getPrototypeOf(LocalVideoView.prototype), 'createView', this).call(this, model);

            var videoContainer = $('<div>', {
                class: 'video-container'
            }).appendTo(libraryDOM);

            var video = $('<video>', {
                'controls': true,
                'autoplay': true
            }).appendTo(videoContainer);

            $('<source>', {
                src: _URLUtils2.default.getURL(baseUrl + libraryCatalog.path),
                type: 'video/mp4'
            }).appendTo(video);

            return libraryDOM;
        }
    }]);

    return LocalVideoView;
}(_VideoView3.default);

exports.default = LocalVideoView;

},{"../../util/URLUtils":86,"./VideoView":99}],99:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _View2 = require('../../core/View');

var _View3 = _interopRequireDefault(_View2);

var _SimpleToolbarView = require('../SimpleToolbarView');

var _SimpleToolbarView2 = _interopRequireDefault(_SimpleToolbarView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VideoView = function (_View) {
    _inherits(VideoView, _View);

    function VideoView() {
        _classCallCheck(this, VideoView);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(VideoView).apply(this, arguments));
    }

    _createClass(VideoView, [{
        key: 'createView',
        value: function createView(model) {

            var libraryCatalog = model['libraryCatalog'];
            var visualTemplate = model['visualTemplate'];

            var libraryDOM = $('<div>', {
                class: 'video-view',
                css: {
                    'background-color': 'black' //visualTemplate.listCatalogsBackgroundColor
                }
            });

            if (libraryCatalog.showCatalogMenu) {
                this.app.createView(new _SimpleToolbarView2.default(), {
                    'libraryCatalog': libraryCatalog,
                    'visualTemplate': visualTemplate
                }).appendTo(libraryDOM);
            }

            return libraryDOM;
        }
    }]);

    return VideoView;
}(_View3.default);

exports.default = VideoView;

},{"../../core/View":23,"../SimpleToolbarView":96}],100:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _VideoView2 = require('./VideoView');

var _VideoView3 = _interopRequireDefault(_VideoView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VimeoView = function (_VideoView) {
    _inherits(VimeoView, _VideoView);

    function VimeoView() {
        _classCallCheck(this, VimeoView);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(VimeoView).apply(this, arguments));
    }

    _createClass(VimeoView, [{
        key: 'createView',
        value: function createView(model) {

            var libraryCatalog = model['libraryCatalog'];

            var libraryDOM = _get(Object.getPrototypeOf(VimeoView.prototype), 'createView', this).call(this, model);

            var iframeContainer = $('<div>', {
                class: 'iframe-container'
            }).appendTo(libraryDOM);

            $('<iframe>', {
                'src': libraryCatalog.url
            }).appendTo(iframeContainer);

            return libraryDOM;
        }
    }]);

    return VimeoView;
}(_VideoView3.default);

exports.default = VimeoView;

},{"./VideoView":99}],101:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _VideoView2 = require('./VideoView');

var _VideoView3 = _interopRequireDefault(_VideoView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var YoutubeListView = function (_VideoView) {
    _inherits(YoutubeListView, _VideoView);

    function YoutubeListView() {
        _classCallCheck(this, YoutubeListView);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(YoutubeListView).apply(this, arguments));
    }

    _createClass(YoutubeListView, [{
        key: 'createView',
        value: function createView(model) {

            var libraryCatalog = model['libraryCatalog'];

            var libraryDOM = _get(Object.getPrototypeOf(YoutubeListView.prototype), 'createView', this).call(this, model);

            var iframeContainer = $('<div>', {
                class: 'iframe-container'
            }).appendTo(libraryDOM);

            $('<iframe>', {
                'src': libraryCatalog.url
            }).appendTo(iframeContainer);

            return libraryDOM;
        }
    }]);

    return YoutubeListView;
}(_VideoView3.default);

exports.default = YoutubeListView;

},{"./VideoView":99}],102:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _VideoView2 = require('./VideoView');

var _VideoView3 = _interopRequireDefault(_VideoView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var YoutubeListView = function (_VideoView) {
    _inherits(YoutubeListView, _VideoView);

    function YoutubeListView() {
        _classCallCheck(this, YoutubeListView);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(YoutubeListView).apply(this, arguments));
    }

    _createClass(YoutubeListView, [{
        key: 'createView',
        value: function createView(model) {

            var libraryCatalog = model['libraryCatalog'];

            var libraryDOM = _get(Object.getPrototypeOf(YoutubeListView.prototype), 'createView', this).call(this, model);

            var iframeContainer = $('<div>', {
                class: 'iframe-container'
            }).appendTo(libraryDOM);

            $('<iframe>', {
                'src': libraryCatalog.url
            }).appendTo(iframeContainer);

            return libraryDOM;
        }
    }]);

    return YoutubeListView;
}(_VideoView3.default);

exports.default = YoutubeListView;

},{"./VideoView":99}],103:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _View2 = require("../../core/View");

var _View3 = _interopRequireDefault(_View2);

var _SimpleToolbarView = require("../SimpleToolbarView");

var _SimpleToolbarView2 = _interopRequireDefault(_SimpleToolbarView);

var _URLUtils = require("../../util/URLUtils");

var _URLUtils2 = _interopRequireDefault(_URLUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GoogleMapsView = function (_View) {
    _inherits(GoogleMapsView, _View);

    function GoogleMapsView() {
        _classCallCheck(this, GoogleMapsView);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(GoogleMapsView).apply(this, arguments));
    }

    _createClass(GoogleMapsView, [{
        key: "createView",
        value: function createView(model) {

            var baseUrl = model['baseUrl'];
            var libraryCatalog = model['libraryCatalog'];
            var visualTemplate = model['visualTemplate'];

            var libraryDOM = $('<div>', {
                class: 'web-view',
                css: {
                    'background-color': 'white' //visualTemplate.listCatalogsBackgroundColor
                }
            });

            if (libraryCatalog.showCatalogMenu) {
                this.app.createView(new _SimpleToolbarView2.default(), {
                    'libraryCatalog': libraryCatalog,
                    'visualTemplate': visualTemplate
                }).appendTo(libraryDOM);
            }

            var iframeContainer = $('<div>', {
                class: 'iframe-container'
            }).appendTo(libraryDOM);

            $('<iframe>', {
                'src': _URLUtils2.default.getURL(baseUrl + libraryCatalog.path)
            }).appendTo(iframeContainer);

            return libraryDOM;
        }
    }]);

    return GoogleMapsView;
}(_View3.default);

exports.default = GoogleMapsView;

},{"../../core/View":23,"../../util/URLUtils":86,"../SimpleToolbarView":96}],104:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _View2 = require("../../core/View");

var _View3 = _interopRequireDefault(_View2);

var _SimpleToolbarView = require("../SimpleToolbarView");

var _SimpleToolbarView2 = _interopRequireDefault(_SimpleToolbarView);

var _URLUtils = require("../../util/URLUtils");

var _URLUtils2 = _interopRequireDefault(_URLUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HTMLView = function (_View) {
    _inherits(HTMLView, _View);

    function HTMLView() {
        _classCallCheck(this, HTMLView);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(HTMLView).apply(this, arguments));
    }

    _createClass(HTMLView, [{
        key: "createView",
        value: function createView(model) {

            var baseUrl = model['baseUrl'];
            var libraryCatalog = model['libraryCatalog'];
            var visualTemplate = model['visualTemplate'];

            var libraryDOM = $('<div>', {
                class: 'web-view',
                css: {
                    'background-color': 'white' //visualTemplate.listCatalogsBackgroundColor
                }
            });

            if (libraryCatalog.showCatalogMenu) {
                this.app.createView(new _SimpleToolbarView2.default(), {
                    'libraryCatalog': libraryCatalog,
                    'visualTemplate': visualTemplate
                }).appendTo(libraryDOM);
            }

            var iframeContainer = $('<div>', {
                class: 'iframe-container'
            }).appendTo(libraryDOM);

            $('<iframe>', {
                'src': _URLUtils2.default.getURL(baseUrl + libraryCatalog.path) + '/index.html'
            }).appendTo(iframeContainer);

            return libraryDOM;
        }
    }]);

    return HTMLView;
}(_View3.default);

exports.default = HTMLView;

},{"../../core/View":23,"../../util/URLUtils":86,"../SimpleToolbarView":96}],105:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _WebView2 = require('./WebView');

var _WebView3 = _interopRequireDefault(_WebView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TypeformView = function (_WebView) {
    _inherits(TypeformView, _WebView);

    function TypeformView() {
        _classCallCheck(this, TypeformView);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(TypeformView).apply(this, arguments));
    }

    return TypeformView;
}(_WebView3.default);

exports.default = TypeformView;

},{"./WebView":106}],106:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _View2 = require('../../core/View');

var _View3 = _interopRequireDefault(_View2);

var _SimpleToolbarView = require('../SimpleToolbarView');

var _SimpleToolbarView2 = _interopRequireDefault(_SimpleToolbarView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WebView = function (_View) {
    _inherits(WebView, _View);

    function WebView() {
        _classCallCheck(this, WebView);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(WebView).apply(this, arguments));
    }

    _createClass(WebView, [{
        key: 'createView',
        value: function createView(model) {

            var libraryCatalog = model['libraryCatalog'];
            var visualTemplate = model['visualTemplate'];

            var libraryDOM = $('<div>', {
                class: 'web-view',
                css: {
                    'background-color': 'white' //visualTemplate.listCatalogsBackgroundColor
                }
            });

            if (libraryCatalog.showCatalogMenu) {
                this.app.createView(new _SimpleToolbarView2.default(), {
                    'libraryCatalog': libraryCatalog,
                    'visualTemplate': visualTemplate
                }).appendTo(libraryDOM);
            }

            var iframeContainer = $('<div>', {
                class: 'iframe-container'
            }).appendTo(libraryDOM);

            $('<iframe>', {
                'src': libraryCatalog.url
            }).appendTo(iframeContainer);

            return libraryDOM;
        }
    }]);

    return WebView;
}(_View3.default);

exports.default = WebView;

},{"../../core/View":23,"../SimpleToolbarView":96}]},{},[17])

